import React, { Component, createRef } from "react";
import { withRouter } from "react-router-dom";
import PubMedSearchAskQuestionIndex from "../../components/PubMedSearch/PubMedSearchAskQuestionIndex";
import PubMedLeftSearchBoxIndex from "../../components/PubMedSearch/PubMedLeftSearchBoxIndex";
import PubMedRightGenAIAnswer from "../../components/PubMedSearch/PubMedRightGenAIAnswer";
import SearchFilter from "../FilterComponent/SearchFilter";
import PubMedNavigationMenu from "../../components/Navigation/PubMedNavigationMenu";
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import Footer from "../../components/footer/Footer";
import PubMedDocumentCard from "../../components/PubMedSearch/PubMedDocumentCard";
import PubMedGlobalFeatures from "../../components/PubMedSearch/PubMedGlobalFeatures";
import PubMedLeftUploadAbstracts from "../../components/PubMedSearch/PubMedLeftUploadAbstracts";
import PubMedRightAbstractsDataCard from "../../components/PubMedSearch/PubMedRightAbstractsDataCard"; import PubMedRightGenAIAbstractsAnswer from "../../components/PubMedSearch/PubMedRightGenAIAbstractsAnswer";
import { chatBotSvgImage, JJ_IMedical_icon } from "../../assets";
import moment from "moment";
import {
    imsLoader,
    filterIconWhite,
    collapseFilterWhite,
    expandFilterWhite,
    pubMedIcon,
    pubMedNIH,
    clearSearchMobView,
    popCancelBttn,
} from "../../assets";
import { processPubMedFilters } from "../FilterComponent/ProcessFilter";
import Services from "../../utils/services";

import {
    PubMedFiltersGenAI,
    LocationOrigin,
    IDColumnValues,
} from "../../utils/utilityServices";
import axios from "axios";
import FilterService from "../../services/FilterService";
import { Modal } from "react-bootstrap";
import queryString from "query-string";
import { Link } from "react-router-dom";
import PubMedPageItems from "../../components/Paginate/PubMedPageItems";
import Pagination from "../../components/Paginate/Pagination";
import FilterDisplay from "../../components/PubMedSearch/PubMedSearchFilterDisplay";
import { Tabs, Tab, TabPanel, TabList } from "react-web-tabs";
import AlertMessagePopUpModal from "../../components/PopUp/AlertMessagePopUpModal";
import { v4 as uuidv4 } from "uuid";
import { clone } from "underscore";
import Button from "../../components/Button";
import PubMedReviewListPopup from '../../components/PopUp/PubMedReviewListPopup';
import PubMedSaveSearchPopup from '../../components/PopUp/PubMedSaveSearchPopup';
import PubMedNotifyMePopUp from "../../components/PopUp/PubMedNotifyMe";
import trackingService from "../../services/trackingService";
import ApiServices from "../../utils/apiServices";
import PubmedExportPopUp from "../../components/PopUp/PubmedExportPopup";
import { Authentication } from "../../utils/authenticationUtilityServices";
import PubMedSearchResponsiveTabs from "../../components/PubMedSearch/PubMedSearchResponsiveTabs";
import { UserData } from "../../auth/Authorization";
import PubMedAlertTableQuery from "../../components/PubMedSearch/PubMedAlertTableQuery";

let _locationOrigin = LocationOrigin;
//_locationOrigin = "https://predev-ims.jnj.com";
let _timeoutTime = (1000 * (300));

class PubMedSearch extends Component {
    userid;
    userExists;
    globalCollapseAll = false;
    globalAbstractCollapseAll = false;
    documentsUrl = [];
    markedDocumentsUrl = [];
    preSelectedValues = { OVID: ["AB", "TI"], Medline: ["AB"], Other: [] };
    resultListRef = createRef([])

    constructor(props) {
        super(props);
        var guid = uuidv4();
        var threadGuid = uuidv4();
        this.resultListRef.current = []
        this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
            sessionID: guid,
            username: "",
            userExists: false,
            searchKeyword: "",
            spinnerMessage: "",
            isLoaded: false,
            isProcessing: true,
            selectedFinalAnsweringDocSize: '5',
            response: [],
            allFilters: {},
            documents: [],
            documentCount: 0,
            appliedFilters: [], //Filters that are applied for while search is happening
            selectedFilters: [],
            itemsPerPage: "25",
            itemsPerPageHighlyResponsive: "25",
            itemsPerPageResponsive: "25",
            currentPage: "1",
            filters: {},
            f1: "",
            fval1: "",
            fieldedSearchArr: {},
            selectedParentFilterArr: [],
            sortByValue: "Relevance",
            sortBy: "",
            sortField: "",
            appliedFiltersForOnlyiMS: [],
            filterYears: [],
            fromYear: "",
            toYear: "",
            error: "",
            errorHTML: "",
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            isRenderLandingPage: false,
            globalCollapseAll: false,
            globalSelectAll: false,
            collapsedSearchIDs: [],
            showMajorTopicSearch: false,
            majorTopicSearchState: true,
            selectedResults: [],
            citationSelectStatus: [],
            showFilters: true,
            answers: {},
            selectedTab: '0',
            selectedTabResponsive: '7',
            selectedTabResUploadAbstract: '9',
            selectTabResOtherUploadAbstract: '11',
            selectTabResSaveSearch: '13',
            pubMedXSearchId: "",
            mathRandom: Math.random(),
            summaries: [],
            relevent: [],
            get_final_answering: false,
            /**relevant list */
            reviewListSearchKeyword: "",
            isReleventSelected: true,
            selectedReviewListId: "",
            reviewListResponse: [],
            reviewListAnswers: {},
            selectedReviewListResults: [],
            citationReviewListSelectStatus: [],
            reviewListCollapsedSearchIDs: [],
            globalReviewListCollapseAll: false,
            globalReviewListSelectAll: false,
            currentReviewListPage: "1",
            documentReviewListCount: 0,
            itemsPerReviewListPage: "25",
            currentReviewListId: '',
            showReviewListFilters: true,
            reviewListFilters: {},
            allReviewListFilters: {},
            appliedReviewListFilters: [],
            selectedReviewListFilters: [],
            selectedParentReviewListFilterArr: [],
            reviewListsortBy: "",
            reviewListsortField: "",
            reviewListSortByValue: "Relevance",
            reviewListFromYear: '',
            reviewListToYear: '',
            currentReviewListId: '',
            isReviewListReleventSelected: true,
            reviewList_get_final_answering: true,
            isAnyChangeAfterReviewListResult: false,
            /**endof region relevant list */

            //#region AbstractSearch
            abstractsResetInfo: null,
            abstractsSearchKeyword: "",
            itemsPerAbstractPage: "25",
            currentAbstractPage: "1",
            documentAbstractCount: 0,
            attachedFiles: [],
            uploadFilePlaceHolder: "",
            uploadFilePlaceHolderTitle: "",
            updateAnyFile: false,
            newAttachedFiles: [],
            useTemplate: "OVID",
            abstractsResponse: [],
            abstractsAnswer: [],
            globalAbstractCollapseAll: false,
            globalAbstractSelectAll: false,
            abstract_column_names: this.preSelectedValues["OVID"],
            abstractsSelected: [],
            showViewabstractDetailPop: false,
            viewAbstractsDetail: null,
            showReviewListPop: false,
            isRelevantAbstract: "False",
            abstractSelectStatus: [],
            abstractCollapsedSearchIDs: [],
            selectedAbstractResults: [],
            //#endregion

            //#region  saveSearch
            saveSearchSearchKeyword: "",
            selectedSaveSearchPubMedXSearchId: "",
            showSaveSearchPop: false,
            globalSaveSearchCollapseAll: false,
            globalSaveSearchSelectAll: false,
            saveSearchCollapsedSearchIDs: [],
            selectedSaveSearchResults: [],
            saveSearchSelectStatus: [],
            saveSearchResponse: [],
            saveSearchAnswer: [],
            saveSearchSelected: [],
            itemsPerSaveSearchPage: "25",
            itemsPerSaveSearchPageHighlyResponsive: "25",
            itemsPerSaveSearchPageResponsive: "25",
            currentSaveSearchPage: "1",
            documentSaveSearchCount: 0,
            sortSaveSearchByValue: "Relevance",
            sortSaveSearchBy: "",
            sortSaveSearchField: "",
            fromSaveSearchYear: "",
            toSaveSearchYear: "",
            appliedSaveSearchFilters: [], //Filters that are applied for while search is happening
            selectedSaveSearchFilters: [],
            allSaveSearchFilters: {},
            saveSearchFilters: {},
            selectedParentSaveSearchFilterArr: [],
            isSaveSearchReleventSelected: true,
            saveSearch_get_final_answering: true,
            selectedSaveSearchSearchKeyword: "",
            selectedFromSaveSearchYear: "",
            selectedToSaveSearchYear: "",
            selectedSaveSearchFilterString: "",
            isAnyChangeAfterSaveSearchResult: false,
            selectedSavesearchId: "",
            //#endregion saveSearch


            //#region  Ovid Abstract
            globalOvidAbstractCollapseAll: false,
            globalOvidAbstractSelectAll: false,
            ovidAbstractCollapsedSearchIDs: [],
            selectedOvidAbstractResults: [],
            ovidAbstractSelectStatus: [],
            ovidAbstractResponse: [],
            ovidAbstractAnswer: [],
            ovidAbstractSelected: [],
            itemsPerOvidAbstractPage: "50",
            itemsPerOvidAbstractPageHighlyResponsive: "50",
            itemsPerOvidAbstractPageResponsive: "50",
            currentOvidAbstractPage: "1",
            documentOvidAbstractCount: 0,
            sortOvidAbstractByValue: "Relevance",
            sortOvidAbstractBy: "",
            sortOvidAbstractField: "",
            fromOvidAbstractYear: "",
            toOvidAbstractYear: "",
            appliedOvidAbstractFilters: [], //Filters that are applied for while search is happening
            selectedOvidAbstractFilters: [],
            allOvidAbstractFilters: {},
            ovidAbstractFilters: {},
            selectedParentOvidAbstractFilterArr: [],
            isOvidAbstractReleventSelected: true,
            has_evaluate_been_called: false,
            isAnyChangeAfterAbstractResult: false,
            //#endregion Ovid Abstract
            titleNameReviewList: '',
            titleSaveSearch: "",

            //personal alert
            showPersonalAlerts: false,
            openManageInPubmedAlert: false,
            showMyAlert: false,
            selectedAlert: {},
            alertResponses: [],
            itemsPerAlertPage: "25",
            currentAlertPage: "1",
            sortAlertByValue: "Relevance",
            sortAlertBy: "",
            sortAlertField: "",
            fromAlertYear: "",
            toAlertYear: "",
            documentAlertCount: 0,
            isAlertReleventSelected: true,
            globalAlertCollapseAll: false,
            globalAlertSelectAll: false,
            alertCollapsedSearchIDs: [],
            selectedAlertResults: [],
            alertSelectStatus: [],
            alertSearchKeyword: "",
            isAnyChangeAfterAlertResult: false,
            itemsPerAlertPageHighlyResponsive: '25',
            itemsPerAlertPageResponsive: "25",
            fromGlobalTab: false,

            // export
            showExportPopup: false,
            // citation
            recievedRef: false,
            allRefs: [],

            //alert
            alertsFrequencySelected: '7'
        };
        this.getAllReviewListData = this.getAllReviewListData.bind(this);
    }
    componentDidMount() {
        try {
            document.title = "PubMed Search";
            this.userid = JSON.parse(localStorage.getItem("username"));
            this.wwid = JSON.parse(localStorage.getItem("wwid"));
            this.userExists = localStorage.getItem("userExists");
            var itemsPerPage = localStorage.getItem("ItemsPerPage");
            var activePage = localStorage.getItem("ActivePage");
            let service = new Services();
            service.logService(
                `PubMedSearch page successfully mounted for ${this.userid.toLowerCase()}`,
                "info"
            );
            if (this.userExists) {
                const currentDate = new Date();
                let currentYear = currentDate.getFullYear();
                this.setState({
                    userExists: this.userExists,
                    fromYear: currentYear - 5,
                    toYear: currentYear,
                    fromSaveSearchYear: currentYear - 5,
                    toSaveSearchYear: currentYear,
                    reviewListFromYear: currentYear - 5,
                    reviewListToYear: currentYear,
                    fromOvidAbstractYear: currentYear - 5,
                    toOvidAbstractYear: currentYear
                });

                /*To detect if user is coming from View Selected Page with some selected data*/
                if (sessionStorage.getItem("selectedResultsDetails") === null) {
                    this.setState({
                        globalSelectAll: false,
                    });
                } else {
                    if (
                        JSON.parse(sessionStorage.getItem("selectedResultsDetails"))
                            .length > 0
                    ) {
                        this.setState({
                            globalSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalSelectAll: false,
                        });
                    }
                }
                /*To detect if user is coming from View Selected Page with some selected data*/
                if (sessionStorage.getItem("selectedAbstractResultsDetails") === null) {
                    this.setState({
                        globalAbstractSelectAll: false,
                    });
                } else {
                    if (
                        JSON.parse(sessionStorage.getItem("selectedAbstractResultsDetails"))
                            .length > 0
                    ) {
                        this.setState({
                            globalAbstractSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalAbstractSelectAll: false,
                        });
                    }
                }
                if (itemsPerPage !== null) {
                    this.setState({
                        itemsPerPage: itemsPerPage,
                    });
                }
                if (activePage !== null) {
                    this.setState({
                        currentPage: activePage,
                    });
                }
                if (this.props.location.search === "") {
                    this.props.history.replace("/PubMedSearch?query=&filters=");
                }
                if (this.props.location.search) {
                    const queryParams = new URLSearchParams(this.props.location.search);
                    const filters = queryParams.get("filters");
                    const query = queryParams.get("query");
                    let _replaceURL = `${this.props.location.pathname}${this.props.location.search}`;

                    if (!query && query !== "") {
                        _replaceURL += `&query=`;
                    }
                    if (!filters && filters !== "") {
                        _replaceURL += `&filters=`;
                    }
                    this.props.history.replace(_replaceURL);
                }
                const queryParams = new URLSearchParams(this.props.location.search);
                const params = queryParams.get("query");
                const filters = queryParams.get("filters");

                if (filters) {
                    let bifurcateFilters = this.bifurcateAppliedFilters(
                        filters.split(";")
                    );
                    this.setState(
                        {
                            //appliedFilters: filters.split(';')
                            appliedFilters: bifurcateFilters.appliedFiltersForBoth,
                            // appliedFiltersForOnlyiMS:
                            //     bifurcateFilters.appliedFiltersForOnlyiMS,
                            /* f1:f1,
                                                                            fval1:fval1 */
                        },
                        async () => {
                            this.setState({
                                selectedParentFilterArr: this.generateSelectParentArray(
                                    this.state.appliedFilters
                                ),
                            });
                            if (params) {
                                await this.runPubmedSearch(params);
                                await this.indexTrackingData(params);
                                await this.indexTabTrackingData(params);
                            }
                        }
                    );
                } else {
                    this.setState(
                        {
                            appliedFilters: [],
                            /* f1:f1,
                                                                            fval1:fval1 */
                        },
                        async () => {
                            this.setState({
                                selectedParentFilterArr: this.generateSelectParentArray(
                                    this.state.appliedFilters
                                ),
                            });
                            if (params) {
                                await this.runPubmedSearch(params);
                                await this.indexTrackingData(params);
                                await this.indexTabTrackingData(params)
                            }
                        }
                    );
                }
                if (filters) {
                    this.setState({
                        selectedFilters: filters.split(";"),
                    });
                } else {
                    this.setState({
                        selectedFilters: [],
                    });
                }
                this.setState({
                    searchKeyword: params ? params : "",
                    // isRenderLandingPage: params ? false : true,
                    isLoaded: params ? false : true,
                    isProcessing: params ? true : false,
                });

                window.addEventListener("resize", this.updateDimensions);
            } else {
                console.log("Access Denied");
                this.props.history.push("/");
            }
            // VIEW SELECTED LOGIC
            let data = this.state.selectedResults;
            let citationSelectStatus = this.state.citationSelectStatus;
            let markedUrl = this.markedDocumentsUrl;
            var sessiondata = sessionStorage.getItem("selectedResultsDetails");
            // for (let index = 0; index < this.state.documentCount; index++) {
            if (localStorage.getItem("selectedResults") === null) {
                if (window.location.search !== this.state.prevUrl) {
                    data = [];
                    citationSelectStatus = [];
                    markedUrl = [];
                }
                /* else {
                                                citationSelectStatus.push(false)
                                            } */
            }
            if (
                localStorage.getItem("selectedResults") !== null &&
                sessiondata !== null
            ) {
                if (this.props.location.search !== this.state.prevUrl) {
                    data = [];
                    citationSelectStatus = [];
                    localStorage.removeItem("selectedResults");
                    localStorage.removeItem("ItemsPerPage");
                    localStorage.removeItem("ActivePage");
                    localStorage.removeItem("markedResultsUrl");
                    sessionStorage.clear();
                } else {
                    localStorage
                        .getItem("selectedResults")
                        .split(",")
                        .map((x, key) => {
                            let i = parseInt(x);
                            citationSelectStatus[i - 1] = true;
                            if (citationSelectStatus[i - 1]) {
                                data = JSON.parse(sessiondata);
                                markedUrl = JSON.parse(
                                    localStorage.getItem("markedResultsUrl")
                                );
                                // data.push(JSON.parse(sessiondata))
                                // data.push({
                                //     detail: this.state.response[i - 1]._source,
                                //     itemTeaser: this.state.response[i - 1].highlight.body,
                                //     index: i
                                // })
                            } else {
                                data.splice(i - 1, 1);
                                markedUrl.splice(i - 1, 1);
                            }
                        });
                }
            }
            this.markedDocumentsUrl = markedUrl;
            this.setState({
                citationSelectStatus: citationSelectStatus,
                selectedResults: data,
            });
        } catch (error) { }
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions = () => {
        try {
            this.setState({ width: window.innerWidth, height: window.innerHeight });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    indexTabTrackingData = (_searchKeyword) => {

        let { useTemplate } = this.state;
        let _eventaction = "PubMedGenAI2.0 Search in PubMed Tab";
        const filters = this.generateArrayString(this.state.appliedFilters);
        _eventaction = this.state.selectedTabResponsive === '7' ? "PubMedGenAI2.0 Search in PubMed Highly Responsive Tab" : "PubMedGenAI2.0 Search in PubMed Responsive Tab";
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            _eventaction,
            "",
            this.buildUrl(_searchKeyword, this.state.appliedFilters, false),
            _searchKeyword,
            filters,
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            this.props.csPath !== null ? this.props.csPath : "",
            this.props.csproduct !== null ? this.props.csproduct : ""
        );
    }
    indexTrackingData = (_searchKeyword) => {

        let { useTemplate } = this.state;
        let _eventaction = "PubMedGenAI2.0 Search in PubMed Tab";
        const filters = this.generateArrayString(this.state.appliedFilters);
        if (this.state.selectedTab === '1') {
            _eventaction = `PubMedGenAI2.0 Search with ${useTemplate} Template in Upload Abstracts Tab`;
        }
        else if (this.state.selectedTab === '2') {
            _eventaction = "PubMedGenAI2.0 Search in Review List Tab";
        }
        else if (this.state.selectedTab === '3') {
            _eventaction = "PubMedGenAI2.0 Search in Saved Searches Tab";
        }
        //let str = this.createSearchCriteriaString();
        //str = str.replace(/(")/g, '\\"');
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            _eventaction,
            "",
            this.buildUrl(_searchKeyword, this.state.appliedFilters, false),
            _searchKeyword,
            filters,
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            this.props.csPath !== null ? this.props.csPath : "",
            this.props.csproduct !== null ? this.props.csproduct : ""
        );
    }
    handleAbstract = (abstractColumn) => {
        this.setState({
            abstract_column_names: abstractColumn,
        });
    };
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true,
        });
    };
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true,
        });
    };
    closeAlertMessage = () => {
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false,
        });
    };
    handleChangeInSearch = async (query) => {
        this.setState(
            {
                searchKeyword: query,
                currentPage: "1",
                // isRenderLandingPage: query ? false : true,
            },
            async () => {
                if (this.state.error !== "") {
                    this.setState({ error: "" });
                }
                await this.runPubmedSearch(query);
                // await this.indexTrackingData(query);
                await this.indexTabTrackingData(query);
                // this.runSearchFromQueryParams(
                //     this.state.allFilters,
                //     this.state.appliedFilters,
                //     query
                // );
            }
        );
    };

    async runPubmedSearch(querytext) {
        try {
            this.setState({
                isProcessing: true,
                globalCollapseAll: false,
                globalSelectAll: false,
                collapsedSearchIDs: [],
                isReleventSelected: true,
            });
            let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
            let filterStr = this.generateArrayString(this.state.appliedFilters);
            var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}search`;
            if (window.location.origin === "https://predev-ims.jnj.com") {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}search`;
            }
            url += `?user_id=${username.split("@")[0]}`;
            let data = {
                query: querytext,
                size: parseInt(this.state.itemsPerPage),
                fromYear: this.state.fromYear,
                toYear: this.state.toYear,
                sortBy: this.state.sortBy,
                sortField: this.state.sortField,
                filters: filterStr,
            };
            const _headers = {
                "Content-Type": "application/json",
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let config = {
                method: "POST",
                url: url,
                headers: _headers,
                timeout: _timeoutTime,
            };
            config.data = data;
            await axios(config)
                .then((response) => {
                    let _pubMedXSearchId = response.headers["x-search-id"];
                    var processed = processPubMedFilters(response.data.body);
                    const filterService = new FilterService();
                    const [filters] = filterService.expandFilterSet(
                        processed,
                        this.state.appliedFilters
                    );
                    let selectedFiltered = this.state.appliedFilters.concat(filters);
                    response.data.body.hits.hits.map((hitItem, hitIndex) => {
                        hitItem._source.rli_id = uuidv4();
                        hitItem._source.relevant = hitItem._source.relevant
                            ? hitItem._source.relevant
                            : "False";
                        hitItem._source.summary = hitItem._source.summary
                            ? hitItem._source.summary
                            : "";
                        hitItem._source.resultID = hitItem._id;
                    });
                    this.setState(
                        {
                            documentCount: response.data.body.hits.total.value,
                            response: response.data.body.hits.hits,
                            filters: processed,
                            isProcessing: false,
                            isLoaded: true,
                            collapseFilter: false,
                            // selectedFilters: selectedFiltered,
                            answers: response.data.answer,
                            pubMedXSearchId: _pubMedXSearchId,
                            selectedFinalAnsweringDocSize: '5'
                        },
                        () => {
                            if (
                                this.state.globalSelectAll &&
                                (this.state.citationSelectStatus.length.toString() ===
                                    this.state.itemsPerPage ||
                                    this.state.citationSelectStatus.length ===
                                    this.state.documentCount)
                            ) {
                                this.setState({ globalSelectAll: true });
                            } else {
                                this.setState({ globalSelectAll: false });
                            }
                            this.handleAllFilters(
                                this.state.filters,
                                this.state.appliedFilters,
                                this.state.selectedFilters,
                                this.state.response,
                                this.state.documentCount,
                                querytext
                            );
                        }
                    );
                    // VIEW SELECTED LOGIC
                    let data = this.state.selectedResults;
                    let citationSelectStatus = this.state.citationSelectStatus;
                    let markedUrl = this.markedDocumentsUrl;
                    var sessiondata = sessionStorage.getItem("selectedResultsDetails");
                    // for (let index = 0; index < this.state.documentCount; index++) {
                    if (localStorage.getItem("selectedResults") === null) {
                        if (window.location.search !== this.state.prevUrl) {
                            data = [];
                            citationSelectStatus = [];
                            markedUrl = [];
                        }
                        /* else {
                                                              citationSelectStatus.push(false)
                                                          } */
                    }
                    if (
                        localStorage.getItem("selectedResults") !== null &&
                        sessiondata !== null
                    ) {
                        if (
                            decodeURI(this.props.location.search) !==
                            decodeURI(this.state.prevUrl)
                        ) {
                            data = [];
                            citationSelectStatus = [];
                            localStorage.removeItem("selectedResults");
                            localStorage.removeItem("ItemsPerPage");
                            localStorage.removeItem("ActivePage");
                            localStorage.removeItem("markedResultsUrl");
                            sessionStorage.clear();
                        }
                    }
                    this.markedDocumentsUrl = markedUrl;
                    this.setState({
                        citationSelectStatus: citationSelectStatus,
                        selectedResults: data,
                    });
                })
                .catch((error) => {
                    this.setState({ error: error, errorExpand: true });
                })
                .finally(() => {
                    this.setState({ isProcessing: false, isLoaded: true });
                });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    }
    async runPubmedSearchTab(querytext, filterSelected) {
        try {
            let { isReleventSelected } = this.state;
            let filterStr = this.generateArrayString(filterSelected);
            var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}search/tab`;
            if (window.location.origin === "https://predev-ims.jnj.com") {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}search/tab`;
            }
            let get_final_answering = this.state.get_final_answering
            const _headers = {
                "Content-Type": "application/json",
                "x-search-id": this.state.pubMedXSearchId,
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let config = {
                method: "POST",
                url: url,
                headers: _headers,
                timeout: _timeoutTime,
            };
            config.data = {
                query: querytext,
                filters: filterStr,
                from_:
                    this.state.currentPage * this.state.itemsPerPage -
                    this.state.itemsPerPage,
                size: parseInt(this.state.itemsPerPage),
                sortBy: this.state.sortBy,
                sortField: this.state.sortField,
                tab: isReleventSelected ? "relevant" : "non relevant",
                fromYear: this.state.fromYear,
                toYear: this.state.toYear,
                get_final_answering,
                final_answering_doc_size: parseInt(this.state.selectedFinalAnsweringDocSize)
            };
            // this.setState({ ...this.state, isLoaded: false });
            await axios(config)
                .then((response) => {
                    var processed = processPubMedFilters(response.data.body);
                    const filterService = new FilterService();
                    const [filters] = filterService.expandFilterSet(
                        processed,
                        this.state.appliedFilters
                    );

                    let selectedFiltered = this.state.appliedFilters.concat(filters);
                    response.data.body.hits.hits.map((hitItem, hitIndex) => {

                        hitItem._source.rli_id = uuidv4();
                        hitItem._source.relevant = hitItem._source.relevant
                            ? hitItem._source.relevant
                            : "False";
                        hitItem._source.summary = hitItem._source.summary
                            ? hitItem._source.summary
                            : "";
                        hitItem._source.resultID = hitItem._id;
                    });
                    this.setState(
                        {
                            pubMedXSearchId: response.headers["x-search-id"],
                            documentCount: response.data.body.hits.total.value,
                            response: response.data.body.hits.hits,
                            filters: processed,
                            isProcessing: false,
                            isLoaded: true,
                            collapseFilter: false,
                            selectedFilters: selectedFiltered,
                            answers: get_final_answering ? response.data.answer : this.state.answers,
                            get_final_answering: false,
                        },
                        () => {
                            if (
                                this.state.globalSelectAll &&
                                (this.state.citationSelectStatus.length.toString() ===
                                    this.state.itemsPerPage ||
                                    this.state.citationSelectStatus.length ===
                                    this.state.documentCount)
                            ) {
                                this.setState({ globalSelectAll: true });
                            } else {
                                this.setState({ globalSelectAll: false });
                            }
                            this.handleAllFilters(
                                this.state.filters,
                                this.state.appliedFilters,
                                this.state.selectedFilters,
                                this.state.response,
                                this.state.documentCount,
                                this.state.searchKeyword
                            );
                        }
                    );
                    // VIEW SELECTED LOGIC
                    let data = this.state.selectedResults;
                    let citationSelectStatus = this.state.citationSelectStatus;
                    let markedUrl = this.markedDocumentsUrl;
                    var sessiondata = sessionStorage.getItem("selectedResultsDetails");
                    // for (let index = 0; index < this.state.documentCount; index++) {
                    if (localStorage.getItem("selectedResults") === null) {
                        if (window.location.search !== this.state.prevUrl) {
                            data = [];
                            citationSelectStatus = [];
                            markedUrl = [];
                        }
                        /* else {
                                                                citationSelectStatus.push(false)
                                                            } */
                    }
                    if (
                        localStorage.getItem("selectedResults") !== null &&
                        sessiondata !== null
                    ) {
                        if (
                            decodeURI(this.props.location.search) !==
                            decodeURI(this.state.prevUrl)
                        ) {
                            data = [];
                            citationSelectStatus = [];
                            localStorage.removeItem("selectedResults");
                            localStorage.removeItem("ItemsPerPage");
                            localStorage.removeItem("ActivePage");
                            localStorage.removeItem("markedResultsUrl");
                            sessionStorage.clear();
                        }
                    }
                    this.markedDocumentsUrl = markedUrl;
                    this.setState({
                        citationSelectStatus: citationSelectStatus,
                        selectedResults: data,
                        isLoaded: true,
                    });
                })
                .catch((err) => {
                    this.setState({ error: err });
                    console.log({ err })

                })
                .finally(() => {
                    this.setState({ isProcessing: false, isLoaded: true });
                });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }

    }
    async runPubmedSaveSearch(querytext) {
        try {
            this.setState({
                isProcessing: true,
                globalSaveSearchCollapseAll: false,
                globalSaveSearchSelectAll: false,
                saveSearchCollapsedSearchIDs: [],
                // isLoaded: false
            });
            let { appliedSaveSearchFilters, selectedSaveSearchPubMedXSearchId, isSaveSearchReleventSelected } = this.state;
            let filterStr = this.generateArrayString(appliedSaveSearchFilters);
            let username = JSON.parse(localStorage.getItem("username")).toLowerCase();

            var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}search/viewsaved`;
            if (window.location.origin === "https://predev-ims.jnj.com") {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}search/viewsaved`;
            }
            const _headers = {
                "Content-Type": "application/json",
                "x-search-id": selectedSaveSearchPubMedXSearchId,
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let config = {
                method: "POST",
                url: url,
                headers: _headers,
                timeout: _timeoutTime,
            };
            config.data = {
                query: querytext,
                filters: filterStr,
                from_:
                    this.state.currentSaveSearchPage * this.state.itemsPerSaveSearchPage -
                    this.state.itemsPerSaveSearchPage,
                size: parseInt(this.state.itemsPerSaveSearchPage),
                sortBy: this.state.sortSaveSearchBy,
                sortField: this.state.sortSaveSearchField,
                fromYear: this.state.fromSaveSearchYear,
                toYear: this.state.toSaveSearchYear,
                result_ids: [],
                tab: isSaveSearchReleventSelected ? "relevant" : "non relevant",
                get_final_answering: this.state.saveSearch_get_final_answering,
            };

            axios(config)
                .then((response) => {
                    var processed = processPubMedFilters(response.data.body);
                    const filterService = new FilterService();
                    const [filters] = filterService.expandFilterSet(
                        processed,
                        this.state.appliedSaveSearchFilters
                    );
                    let selectedFiltered = this.state.appliedSaveSearchFilters.concat(filters);
                    response.data.body.hits.hits.map((hitItem, hitIndex) => {
                        if (hitItem._source.rli_id) {
                            hitItem._source.old_rli_id = clone(hitItem._source.rli_id);
                        } else {
                            hitItem._source.old_rli_id = "";
                        }
                        hitItem._source.rli_id = uuidv4();
                        hitItem._source.relevant = hitItem._source.relevant
                            ? hitItem._source.relevant
                            : "False";
                        hitItem._source.summary = hitItem._source.summary
                            ? hitItem._source.summary
                            : "";
                    });
                    this.setState(
                        {
                            documentSaveSearchCount: response.data.body.hits.total.value,
                            saveSearchResponse: response.data.body.hits.hits,
                            saveSearchFilters: processed,
                            selectedSaveSearchFilters: selectedFiltered,
                            isProcessing: false,
                            isLoaded: true,
                            collapseFilter: false,
                            saveSearchAnswer: this.state.saveSearch_get_final_answering ? response.data.answer : this.state.saveSearchAnswer,
                            saveSearch_get_final_answering: false,
                        },
                        () => {
                            if (
                                this.state.globalSaveSearchSelectAll &&
                                (this.state.saveSearchSelectStatus.length.toString() ===
                                    this.state.itemsPerSaveSearchPage ||
                                    this.state.saveSearchSelectStatus.length ===
                                    this.state.documentSaveSearchCount)
                            ) {
                                this.setState({ globalSaveSearchSelectAll: true });
                            } else {
                                this.setState({ globalSaveSearchSelectAll: false });
                            }
                            this.handleAllSaveSearchFilters(
                                this.state.saveSearchFilters,
                                this.state.appliedSaveSearchFilters,
                                this.state.selectedSaveSearchFilters,
                                this.state.saveSearchResponse,
                                this.state.documentSaveSearchCount,
                                this.state.saveSearchSearchKeyword
                            );
                        }
                    );

                })
                .catch((error) => {
                    this.setState({ error: error, errorExpand: true });
                })
                .finally(() => {
                    this.setState({ isProcessing: false, isLoaded: true });
                });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    }
    runRefreshSaveSearchPubmedSearch() {
        try {
            let { selectedFromSaveSearchYear, selectedToSaveSearchYear, selectedSaveSearchFilterString } = this.state;
            let _appliedFilters = [];
            if (selectedSaveSearchFilterString) {
                let bifurcateFilters = this.bifurcateAppliedFilters(
                    selectedSaveSearchFilterString.split(";")
                );
                _appliedFilters = bifurcateFilters.appliedFiltersForBoth;

            } else {
                _appliedFilters = [];
            }
            let _selectedParentSaveSearchFilterArr = this.generateSelectParentArray(_appliedFilters);
            this.setState({
                isProcessing: true,
                globalSaveSearchCollapseAll: false,
                globalSaveSearchSelectAll: false,
                saveSearchCollapsedSearchIDs: [],
                isSaveSearchReleventSelected: true,
                selectedSaveSearchResults: [],
                saveSearchSelectStatus: [],
                itemsPerSaveSearchPage: "25",
                itemsPerSaveSearchPageHighlyResponsive: "25",
                itemsPerSaveSearchPageResponsive: "25",
                currentSaveSearchPage: "1",
                documentSaveSearchCount: 0,
                sortSaveSearchByValue: "Relevance",
                sortSaveSearchBy: "",
                sortSaveSearchField: "",
                appliedSaveSearchFilters: _appliedFilters,
                fromSaveSearchYear: clone(selectedFromSaveSearchYear),
                toSaveSearchYear: clone(selectedToSaveSearchYear),
                selectedParentSaveSearchFilterArr: _selectedParentSaveSearchFilterArr,

            }, async () => {
                let { saveSearchSearchKeyword, selectedSaveSearchPubMedXSearchId, selectedSavesearchId } = this.state;
                let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
                let filterStr = this.generateArrayString(this.state.appliedSaveSearchFilters);
                var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}search`;
                if (window.location.origin === "https://predev-ims.jnj.com") {
                    url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}search`;
                }
                url += `?user_id=${username.split("@")[0]}`;
                let data = {
                    query: saveSearchSearchKeyword,
                    size: parseInt(this.state.itemsPerReviewListPage),
                    fromYear: this.state.fromSaveSearchYear,
                    toYear: this.state.toSaveSearchYear,
                    sortBy: this.state.sortSaveSearchBy,
                    sortField: this.state.sortSaveSearchField,
                    filters: filterStr,
                };
                const _headers = {
                    "Content-Type": "application/json",
                }
                if (await Authentication.isAccessTokenAvailable()) {
                    const token = await Authentication.getAccessToken();
                    _headers.Authorization = `Bearer ${token}`;
                }
                let config = {
                    method: "POST",
                    url: url,
                    headers: _headers,
                    timeout: _timeoutTime,
                };
                config.data = data;
                axios(config)
                    .then((response) => {
                        let _pubMedXSearchId = response.headers["x-search-id"];
                        var processed = processPubMedFilters(response.data.body);
                        const filterService = new FilterService();
                        const [filters] = filterService.expandFilterSet(
                            processed,
                            this.state.appliedSaveSearchFilters
                        );
                        let selectedFiltered = this.state.appliedSaveSearchFilters.concat(filters);
                        response.data.body.hits.hits.map((hitItem, hitIndex) => {
                            hitItem._source.rli_id = uuidv4();
                            hitItem._source.relevant = hitItem._source.relevant
                                ? hitItem._source.relevant
                                : "False";
                            hitItem._source.summary = hitItem._source.summary
                                ? hitItem._source.summary
                                : "";
                            hitItem._source.resultID = hitItem._id;
                        });
                        this.setState(
                            {
                                documentSaveSearchCount: response.data.body.hits.total.value,
                                saveSearchResponse: response.data.body.hits.hits,
                                saveSearchFilters: processed,
                                isProcessing: false,
                                isLoaded: true,
                                collapseFilter: false,
                                selectedSaveSearchFilters: selectedFiltered,
                                saveSearchAnswer: response.data.answer,
                                saveSearch_get_final_answering: false,
                                isAnyChangeAfterSaveSearchResult: false,
                            },
                            async () => {
                                if (
                                    this.state.globalSaveSearchSelectAll &&
                                    (this.state.saveSearchSelectStatus.length.toString() ===
                                        this.state.itemsPerSaveSearchPage ||
                                        this.state.saveSearchSelectStatus.length ===
                                        this.state.documentSaveSearchCount)
                                ) {
                                    this.setState({ globalSaveSearchSelectAll: true });
                                } else {
                                    this.setState({ globalSaveSearchSelectAll: false });
                                }
                                this.handleAllSaveSearchFilters(
                                    this.state.saveSearchFilters,
                                    this.state.appliedSaveSearchFilters,
                                    this.state.selectedSaveSearchFilters,
                                    this.state.saveSearchResponse,
                                    this.state.documentSaveSearchCount,
                                    this.state.saveSearchSearchKeyword
                                );
                                let pubMedSaveSearchFalseResponse = await this.updatePubmedSavedFlag(_pubMedXSearchId, true);

                                if (!pubMedSaveSearchFalseResponse.errors) {
                                    let pubMedSaveSearchTrueResponse = await this.updatePubmedSavedFlag(selectedSaveSearchPubMedXSearchId, false);
                                    if (!pubMedSaveSearchTrueResponse.errors) {
                                        let service = new ApiServices();
                                        let res = await service.updatePubMedSaveSearchDocId(selectedSavesearchId, _pubMedXSearchId);
                                        this.setState({ selectedSaveSearchPubMedXSearchId: _pubMedXSearchId });
                                    } else {
                                        this.errorAlertMessage("Sorry, something went wrong");
                                    }
                                } else {
                                    this.errorAlertMessage("Sorry, something went wrong");
                                }
                            }
                        );
                    })
                    .catch((error) => {
                        this.setState({ error: error, errorExpand: true });
                    })
                    .finally(() => {
                        this.setState({ isProcessing: false, isLoaded: true });
                    });


            });

        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    }

    runMultipleFilesUpload = async (e) => {
        try {
            this.setState({ isProcessing: true, has_evaluate_been_called: false, isOvidAbstractReleventSelected: false, spinnerMessage: `Please wait while uploading the document.` });
            let { sessionID, useTemplate, newAttachedFiles, appliedOvidAbstractFilters } = this.state;
            var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}uploadabstract`;
            if (window.location.origin === "https://predev-ims.jnj.com") {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}uploadabstract`;
            }
            //url += `?id_column_name=${IDColumnValues[useTemplate]}`
            let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
            username = username.split("@")[0];
            let filterStr = this.generateArrayString(appliedOvidAbstractFilters);
            const formData = new FormData();
            newAttachedFiles.map((item, index) => {
                formData.append(`excel_file`, item);
            });
            formData.append(`id_column_name`, IDColumnValues[useTemplate]);
            formData.append(`user_id`, username);
            if (filterStr)
                formData.append(`filters`, filterStr);
            if (this.state.sortOvidAbstractBy)
                formData.append(`sortBy`, this.state.sortOvidAbstractBy);
            if (this.state.sortOvidAbstractField)
                formData.append(`sortField`, this.state.sortOvidAbstractField);

            formData.append(`from_`, (this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage - this.state.itemsPerOvidAbstractPage));
            formData.append(`size`, parseInt(this.state.itemsPerOvidAbstractPage));
            // formData.append(`fromYear`, this.state.fromOvidAbstractYear);
            // formData.append(`toYear`, this.state.toOvidAbstractYear);
            let _useTemplate = useTemplate === "Other" ? "others" : useTemplate.toLocaleLowerCase()
            formData.append(`format`, _useTemplate.toLocaleLowerCase());
            if (useTemplate === "OVID") {
                formData.append(`mpyear_column_name`, "YR");
            }
            const _headers = {
                "content-type": "multipart/form-data",
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let config = {
                method: "POST",
                url: url,
                headers: _headers,
                data: formData,
                timeout: _timeoutTime
            };
            await axios(config)
                .then(async (response) => {
                    let _responseData = JSON.parse(JSON.stringify(response.data));// { ...response.data }; //Object.assign({}, response.data);// JSON.parse(JSON.stringify(response.data));// clone(response.data)
                    let _abstractXSearchId = response.headers["x-search-id"];
                    if (useTemplate === "OVID") {
                        var processed = processPubMedFilters(response.data.body);
                        response.data = await this.processElasticOvidData(response.data)
                        const filterService = new FilterService();
                        const [filters] = filterService.expandFilterSet(
                            processed,
                            this.state.appliedOvidAbstractFilters
                        );
                        let selectedFiltered = this.state.selectedOvidAbstractFilters.concat(filters);
                        selectedFiltered = this.state.appliedOvidAbstractFilters.concat(filters);
                        this.setState(
                            {
                                abstractsResetInfo: _responseData,
                                documentOvidAbstractCount: response.data.body.hits.total.value,
                                ovidAbstractResponse: response.data.body.hits.hits,
                                ovidAbstractFilters: processed,
                                isProcessing: false,
                                isLoaded: true,
                                collapseFilter: false,
                                //ovidAbstractAnswer: response.data.answer,
                                ovidAbstractAnswer: [],
                                abstractXSearchId: _abstractXSearchId,
                                updateAnyFile: true,
                                attachedFiles: newAttachedFiles,
                                newAttachedFiles: [],
                                fromOvidAbstractYear: response.data.body.aggregations.min_year,
                                toOvidAbstractYear: response.data.body.aggregations.max_year,
                                isAnyChangeAfterAbstractResult: false
                            },
                            async () => {
                                this.manageFilePlaceHolder();
                                if (this.state.abstractsSearchKeyword) {
                                    this.setState({ isOvidAbstractReleventSelected: true }, async () => {
                                        await this.runUploadAbstractEvaluate(
                                            this.state.abstractsSearchKeyword
                                        );
                                    })
                                }
                                this.successAlertMessage("Document uploaded successfully.");
                                if (
                                    this.state.globalOvidAbstractSelectAll &&
                                    (this.state.ovidAbstractSelectStatus.length.toString() ===
                                        this.state.itemsPerOvidAbstractPage ||
                                        this.state.ovidAbstractSelectStatus.length ===
                                        this.state.documentOvidAbstractCount)
                                ) {
                                    this.setState({ globalOvidAbstractSelectAll: true });
                                } else {
                                    this.setState({ globalOvidAbstractSelectAll: false });
                                }
                                this.handleAllOvidAbstractFilters(
                                    this.state.ovidAbstractFilters,
                                    this.state.appliedOvidAbstractFilters,
                                    this.state.selectedOvidAbstractFilters,
                                    this.state.ovidAbstractResponse,
                                    this.state.documentOvidAbstractCount,
                                    this.state.abstractsSearchKeyword
                                );
                            }
                        );
                    } else if (response && response.data && response.data.body && response.data.body.hits && response.data.body.hits.hits && response.data.body.hits.hits.length > 0) {
                        response.data.body.hits.hits.map((hitItem, hitIndex) => {
                            hitItem._source.rli_id = uuidv4();
                            hitItem._source.relevant = hitItem._source.relevant
                                ? hitItem._source.relevant
                                : "False";
                            hitItem._source.summary = hitItem._source.summary
                                ? hitItem._source.summary
                                : "";
                            hitItem._source.keypoints = hitItem._source.keypoints ? hitItem._source.keypoints : null;

                            Object.keys(hitItem._source).map((y) => {
                                if (typeof hitItem._source[y] === "number" && y !== "mpYear") {
                                    hitItem._source[y] = `${hitItem._source[y]}`;
                                }
                            });
                        });

                        let _response = response.data.body.hits.hits.map(x => x._source);
                        var processed = processPubMedFilters(response.data.body);
                        const filterService = new FilterService();
                        const [filters] = filterService.expandFilterSet(
                            processed,
                            this.state.appliedOvidAbstractFilters
                        );
                        let selectedFiltered = this.state.selectedOvidAbstractFilters.concat(filters);
                        selectedFiltered = this.state.appliedOvidAbstractFilters.concat(filters);
                        this.setState(
                            {
                                abstractsResetInfo: _responseData,
                                documentOvidAbstractCount: response.data.body.hits.total.value,
                                //abstractsResponse: response,
                                abstractsResponse: _response,
                                ovidAbstractFilters: processed,
                                isProcessing: false,
                                isLoaded: true,
                                collapseFilter: false,
                                //ovidAbstractAnswer: response.data.answer,
                                ovidAbstractAnswer: [],
                                // documentAbstractCount: _response.length,
                                // itemsPerAbstractPage: `${_response.length}`,
                                abstractXSearchId: _abstractXSearchId,
                                updateAnyFile: true,
                                attachedFiles: newAttachedFiles,
                                newAttachedFiles: [],
                                fromOvidAbstractYear: '',
                                toOvidAbstractYear: '',
                                isAnyChangeAfterAbstractResult: false,
                            },
                            async () => {
                                this.manageFilePlaceHolder();

                                this.successAlertMessage("Document uploaded successfully.");
                            }
                        );
                    } else {
                        this.errorAlertMessage(
                            `This document contains no data. Kindly upload valid document.`
                        );
                    }
                })
                .catch((error) => {
                    this.setState(
                        {
                            error: error,
                            newAttachedFiles: [],
                            abstractsResponse: [],
                            abstractsAnswer: [],
                            abstractXSearchId: "",
                            errorExpand: true,
                        },
                        () => {
                            this.errorAlertMessage(
                                `Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map((x) => x.name).join("<br /> - ")}`
                            );
                        }
                    );
                    console.log(error);
                })
                .finally(() => {
                    this.setState({ isProcessing: false, isLoaded: true, mathRandom: Math.random(), spinnerMessage: `` });
                });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    runUploadAbstractEvaluate = async (querytext) => {
        const { useTemplate, abstract_column_names } = this.state
        if (useTemplate === "OVID" || (useTemplate === 'Other' && abstract_column_names.length > 0)) {
            try {
                this.setState({
                    isProcessing: true,
                    globalOvidAbstractCollapseAll: false,
                    globalOvidAbstractSelectAll: false,
                    ovidAbstractCollapsedSearchIDs: [],
                    isAnyChangeAfterAbstractResult: true,
                    // isLoaded: false,
                });
                let { appliedOvidAbstractFilters, abstractXSearchId, useTemplate, isOvidAbstractReleventSelected } = this.state;
                let filterStr = this.generateArrayString(appliedOvidAbstractFilters);

                var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}uploadabstract/evaluate`;
                if (window.location.origin === "https://predev-ims.jnj.com") {
                    url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}uploadabstract/evaluate`;
                }
                let _useTemplate = useTemplate === "Other" ? "others" : useTemplate.toLocaleLowerCase()
                const _headers = {
                    "Content-Type": "application/json",
                    "x-search-id": abstractXSearchId,
                }
                if (await Authentication.isAccessTokenAvailable()) {
                    const token = await Authentication.getAccessToken();
                    _headers.Authorization = `Bearer ${token}`;
                }
                let config = {
                    method: "POST",
                    url: url,
                    headers: _headers,
                    timeout: _timeoutTime,
                };
                if (useTemplate === "OVID") {
                    config.data = {
                        query: querytext,
                        filters: filterStr,
                        from_:
                            this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage -
                            this.state.itemsPerOvidAbstractPage,
                        size: parseInt(this.state.itemsPerOvidAbstractPage),
                        sortBy: this.state.sortOvidAbstractBy,
                        sortField: this.state.sortOvidAbstractField,
                        fromYear: this.state.fromOvidAbstractYear,
                        toYear: this.state.toOvidAbstractYear,
                        mpyear_column_name: "YR",
                        abstract_column_names: this.state.abstract_column_names,//this.preSelectedValues[useTemplate],
                        tab: isOvidAbstractReleventSelected ? "relevant" : "non relevant",
                        format: _useTemplate.toLocaleLowerCase(),
                    };
                } else {
                    config.data = {
                        query: querytext,
                        filters: filterStr,
                        from_:
                            this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage -
                            this.state.itemsPerOvidAbstractPage,
                        size: parseInt(this.state.itemsPerOvidAbstractPage),
                        // sortBy: this.state.sortOvidAbstractBy,
                        // sortField: this.state.sortOvidAbstractField,
                        // fromYear: this.state.fromOvidAbstractYear,
                        // toYear: this.state.toOvidAbstractYear,
                        abstract_column_names: this.state.abstract_column_names,//this.preSelectedValues[useTemplate],
                        tab: isOvidAbstractReleventSelected ? "relevant" : "non relevant",
                        format: _useTemplate.toLocaleLowerCase(),
                    };
                }

                await axios(config)
                    .then(async (response) => {
                        if (useTemplate === "OVID") {

                            var processed = processPubMedFilters(response.data.body);
                            response.data = await this.processElasticOvidData(response.data)
                            const filterService = new FilterService();
                            const [filters] = filterService.expandFilterSet(
                                processed,
                                this.state.appliedOvidAbstractFilters
                            );
                            let selectedFiltered = this.state.appliedOvidAbstractFilters.concat(filters);
                            this.setState(
                                {
                                    documentOvidAbstractCount: response.data.body.hits.total.value,
                                    ovidAbstractResponse: response.data.body.hits.hits,
                                    ovidAbstractFilters: processed,
                                    isProcessing: false,
                                    isLoaded: true,
                                    collapseFilter: false,
                                    ovidAbstractAnswer: response.data.answer,
                                    has_evaluate_been_called: true,
                                },
                                async () => {
                                    if (
                                        this.state.globalOvidAbstractSelectAll &&
                                        (this.state.ovidAbstractSelectStatus.length.toString() ===
                                            this.state.itemsPerOvidAbstractPage ||
                                            this.state.ovidAbstractSelectStatus.length ===
                                            this.state.documentOvidAbstractCount)
                                    ) {
                                        this.setState({ globalOvidAbstractSelectAll: true });
                                    } else {
                                        this.setState({ globalOvidAbstractSelectAll: false });
                                    }
                                    this.handleAllOvidAbstractFilters(
                                        this.state.ovidAbstractFilters,
                                        this.state.appliedOvidAbstractFilters,
                                        this.state.selectedOvidAbstractFilters,
                                        this.state.ovidAbstractResponse,
                                        this.state.documentOvidAbstractCount,
                                        this.state.abstractsSearchKeyword
                                    );
                                }
                            );
                        } else {
                            response.data.body.hits.hits.map((hitItem, hitIndex) => {
                                hitItem._source.rli_id = uuidv4();
                                hitItem._source.relevant = hitItem._source.relevant
                                    ? hitItem._source.relevant
                                    : "False";
                                hitItem._source.summary = hitItem._source.summary
                                    ? hitItem._source.summary
                                    : "";
                                hitItem._source.keypoints = hitItem._source.keypoints ? hitItem._source.keypoints : null;

                                Object.keys(hitItem._source).map((y) => {
                                    if (typeof hitItem._source[y] === "number" && y !== "mpYear") {
                                        hitItem._source[y] = `${hitItem._source[y]}`;
                                    }
                                });
                            });
                            let _response = response.data.body.hits.hits.map(x => x._source);
                            var processed = processPubMedFilters(response.data.body);
                            const filterService = new FilterService();
                            const [filters] = filterService.expandFilterSet(
                                processed,
                                this.state.appliedOvidAbstractFilters
                            );
                            let selectedFiltered = this.state.selectedOvidAbstractFilters.concat(filters);
                            selectedFiltered = this.state.appliedOvidAbstractFilters.concat(filters);
                            this.setState(
                                {
                                    documentOvidAbstractCount: response.data.body.hits.total.value,
                                    //abstractsResponse: response,
                                    abstractsResponse: _response,
                                    ovidAbstractFilters: processed,
                                    isProcessing: false,
                                    isLoaded: true,
                                    collapseFilter: false,
                                    ovidAbstractAnswer: response.data.answer,
                                    // documentAbstractCount: _response.length,
                                    // itemsPerAbstractPage: `${_response.length}`,
                                    isProcessing: false,
                                    isLoaded: true,
                                    collapseFilter: false,
                                    has_evaluate_been_called: true,
                                }
                            );
                        }
                    })
                    .catch((error) => {
                        this.setState({ error: error, errorExpand: true });
                    })
                    .finally(() => {
                        this.setState({ isProcessing: false, isLoaded: true, mathRandom: Math.random() });
                    });
            } catch (error) {
                this.setState({ error: error, errorExpand: true });
            }
        } else {
            this.errorAlertMessage("Kindly select abstract columns to proceed.");
        }
    };
    runUploadAbstractRead = async (querytext) => {
        try {
            this.setState({
                isProcessing: true,
                globalOvidAbstractCollapseAll: false,
                globalOvidAbstractSelectAll: false,
                ovidAbstractCollapsedSearchIDs: [],
                isReleventSelected: true,
                isAnyChangeAfterAbstractResult: true,
                // isLoaded: false

            });
            let { appliedOvidAbstractFilters, abstractXSearchId, useTemplate, isOvidAbstractReleventSelected } = this.state;
            let filterStr = this.generateArrayString(appliedOvidAbstractFilters);

            var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}uploadabstract/read`;
            if (window.location.origin === "https://predev-ims.jnj.com") {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}uploadabstract/read`;
            }
            let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
            username = username.split("@")[0];
            let _useTemplate = useTemplate === "Other" ? "others" : useTemplate.toLocaleLowerCase()
            const _headers = {
                "Content-Type": "application/json",
                "x-search-id": abstractXSearchId,
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let config = {
                method: "POST",
                url: url,
                headers: _headers,
                timeout: _timeoutTime,
            };

            if (useTemplate === "OVID") {
                config.data = {
                    query: querytext,
                    filters: filterStr,
                    from_:
                        this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage -
                        this.state.itemsPerOvidAbstractPage,
                    size: parseInt(this.state.itemsPerOvidAbstractPage),
                    sortBy: this.state.sortOvidAbstractBy,
                    sortField: this.state.sortOvidAbstractField,
                    fromYear: this.state.fromOvidAbstractYear,
                    toYear: this.state.toOvidAbstractYear,
                    mpyear_column_name: "YR",
                    user_id: username,
                    format: _useTemplate.toLocaleLowerCase(),
                    tab: isOvidAbstractReleventSelected ? "relevant" : "non relevant",
                    has_evaluate_been_called: this.state.has_evaluate_been_called
                };
            } else {
                config.data = {
                    query: querytext,
                    filters: filterStr,
                    from_:
                        this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage -
                        this.state.itemsPerOvidAbstractPage,
                    size: parseInt(this.state.itemsPerOvidAbstractPage),
                    // sortBy: this.state.sortOvidAbstractBy,
                    // sortField: this.state.sortOvidAbstractField,
                    // fromYear: this.state.fromOvidAbstractYear,
                    // toYear: this.state.toOvidAbstractYear,
                    user_id: username,
                    format: _useTemplate.toLocaleLowerCase(),
                    tab: isOvidAbstractReleventSelected ? "relevant" : "non relevant",
                    has_evaluate_been_called: this.state.has_evaluate_been_called
                };
            }

            await axios(config)
                .then(async (response) => {
                    if (useTemplate === "OVID") {
                        var processed = processPubMedFilters(response.data.body);
                        response.data = await this.processElasticOvidData(response.data)
                        const filterService = new FilterService();
                        const [filters] = filterService.expandFilterSet(
                            processed,
                            this.state.appliedOvidAbstractFilters
                        );
                        let selectedFiltered = this.state.selectedOvidAbstractFilters.concat(filters);
                        selectedFiltered = this.state.appliedOvidAbstractFilters.concat(filters);
                        this.setState(
                            {
                                documentOvidAbstractCount: response.data.body.hits.total.value,
                                ovidAbstractResponse: response.data.body.hits.hits,
                                ovidAbstractFilters: processed,
                                isProcessing: false,
                                isLoaded: true,
                                collapseFilter: false,
                                //ovidAbstractAnswer: response.data.answer,
                            },
                            async () => {
                                if (
                                    this.state.globalOvidAbstractSelectAll &&
                                    (this.state.ovidAbstractSelectStatus.length.toString() ===
                                        this.state.itemsPerOvidAbstractPage ||
                                        this.state.ovidAbstractSelectStatus.length ===
                                        this.state.documentOvidAbstractCount)
                                ) {
                                    this.setState({ globalOvidAbstractSelectAll: true });
                                } else {
                                    this.setState({ globalOvidAbstractSelectAll: false });
                                }
                                this.handleAllOvidAbstractFilters(
                                    this.state.ovidAbstractFilters,
                                    this.state.appliedOvidAbstractFilters,
                                    this.state.selectedOvidAbstractFilters,
                                    this.state.ovidAbstractResponse,
                                    this.state.documentOvidAbstractCount,
                                    this.state.abstractsSearchKeyword
                                );
                            }
                        );
                    } else {
                        response.data.body.hits.hits.map((hitItem, hitIndex) => {
                            hitItem._source.rli_id = uuidv4();
                            hitItem._source.relevant = hitItem._source.relevant
                                ? hitItem._source.relevant
                                : "False";
                            hitItem._source.summary = hitItem._source.summary
                                ? hitItem._source.summary
                                : "";
                            hitItem._source.keypoints = hitItem._source.keypoints ? hitItem._source.keypoints : null;

                            Object.keys(hitItem._source).map((y) => {
                                if (typeof hitItem._source[y] === "number" && y !== "mpYear") {
                                    hitItem._source[y] = `${hitItem._source[y]}`;
                                }
                            });
                        });
                        let _response = response.data.body.hits.hits.map(x => x._source);
                        var processed = processPubMedFilters(response.data.body);
                        const filterService = new FilterService();
                        const [filters] = filterService.expandFilterSet(
                            processed,
                            this.state.appliedOvidAbstractFilters
                        );
                        let selectedFiltered = this.state.selectedOvidAbstractFilters.concat(filters);
                        selectedFiltered = this.state.appliedOvidAbstractFilters.concat(filters);
                        this.setState(
                            {
                                documentOvidAbstractCount: response.data.body.hits.total.value,
                                //abstractsResponse: response,
                                abstractsResponse: _response,
                                ovidAbstractFilters: processed,
                                isProcessing: false,
                                isLoaded: true,
                                collapseFilter: false,
                                // ovidAbstractAnswer: response.data.answer,
                                // documentAbstractCount: _response.length,
                                // itemsPerAbstractPage: `${_response.length}`,
                                isProcessing: false,
                                isLoaded: true,
                                collapseFilter: false,
                            }
                        );
                    }
                })
                .catch((error) => {
                    this.setState({ error: error, errorExpand: true });
                    console.log(error);
                })
                .finally(() => {
                    this.setState({ isProcessing: false, isLoaded: true, mathRandom: Math.random() });
                });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }

    };
    processPubmedData = async (response, summaries, relevent) => {
        let pubmedMappingItems = [];
        response.map((ritem, rindex) => {
            let _summaries = summaries.find((val) => {
                return val.pmid === ritem._source.PMID;
            });
            let _relevent = relevent.find((val) => {
                return val.pmid === ritem._source.PMID;
            });

            let pubmedMappingItem = {
                ...ritem,
                _source: {
                    ...ritem._source,
                    Relevance:
                        _relevent && _relevent.relevant
                            ? _relevent.relevant === "Yes"
                                ? "True"
                                : "False"
                            : "False",
                    Summary: _summaries && _summaries.summary ? _summaries.summary : "",
                },
            };
            pubmedMappingItems.push(pubmedMappingItem);
        });
        return pubmedMappingItems;
    };
    updatePubmedSavedFlag = async (_XSearchId, savedValue = true) => {
        let res = { errors: true }
        let data = [];

        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}search/save?saved_value=${savedValue}`
        if (window.location.origin === "https://predev-ims.jnj.com") {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}search/save?saved_value=${savedValue}`;
        }
        const _headers = { "x-search-id": _XSearchId }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        const options = {
            headers: _headers,
            timeout: _timeoutTime,
        };
        await axios.post(url, [],
            options).then((response) => {
                //res = response.data
                res = { errors: false }
            }).catch((error) => {
                console.log(error);
                this.setState({ error: error, errorExpand: true });
                res = { errors: true }
            })
        return res
    };
    generateArrayString = (array) => {
        try {
            let arrStr = "";
            array.map((item, index) => {
                if (index === array.length - 1) {
                    arrStr += item;
                } else {
                    arrStr += item + ";";
                }
                return null;
            });
            return arrStr;
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    bifurcateAppliedFilters(appliedFilters) {
        try {
            let appliedFiltersForOnlyiMS = [];
            let appliedFiltersForBoth = [];
            appliedFilters.map((filter) => {
                const filterParts = filter.split("/");
                const filterTop = filterParts[0];
                if (
                    Object.keys(PubMedFiltersGenAI).findIndex(
                        (x) => x.toLowerCase() === filterTop.toLowerCase()
                    ) > -1) {
                    appliedFiltersForBoth.push(filter);
                } else {
                    appliedFiltersForOnlyiMS.push(filter);
                }
            });
            return {
                appliedFiltersForOnlyiMS: appliedFiltersForOnlyiMS,
                appliedFiltersForBoth: appliedFiltersForBoth,
            };
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    }
    generateSelectParentArray = (appliedfilters) => {
        try {
            let parentFacet = [];
            appliedfilters.forEach((filter) => {
                const filterParts = filter.split("/");
                const filterTop = filterParts[0];
                parentFacet.push(filterTop);
            });
            return parentFacet;
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleAllFilters = (
        filters,
        appliedfilters,
        selectedFilters,
        response,
        docCount,
        query
    ) => {
        try {
            this.setState({
                filters: filters,
                appliedFilters: appliedfilters,
                selectedFilters: selectedFilters,
                response: response,
                documentCount: docCount,
                searchKeyword: query,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleYearSelection = (newYears) => {
        try {
            this.setState(
                {
                    fromYear: newYears.min,
                    toYear: newYears.max,
                },
                () =>
                    this.setState({
                        globalSelectAll: false,
                        selectedResults: [],
                        citationSelectStatus: [],
                    })
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handlePageChange = (currentPage) => {
        try {
            window.scrollTo({ behavior: "smooth", top: "0px" });
            let checkSelectStatus = this.state.citationSelectStatus.filter(
                (item) => item
            );
            if (
                this.state.globalSelectAll &&
                (checkSelectStatus.length.toString() === this.state.itemsPerPage ||
                    this.state.citationSelectStatus.length === this.state.documentCount)
            ) {
                this.setState({ citationSelectStatus: [], selectedResults: [] });
            }
            this.setState(
                {
                    currentPage: currentPage,
                    response: [],
                    isProcessing: true,
                    // isLoaded: false,
                    globalCollapseAll: false,
                    globalSelectAll: false,
                    get_final_answering: false,
                    collapsedSearchIDs: [],
                },
                () => {
                    let setSelectStatus = false;
                    let startIndex =
                        this.state.currentPage * this.state.itemsPerPage -
                        this.state.itemsPerPage;
                    let endIndex = this.state.currentPage * this.state.itemsPerPage;
                    let citationStatusForCurrentPage =
                        this.state.citationSelectStatus.slice(startIndex, endIndex);
                    setSelectStatus = citationStatusForCurrentPage.some(
                        (e) => e === true
                    );
                    if (setSelectStatus) {
                        this.setState({
                            globalSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalSelectAll: false,
                        });
                    }
                    this.runSearchFromQueryParams(
                        this.state.allFilters,
                        this.state.appliedFilters,
                        this.state.searchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    gotoPage = (currentPage) => {
        try {
            this.setState(
                {
                    currentPage: currentPage,
                    response: [],
                    isProcessing: true,
                    isLoaded: true,
                    globalCollapseAll: false,
                    collapsedSearchIDs: [],
                    get_final_answering: false
                },
                () => {
                    let setSelectStatus = false;
                    let startIndex =
                        this.state.currentPage * this.state.itemsPerPage -
                        this.state.itemsPerPage;
                    let endIndex = this.state.currentPage * this.state.itemsPerPage;
                    let citationStatusForCurrentPage =
                        this.state.citationSelectStatus.slice(startIndex, endIndex);
                    setSelectStatus = citationStatusForCurrentPage.some(
                        (e) => e === true
                    );
                    if (setSelectStatus) {
                        this.setState({
                            globalSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalSelectAll: false,
                        });
                    }
                    this.runSearchFromQueryParams(
                        this.state.allFilters,
                        this.state.appliedFilters,
                        this.state.searchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleAnswerChangeDocsize = (items) => {
        this.setState({ selectedFinalAnsweringDocSize: items, get_final_answering: true },
            () => {
                this.runSearchFromQueryParams(
                    this.state.allFilters,
                    this.state.appliedFilters,
                    this.state.searchKeyword
                )
            }
        )
    }

    handleChangeSelectItems = (items) => {
        try {
            let checkSelectStatus = this.state.citationSelectStatus.filter(
                (item) => item
            );
            if (
                this.state.globalSelectAll &&
                (checkSelectStatus.length.toString() === this.state.itemsPerPage ||
                    this.state.citationSelectStatus.length === this.state.documentCount)
            ) {
                this.setState({ citationSelectStatus: [], selectedResults: [] });
            }
            let { isReleventSelected, itemsPerPageHighlyResponsive, itemsPerPageResponsive } = this.state;
            this.setState(
                {
                    itemsPerPage: items,
                    itemsPerPageHighlyResponsive: isReleventSelected ? items : itemsPerPageHighlyResponsive,
                    itemsPerPageResponsive: isReleventSelected ? itemsPerPageResponsive : items,
                    globalCollapseAll: false,
                    globalSelectAll: false,
                    collapsedSearchIDs: [],
                    selectedResults: [],
                    citationSelectStatus: [],
                    get_final_answering: false
                },
                () => {
                    let totalPages = Math.ceil(
                        this.state.documentCount / this.state.itemsPerPage
                    );
                    if (totalPages < this.state.currentPage) {
                        this.setState(
                            {
                                currentPage: totalPages,
                            },
                            () => {
                                let setSelectStatus = false;
                                let startIndex =
                                    this.state.currentPage * this.state.itemsPerPage -
                                    this.state.itemsPerPage;
                                let endIndex = this.state.currentPage * this.state.itemsPerPage;
                                let citationStatusForCurrentPage =
                                    this.state.citationSelectStatus.slice(startIndex, endIndex);
                                setSelectStatus = citationStatusForCurrentPage.some(
                                    (e) => e === true
                                );
                                if (setSelectStatus) {
                                    this.setState({
                                        globalSelectAll: true,
                                    });
                                } else {
                                    this.setState({
                                        globalSelectAll: false,
                                    });
                                }
                                this.runSearchFromQueryParams(
                                    this.state.allFilters,
                                    this.state.appliedFilters,
                                    this.state.searchKeyword
                                );
                            }
                        );
                    } else {
                        this.runSearchFromQueryParams(
                            this.state.allFilters,
                            this.state.appliedFilters,
                            this.state.searchKeyword
                        );
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    buildUrl = (
        searchKeyword,
        filters,
        isClearSearch,
        addDateRange = true
    ) => {
        try {
            searchKeyword = encodeURIComponent(searchKeyword);
            let filterStr = this.generateArrayString(filters);
            let url = `?query=${searchKeyword}&filters=${filterStr}`;
            if (isClearSearch === true) {
                url = `?query=&filters=`;
            }
            return url;
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    runSearchFromQueryParams(allfilters, appliedfilters, querytext) {
        try {
            this.setState({
                isProcessing: true,
                // isLoaded: false 
            });
            const filterService = new FilterService();
            const query = querytext;
            const inFilters = appliedfilters;
            // const [filters] = filterService.expandFilterSet(allfilters, inFilters)
            const [filters] = filterService.expandFilterSet(
                this.state.filters,
                inFilters
            );
            const filterSelected = inFilters;
            let selectedFiltered = this.state.selectedFilters.concat(filters);
            selectedFiltered = [...new Set(selectedFiltered)];
            this.setState(
                {
                    appliedFilters: inFilters,
                    selectedFilters: selectedFiltered,
                    // selectedFilters: filters
                },
                async () => {
                    // this.runPubmedSearch(query);
                    await this.runPubmedSearchTab(query, filterSelected);
                    await this.indexTabTrackingData(query);
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    }

    handleOnChangeInfilter = (
        filters,
        appliedfilters,
        selectedFilters,
        response,
        doc,
        query
    ) => {
        try {
            let params = queryString.parse(this.props.location.search);
            //var filters = appliedfilters;
            filters = appliedfilters;
            let selectedFacets = this.generateSelectParentArray(appliedfilters);
            const newUrl = this.buildUrl(
                params.query,
                filters,
                false
            );
            this.props.history.push({
                pathname: "/PubMedSearch",
                search: newUrl,
                state: {
                    selectedFilters: selectedFilters,
                    allFilters: this.state.allFilters,
                    appliedFilters: appliedfilters,
                },
            });
            this.setState(
                {
                    currentPage: "1",
                    selectedParentFilterArr: selectedFacets,
                    collapseFilter: true,
                    selectedFilters: selectedFilters,
                    globalSelectAll: false,
                    selectedResults: [],
                    citationSelectStatus: [],
                    get_final_answering: true,
                },
                () => {
                    this.runSearchFromQueryParams(
                        this.state.allFilters,
                        appliedfilters,
                        this.state.searchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleCitationSelection = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.citationSelectStatus;
            a[index - 1] = !this.state.citationSelectStatus[index - 1];
            let data = this.state.selectedResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.citationSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                citationSelectStatus: a,
                selectedResults: data,
            });
            let checkSelectStatus = a.filter((item) => item);
            if (checkSelectStatus.length === parseInt(this.state.itemsPerPage)) {
                this.setState({ globalSelectAll: true });
            } else if (checkSelectStatus.length === this.state.response.length) {
                this.setState({ globalSelectAll: true });
            } else {
                this.setState({ globalSelectAll: false });
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleAbstractCitationSelection = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.abstractSelectStatus;
            a[index - 1] = !this.state.abstractSelectStatus[index - 1];
            let data = this.state.selectedAbstractResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.abstractSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                abstractSelectStatus: a,
                selectedAbstractResults: data,
            });
            let checkSelectStatus = a.filter((item) => item);
            if (
                checkSelectStatus.length === parseInt(this.state.itemsPerAbstractPage)
            ) {
                this.setState({ globalAbstractSelectAll: true });
            } else if (
                checkSelectStatus.length === this.state.abstractsResponse.length
            ) {
                this.setState({ globalAbstractSelectAll: true });
            } else {
                this.setState({ globalAbstractSelectAll: false });
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    citationUrl = (url, index, item, displayedResultsUrl) => {
        try {
            if (item.domain === "CTGov") {
                displayedResultsUrl[index] = url;
            } else {
                displayedResultsUrl[index] = window.location.origin + url;
                // displayedResultsUrl[index] = "https://predev-ims.jnj.com" + url;
            }
            this.documentsUrl = displayedResultsUrl;
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    manageAbstractCollapseAndExpand = (iscollapsed, rli_id) => {
        try {
            let { abstractCollapsedSearchIDs, abstractsResponse } = this.state;
            let responseSearchIDs = abstractsResponse.map((x) => x.rli_id);

            if (iscollapsed) {
                abstractCollapsedSearchIDs.push(rli_id);
            } else {
                abstractCollapsedSearchIDs = abstractCollapsedSearchIDs.filter(
                    (x) => x !== rli_id
                );
            }
            let tempGlobalCollapseAll = responseSearchIDs.every((x) =>
                abstractCollapsedSearchIDs.includes(x)
            );
            this.setState({
                abstractCollapsedSearchIDs: abstractCollapsedSearchIDs,
                globalAbstractCollapseAll: tempGlobalCollapseAll,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    manageCollapseAndExpand = (iscollapsed, rli_id) => {
        try {
            let { collapsedSearchIDs, response } = this.state;
            let responseSearchIDs = response.map((x) => x._source.rli_id);
            if (iscollapsed) {
                collapsedSearchIDs.push(rli_id);
            } else {
                collapsedSearchIDs = collapsedSearchIDs.filter((x) => x !== rli_id);
            }
            let tempGlobalCollapseAll = responseSearchIDs.every((x) =>
                collapsedSearchIDs.includes(x)
            );
            this.setState({
                collapsedSearchIDs: collapsedSearchIDs,
                globalCollapseAll: tempGlobalCollapseAll,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleClearFilters = () => {
        try {
            const currentDate = new Date();
            let currentYear = currentDate.getFullYear();
            this.setState(
                {
                    selectedFilters: [],
                    appliedFilters: [],
                    selectedParentFilterArr: [],
                    appliedFiltersForOnlyiMS: [],
                    filters: [],
                    fromYear: currentYear - 5,
                    toYear: currentYear,
                    globalSelectAll: false,
                    selectedResults: [],
                    citationSelectStatus: [],
                    get_final_answering: true,
                },
                () => {
                    let params = queryString.parse(this.props.location.search);
                    const newUrl = this.buildUrl(
                        params.query,
                        this.state.appliedFilters,
                        false,
                        false
                    );
                    this.props.history.push(newUrl);
                    this.runSearchFromQueryParams(
                        this.state.allFilters,
                        this.state.appliedFilters,
                        this.state.searchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleRemoveAppliedFilter = (facet) => {
        try {
            let parentFacetName = facet.split("/")[0];
            let arr = this.state.selectedParentFilterArr;
            const index = arr.indexOf(parentFacetName);
            if (index > -1) {
                arr.splice(index, 1);
            }
            this.setState(
                {
                    appliedFilters: this.state.appliedFilters.filter(
                        (filter) => !filter.startsWith(facet)
                    ),
                    selectedParentFilterArr: arr,
                    selectedFilters: this.state.selectedFilters.filter(
                        (filter) => filter && !filter.startsWith(facet)
                    ),
                    globalSelectAll: false,
                    selectedResults: [],
                    citationSelectStatus: [],
                    get_final_answering: true
                },
                () => {
                    let params = queryString.parse(this.props.location.search);
                    const newUrl = this.buildUrl(
                        params.query,
                        this.state.appliedFilters,
                        false
                    );
                    this.props.history.push(newUrl);
                    this.runSearchFromQueryParams(
                        this.state.allFilters,
                        this.state.appliedFilters,
                        this.state.searchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleScroll = (event) => {
        this.scrollingTableHeader.scrollTo({
            behavior: "smooth",
            left: event.target.scrollLeft,
        });
    };
    handleAbstractCollapseAllGlobal = () => {
        try {
            let { abstractsResponse, abstractCollapsedSearchIDs } = this.state;
            if (!this.state.globalAbstractCollapseAll) {
                abstractCollapsedSearchIDs = abstractsResponse.map((x) => x.rli_id);
            } else {
                abstractCollapsedSearchIDs = [];
            }
            this.setState({
                globalAbstractCollapseAll: !this.state.globalAbstractCollapseAll,
                abstractCollapsedSearchIDs: abstractCollapsedSearchIDs,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleCollapseAllGlobal = () => {
        try {
            let { response, collapsedSearchIDs } = this.state;
            if (!this.state.globalCollapseAll) {
                collapsedSearchIDs = response.map((x) => x._source.rli_id);
            } else {
                collapsedSearchIDs = [];
            }
            this.setState({
                globalCollapseAll: !this.state.globalCollapseAll,
                collapsedSearchIDs: collapsedSearchIDs,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleSelectAll = () => {
        try {
            this.setState(
                {
                    globalSelectAll: !this.state.globalSelectAll,
                },
                () => {
                    let startIndex =
                        this.state.currentPage * this.state.itemsPerPage -
                        this.state.itemsPerPage +
                        1;
                    var count = startIndex;
                    let endIndex = this.state.itemsPerPage;
                    if (this.state.globalSelectAll) {
                        this.markedDocumentsUrl = [];
                        this.setState({ selectedResults: [] }, () => {
                            for (let i = 1; i <= endIndex; i++) {
                                if (this.state.response[i - 1] !== undefined) {
                                    this.handleCitationSelectionGlobal(
                                        count,
                                        this.state.response[i - 1]._source,
                                        this.state.response[i - 1].highlight === undefined ||
                                            this.state.response[i - 1].highlight?.body[0] ===
                                            "Empty File" ||
                                            this.state.response[i - 1].highlight?.body[0] ===
                                            "Not an empty file"
                                            ? []
                                            : this.state.response[i - 1].highlight.body,
                                        i
                                    );
                                    count++;
                                }
                            }
                        });
                    } else {
                        for (let i = 1; i <= endIndex; i++) {
                            if (this.state.response[i - 1] !== undefined) {
                                this.handleCitationUnSelection(
                                    count,
                                    this.state.response[i - 1]._source,
                                    this.state.response[i - 1].highlight === undefined ||
                                        this.state.response[i - 1].highlight?.body[0] ===
                                        "Empty File" ||
                                        this.state.response[i - 1].highlight?.body[0] ===
                                        "Not an empty file"
                                        ? []
                                        : this.state.response[i - 1].highlight.body
                                );
                                count++;
                            }
                        }
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleAbstractSelectAll = () => {
        try {
            this.setState(
                {
                    globalAbstractSelectAll: !this.state.globalAbstractSelectAll,
                },
                () => {
                    let startIndex =
                        this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage -
                        this.state.itemsPerOvidAbstractPage +
                        1;
                    var count = startIndex;
                    let endIndex = this.state.itemsPerOvidAbstractPage;
                    if (this.state.globalAbstractSelectAll) {
                        this.markedDocumentsUrl = [];
                        this.setState({ selectedAbstractResults: [], abstractsSelected: this.state.abstractsResponse.map(x => x.rowIndex) }, () => {
                            for (let i = 1; i <= endIndex; i++) {
                                if (this.state.abstractsResponse[i - 1] !== undefined) {
                                    this.handleAbstractCitationSelectionGlobal(
                                        count,
                                        this.state.abstractsResponse[i - 1],
                                        this.state.abstractsResponse[i - 1].highlight ===
                                            undefined ||
                                            this.state.abstractsResponse[i - 1].highlight?.body[0] ===
                                            "Empty File" ||
                                            this.state.abstractsResponse[i - 1].highlight?.body[0] ===
                                            "Not an empty file"
                                            ? []
                                            : this.state.abstractsResponse[i - 1].highlight.body,
                                        i
                                    );
                                    count++;
                                }
                            }
                        });
                    } else {
                        this.setState({ abstractsSelected: [] })
                        for (let i = 1; i <= endIndex; i++) {
                            if (this.state.abstractsResponse[i - 1] !== undefined) {
                                this.handleAbstractCitationUnSelection(
                                    count,
                                    this.state.abstractsResponse[i - 1],
                                    this.state.abstractsResponse[i - 1].highlight === undefined ||
                                        this.state.abstractsResponse[i - 1].highlight?.body[0] ===
                                        "Empty File" ||
                                        this.state.abstractsResponse[i - 1].highlight?.body[0] ===
                                        "Not an empty file"
                                        ? []
                                        : this.state.abstractsResponse[i - 1].highlight.body
                                );
                                count++;
                            }
                        }
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleCitationSelectionGlobal = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.citationSelectStatus;
            a[index - 1] = true;
            let data = this.state.selectedResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.citationSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key - 1]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                citationSelectStatus: a,
                selectedResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleCitationUnSelection = (index, item, itemTeaser) => {
        try {
            let a = this.state.citationSelectStatus;
            a[index - 1] = false;
            let data = this.state.selectedResults;
            let urls = this.markedDocumentsUrl;
            /* if (this.state.citationSelectStatus[index - 1]) {
                                    data.push({
                                        detail: item,
                                        itemTeaser: itemTeaser,
                                        index: index,
                                    })
                                }
                                else { */
            const i = data.map((x) => x.index).indexOf(index);
            if (i > -1) {
                data.splice(i, 1); // 2nd parameter means remove one item only
                urls.splice(i, 1);
            }
            /* } */
            // let selectedResultsDetails = data;
            // sessionStorage.setItem("selectedResultsDetails", JSON.stringify(selectedResultsDetails));
            // let selectedResultsIndex = data.map(x => x.index)
            // localStorage.setItem('selectedResults', selectedResultsIndex)
            this.markedDocumentsUrl = urls;
            this.setState({
                citationSelectStatus: a,
                selectedResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleAbstractCitationSelectionGlobal = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.abstractSelectStatus;
            a[index - 1] = true;
            let data = this.state.selectedAbstractResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.abstractSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key - 1]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                abstractSelectStatus: a,
                selectedAbstractResults: data,
                //abstractsSelected: data.map(data1 => data1.detail.rowIndex)
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleAbstractCitationUnSelection = (index, item, itemTeaser) => {
        try {
            let a = this.state.abstractSelectStatus;
            a[index - 1] = false;
            let data = this.state.selectedAbstractResults;
            let urls = this.markedDocumentsUrl;
            /* if (this.state.citationSelectStatus[index - 1]) {
                                    data.push({
                                        detail: item,
                                        itemTeaser: itemTeaser,
                                        index: index,
                                    })
                                }
                                else { */
            const i = data.map((x) => x.index).indexOf(index);
            if (i > -1) {
                data.splice(i, 1); // 2nd parameter means remove one item only
                urls.splice(i, 1);
            }
            /* } */
            // let selectedResultsDetails = data;
            // sessionStorage.setItem("selectedResultsDetails", JSON.stringify(selectedResultsDetails));
            // let selectedResultsIndex = data.map(x => x.index)
            // localStorage.setItem('selectedResults', selectedResultsIndex)
            this.markedDocumentsUrl = urls;
            this.setState({
                abstractSelectStatus: a,
                selectedAbstractResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handelSelectedAbstract = (_abstractsSelected) => {
        this.setState({ abstractsSelected: _abstractsSelected });
    };
    getSelectedCitationDetails = () => {
        try {
            if (this.state.selectedResults.length > 0) {
                let selectedResultsDetails = this.state.selectedResults;
                sessionStorage.setItem(
                    "selectedResultsDetails",
                    JSON.stringify(selectedResultsDetails)
                );
                let selectedResultsIndex = this.state.selectedResults.map(
                    (x) => x.index
                );
                localStorage.setItem("selectedResults", selectedResultsIndex);
                localStorage.setItem(
                    "markedResultsUrl",
                    JSON.stringify(this.markedDocumentsUrl)
                );
                localStorage.setItem("ItemsPerPage", this.state.itemsPerPage);
                localStorage.setItem("ActivePage", this.state.currentPage);
                this.props.history.push({
                    pathname: "/viewmarked",
                    state: { selectedResults: this.state.selectedResults },
                });
            } else {
                alert("There are no documents selected");
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    getSelectedAbstractCitationDetails = () => {
        try {
            if (this.state.selectedAbstractResults.length > 0) {
                let selectedAbstractResultsDetails = this.state.selectedAbstractResults;
                sessionStorage.setItem(
                    "selectedAbstractResultsDetails",
                    JSON.stringify(selectedAbstractResultsDetails)
                );
                let selectedAbstractResultsIndex =
                    this.state.selectedAbstractResults.map((x) => x.index);
                localStorage.setItem(
                    "selectedAbstractResults",
                    selectedAbstractResultsIndex
                );
                localStorage.setItem(
                    "markedResultsUrl",
                    JSON.stringify(this.markedDocumentsUrl)
                );
                localStorage.setItem("ItemsPerPage", this.state.itemsPerPage);
                localStorage.setItem("ActivePage", this.state.currentPage);
                this.props.history.push({
                    pathname: "/viewmarked",
                    state: {
                        selectedAbstractResults: this.state.selectedAbstractResults,
                    },
                });
            } else {
                alert("There are no documents selected");
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleReleventNonreleventFilter = async (isRelevent) => {
        if (this.state.isReleventSelected != isRelevent) {
            let { itemsPerPageHighlyResponsive, itemsPerPageResponsive } = this.state;
            this.setState(
                {
                    isReleventSelected: isRelevent,
                    itemsPerPage: isRelevent ? itemsPerPageHighlyResponsive : itemsPerPageResponsive,
                    currentPage: "1",
                    globalCollapseAll: false,
                    collapsedSearchIDs: [],
                    globalSelectAll: false,
                    selectedResults: [],
                    citationSelectStatus: [],
                    response: [],
                    get_final_answering: (isRelevent && this.state.answers.length === 0)
                },
                () => {
                    this.runSearchFromQueryParams(
                        this.state.allFilters,
                        this.state.appliedFilters,
                        this.state.searchKeyword
                    );
                }
            );
        }
    };

    handleRef = (ref, index) => {
        if (ref) {
            this.resultListRef.current[index] = ref
        }
    }

    resultList = (results, itemsPerPage, currentPage) => {
        if (this.state.selectedTab === '0') {
            try {
                let { collapsedSearchIDs, searchKeyword, selectedTabResponsive, isReleventSelected } = this.state;
                var startIndex;
                startIndex = currentPage * itemsPerPage - itemsPerPage;
                var count = startIndex;
                let displayedResults = [];
                let displayedResultsUrl = [];
                this.resultListRef.current = Array.from({ length: results.length }, i => i)
                return (<>
                    {searchKeyword &&
                        <div>
                            <PubMedSearchResponsiveTabs selectedTabResponsive={selectedTabResponsive} isCheckButtonActive={isReleventSelected} selectedTab={this.state.selectedTab} isTabForId={'7'} handleOnTabClickresponsive={this.handleOnTabClickresponsive} width={this.state.width} />
                        </div>
                    }
                    {(() => {
                        if (results.length > 0) {
                            return (
                                <>
                                    <div className="pubmed-main-right-section-result-list box-white-main">
                                        <div
                                            className="sticky top-16 z-2 overflow-hidden rounded-border-20 bg-white/95 backdrop-blur dark:bg-secondary-950/75"
                                            ref={(el) => {
                                                this.scrollingTableHeader = el;
                                            }}
                                            id="scrolling-table-header"
                                        ></div>
                                        <div
                                            className="overflow-x-auto pubmed-main-right-section-result-list-body pt-1"
                                            onScroll={(e) => this.handleScroll(e)}
                                        >
                                            {/* <div className="min-w-1200px"> */}

                                            <div>
                                                {results.map((item, index) => {
                                                    count++;
                                                    if (
                                                        item.highlight === undefined ||
                                                        item.highlight?.body[0] === "Empty File" ||
                                                        item.highlight?.body[0] === "Not an empty file"
                                                    ) {
                                                        displayedResults.push({
                                                            detail: item._source,
                                                            itemTeaser: [],
                                                            index: index + 1,
                                                        });
                                                        // item.highlight = { 'body': ['Test body until indexed value is available'] }
                                                    } else {
                                                        displayedResults.push({
                                                            detail: item._source,
                                                            itemTeaser: item.highlight.body,
                                                            index: index + 1,
                                                        });
                                                    }
                                                    let responseSearchIDs = item._source.rli_id;
                                                    let globalCollapseAll = collapsedSearchIDs.some(
                                                        (x) => x === responseSearchIDs
                                                    );
                                                    return (
                                                        <>
                                                            <div
                                                                key={`result-id-${index}`}
                                                                id={`result-id-${index}`}
                                                                className="mx-1 mb-2 rounded-2xl border-2 border-secondary-100 pubmed-main-result-item-border"
                                                            >
                                                                <PubMedDocumentCard
                                                                    item={item._source}
                                                                    count={count}
                                                                    appliedFilters={this.state.appliedFilters}
                                                                    searchKeyword={this.state.searchKeyword}
                                                                    pageNumber={this.state.currentPage}
                                                                    pageSize={this.state.itemsPerPage}
                                                                    itemTeaser={
                                                                        item.highlight === undefined ||
                                                                            item.highlight?.body[0] === "Empty File" ||
                                                                            item.highlight?.body[0] === "Not an empty file"
                                                                            ? []
                                                                            : item.highlight.body
                                                                    }
                                                                    handleCitationSelection={(i, item, itemTeaser) =>
                                                                        this.handleCitationSelection(
                                                                            i,
                                                                            item,
                                                                            itemTeaser,
                                                                            index
                                                                        )
                                                                    }
                                                                    isChecked={
                                                                        this.state.citationSelectStatus[count - 1]
                                                                    }
                                                                    customWidth={this.state.width}
                                                                    //globalCollapseAll={this.state.globalCollapseAll}
                                                                    globalCollapseAll={globalCollapseAll}
                                                                    csPath={this.state.csPath}
                                                                    csproduct={this.state.csproduct}
                                                                    citationUrl={(url) =>
                                                                        this.citationUrl(
                                                                            url,
                                                                            index,
                                                                            item._source,
                                                                            displayedResultsUrl
                                                                        )
                                                                    }
                                                                    manageCollapseAndExpand={
                                                                        this.manageCollapseAndExpand
                                                                    }
                                                                    selectedTab={this.state.selectedTab}
                                                                    handleRef={this.handleRef}
                                                                    index={index}
                                                                />
                                                                {/* <div className="resultsDivFooter"></div> */}
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        {localStorage.setItem(
                                            "displayedResults",
                                            JSON.stringify(displayedResults)
                                        )}
                                    </div>
                                </>
                            );

                        } else {
                            localStorage.removeItem("displayedResults");
                            return (
                                <div className="results-no-search-content pubmed-results-no-search-content">
                                    <span>Nothing here matches your search</span>
                                    <br />
                                    <br />
                                    <span>Suggestions</span>
                                    <li>
                                        <b>Adjust the 'Publication Year'</b> (if applicable)
                                    </li>
                                    <li>Make sure all words are spelled correctly</li>
                                    <li>Try different search terms</li>
                                    <li>Try more general search terms</li>
                                    <li>Try fewer search terms</li>
                                </div>
                            );
                        }

                    })()}
                </>)

            } catch (error) {
                this.setState({ error: error, errorExpand: true });
            }
        }
        return <></>
        // this.setState({displayedResults:displayedResults})
    };


    resultListCount = (itemsPerPage, currentPage, documentCount, response) => {
        try {
            var endIndex, startIndex;
            startIndex = currentPage * itemsPerPage - itemsPerPage;
            endIndex = currentPage * itemsPerPage;
            // var count = startIndex;
            // const totalPages = Math.ceil(this.state.documentCount / itemsPerPage);
            // const previousOff = currentPage == 1;
            // const nextOff = currentPage == totalPages;
            if (this.state.width < 600) {
                return (
                    <div
                        className="results-count-wrapper pubmed-main-right-section-result-list-count box-white-main"
                        style={{
                            justifyContent:
                                this.state.response.length > 0 ? "space-between" : "flex-end",
                        }}
                    >
                        {
                            this.state.response.length > 0 && (
                                <Pagination
                                    // metadata={this.state.documentCount}
                                    // handlePageChange={this.handlePageChange}
                                    // itemsPerPage={this.state.itemsPerPage}
                                    // page={this.state.currentPage}
                                    metadata={documentCount}
                                    handlePageChange={this.handlePageChange}
                                    itemsPerPage={itemsPerPage}
                                    page={currentPage}
                                    customWidth={this.state.width}
                                    customHeight={this.state.height}
                                />
                            )
                            // <div className="resultListCount-container">
                            //     {this.state.documentCount > 0 &&
                            //         <span className="paginationContainer-mobile">
                            //             <span className="startEndIndexText-mobile" onClick={this.navigateToFirstPage}>
                            //                 {previousOff ? null : 1}
                            //             </span>
                            //             {
                            //                 previousOff ? <img src={prdtNavButton} alt="leftArrowIcon" className="paginationArrowIcon-mobile" style={{ transform: "matrix(-1, 0, 0, -1, 0, 0)" }} /> : <img src={leftArrowMobileIcon} alt="leftArrowIcon" className="paginationArrowIcon-mobile" onClick={this.handlePreviousClick} style={{ cursor: "pointer" }} />
                            //             }
                            //             <span className="currentResultText-mobile">
                            //                 {currentPage}
                            //             </span>
                            //             {
                            //                 nextOff ? <img src={prdtNavButton} alt="rightArrowIcon" className="paginationArrowIcon-mobile" /> : <img src={rightArrowMobileIcon} alt="rightArrowIcon" className="paginationArrowIcon-mobile" onClick={this.handleNextClick} style={{ cursor: "pointer" }} />
                            //             }
                            //             <span className="startEndIndexText-mobile" onClick={this.navigateToLastPage}>
                            //                 {nextOff ? null : totalPages}
                            //             </span>
                            //         </span>
                            //     }
                            // </div>
                        }
                        <div
                            className="clearSearchContainer"
                            onClick={this.handleClearSearch}
                        >
                            <img
                                src={clearSearchMobView}
                                alt="clearSearch"
                                className="clearSearchIcon" /* onClick={this.handleClearSearch} */
                            />
                            {/* <span className="clearSearchText">Clear Search</span> */}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className={this.state.selectedTab != 2 ? "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main" :
                        "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main m-y"}>
                        {response.length > 0 && (
                            <div className="resultListCount-container">
                                {documentCount > 0 && (
                                    <span
                                        className="showingResultsCountContainer" /* style={{ display: "flex", width: "200px" }} */
                                    >
                                        {endIndex <= documentCount ? (
                                            <div className="results-number-show-wrapper">
                                                Showing {(startIndex + 1).toLocaleString("en-us")}-
                                                {endIndex.toLocaleString("en-us")} of{" "}
                                                {documentCount.toLocaleString("en-us")}{" "}
                                                Results
                                            </div>
                                        ) : (
                                            <div className="results-number-show-wrapper">
                                                Showing {(startIndex + 1).toLocaleString("en-us")}-
                                                {documentCount.toLocaleString("en-us")} of{" "}
                                                {documentCount.toLocaleString("en-us")}{" "}
                                                Results
                                            </div>
                                        )}
                                    </span>
                                )}
                                <span
                                    style={{
                                        marginRight: "0.5%",
                                        display: "flex",
                                        width: "180px",
                                    }}
                                >
                                    <PubMedPageItems
                                        handleChangeSelectItems={this.handleChangeSelectItems}
                                        itemsPerPage={this.state.itemsPerPage}
                                        customWidth={this.state.width}
                                    />
                                </span>
                                {this.state.width >= 1000 ? (
                                    <div className="sort-by-wrapper">
                                        <span className="sort-by-text">Sort By:</span>
                                        <select
                                            className="sort-by-select-wrapper"
                                            onChange={this.handleChangeSelectSortBy}
                                            defaultValue={this.state.sortByValue}
                                            value={this.state.sortByValue}
                                        >
                                            <option value="Relevance">Relevance</option>
                                            <option>Year (oldest to newest)</option>
                                            <option>Year (newest to oldest)</option>
                                        </select>
                                    </div>
                                ) : (
                                    this.state.width >= 600 && (
                                        <div className="sort-by-wrapper">
                                            <span className="sort-by-text">Sort By:</span>
                                            <select
                                                className="sort-by-select-wrapper"
                                                onChange={this.handleChangeSelectSortBy}
                                                defaultValue={this.state.sortByValue}
                                                value={this.state.sortByValue}
                                            >
                                                <option value="Relevance">Relevance</option>
                                                <option>Year Asc</option>
                                                <option>Year Desc</option>
                                            </select>
                                        </div>
                                    )
                                )}
                            </div>
                        )}
                        {this.state.width < 1000 && (
                            <div
                                className="clearSearchContainer"
                                onClick={this.handleClearSearch}
                            >
                                <img
                                    src={clearSearchMobView}
                                    alt="clearSearch"
                                    className="clearSearchIcon"
                                />
                                {this.state.width >= 805 && (
                                    <span className="clearSearchText">Clear Search</span>
                                )}
                            </div>
                        )}
                    </div>
                );
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleChangeSelectSortBy = (e) => {
        try {
            if (
                e.target.value === "Year (oldest to newest)" ||
                e.target.value === "Year Asc"
            ) {
                this.setState({ sortBy: "asc", sortField: "mpYear" });
            } else if (
                e.target.value === "Year (newest to oldest)" ||
                e.target.value === "Year Desc"
            ) {
                this.setState({ sortBy: "desc", sortField: "mpYear" });
            } else {
                this.setState({ sortBy: "", sortField: "" });
            }
            this.setState(
                {
                    sortByValue: e.target.value,
                    citationSelectStatus: [],
                    selectedResults: [],
                    globalSelectAll: false,
                    globalCollapseAll: false,
                    collapsedSearchIDs: [],
                },
                () => {
                    this.runSearchFromQueryParams(
                        this.state.allFilters,
                        this.state.appliedFilters,
                        this.state.searchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    resultAbstractList = (results, itemsPerPage, currentPage) => {
        if (this.state.selectedTab == '1') {
            const results1 = results.filter((result) => result.relevant === this.state.isRelevantAbstract)
            try {
                let { abstractCollapsedSearchIDs, abstractsSearchKeyword, attachedFiles } = this.state;
                var startIndex;
                startIndex = currentPage * itemsPerPage - itemsPerPage;
                var count = startIndex;
                let displayedResults = [];
                let displayedResultsUrl = [];
                this.resultListRef.current = Array.from({ length: results.length }, i => i)
                return (<>
                    {((attachedFiles && attachedFiles.length > 0) || abstractsSearchKeyword) && <div className="relevant-non-relevant-filter-container">
                        <div
                            className="pubmed-search-relevant-outer-box relevant-filter-container"
                            onClick={() => this.setState({ ...this.state, isRelevantAbstract: "True" })}>
                            <div className="pubmed-search-relevant-box relevant-filter-box relevant-box-width">
                                {this.state.isRelevantAbstract == "True" && (
                                    <svg
                                        fill="#000000"
                                        width="14px"
                                        height="14px"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21ZM17.737,8.824a1,1,0,0,1-.061,1.413l-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,0,1,1.415-1.414l2.323,2.323,5.294-4.853A1,1,0,0,1,17.737,8.824Z"></path>
                                        </g>
                                    </svg>
                                )}
                                <span className="mx-1">Highly Responsive</span>
                            </div>
                        </div>
                        <div
                            className="pubmed-search-relevant-outer-box non-relevant-filter-container"
                            onClick={() => this.setState({ ...this.state, isRelevantAbstract: "False" })}
                        >
                            <div className="pubmed-search-not-relevant-box non-relevant-filter-box">
                                {this.state.isRelevantAbstract == "False" && (
                                    <svg
                                        fill="#000000"
                                        width="14px"
                                        height="14px"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21ZM17.737,8.824a1,1,0,0,1-.061,1.413l-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,0,1,1.415-1.414l2.323,2.323,5.294-4.853A1,1,0,0,1,17.737,8.824Z"></path>
                                        </g>
                                    </svg>
                                )}
                                <span className="mx-1">Responsive</span>
                            </div>
                        </div>
                    </div>}
                    {(() => {
                        if (results.length > 0) {
                            return (
                                <>
                                    {results1?.length ?
                                        <div className="pubmed-main-right-section-result-list box-white-main">
                                            <div
                                                className="sticky top-16 z-2 overflow-hidden rounded-border-20 bg-white/95 backdrop-blur dark:bg-secondary-950/75"
                                                ref={(el) => {
                                                    this.scrollingTableHeader = el;
                                                }}
                                                id="scrolling-table-header"
                                            ></div>
                                            <div
                                                className="overflow-x-auto pubmed-main-right-section-result-list-body pt-1"
                                                onScroll={(e) => this.handleScroll(e)}
                                            >
                                                <div >
                                                    {results1.map((item, index) => {
                                                        count++;
                                                        if (
                                                            item.highlight === undefined ||
                                                            item.highlight?.body[0] === "Empty File" ||
                                                            item.highlight?.body[0] === "Not an empty file"
                                                        ) {
                                                            displayedResults.push({
                                                                detail: item,
                                                                itemTeaser: [],
                                                                index: index + 1,
                                                            });
                                                            // item.highlight = { 'body': ['Test body until indexed value is available'] }
                                                        } else {
                                                            displayedResults.push({
                                                                detail: item,
                                                                itemTeaser: item.highlight.body,
                                                                index: index + 1,
                                                            });
                                                        }
                                                        let responseSearchIDs = item.rli_id;
                                                        let globalCollapseAll = abstractCollapsedSearchIDs.some(
                                                            (x) => x === responseSearchIDs
                                                        );
                                                        return (
                                                            <>
                                                                <div
                                                                    key={`result-id-${index}`}
                                                                    id={`result-id-${index}`}
                                                                    className="mx-1 mb-2 rounded-2xl border-2 border-secondary-100 pubmed-main-result-item-border"
                                                                >
                                                                    <PubMedDocumentCard
                                                                        tab={1}
                                                                        item={item}
                                                                        count={count}
                                                                        appliedFilters={this.state.appliedFilters}
                                                                        searchKeyword={this.state.searchKeyword}
                                                                        pageNumber={this.state.currentAbstractPage}
                                                                        pageSize={this.state.itemsPerAbstractPage}
                                                                        itemTeaser={
                                                                            item.highlight === undefined ||
                                                                                item.highlight?.body[0] === "Empty File" ||
                                                                                item.highlight?.body[0] === "Not an empty file"
                                                                                ? []
                                                                                : item.highlight.body
                                                                        }
                                                                        handleCitationSelection={(i, item, itemTeaser) =>
                                                                            this.handleAbstractCitationSelection(
                                                                                i,
                                                                                item,
                                                                                itemTeaser,
                                                                                index
                                                                            )
                                                                        }
                                                                        isChecked={
                                                                            this.state.abstractSelectStatus[count - 1]
                                                                        }
                                                                        customWidth={this.state.width}
                                                                        //globalCollapseAll={this.state.globalCollapseAll}
                                                                        globalCollapseAll={globalCollapseAll}
                                                                        csPath={this.state.csPath}
                                                                        csproduct={this.state.csproduct}
                                                                        citationUrl={(url) =>
                                                                            this.citationUrl(
                                                                                url,
                                                                                index,
                                                                                item._source,
                                                                                displayedResultsUrl
                                                                            )
                                                                        }
                                                                        manageCollapseAndExpand={
                                                                            this.manageAbstractCollapseAndExpand
                                                                        }
                                                                        selectedTab={this.state.selectedTab}
                                                                        handleRef={this.handleRef}
                                                                        index={index}
                                                                    />
                                                                    {/* <div className="resultsDivFooter"></div> */}
                                                                </div>
                                                            </>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                            {localStorage.setItem(
                                                "displayedAbstractResults",
                                                JSON.stringify(displayedResults)
                                            )}
                                        </div>
                                        :
                                        <div className="results-no-search-content pubmed-results-no-search-content">
                                            <span>Nothing here matches against {this.state.isRelevantAbstract == "True" ? "Relevant" : "Non Relevant"} filter</span>
                                        </div>
                                    }
                                </>
                            );
                        } else {
                            localStorage.removeItem("displayedAbstractResults");
                            return (
                                <div className="results-no-search-content pubmed-results-no-search-content">
                                    <span>Nothing here matches your search</span>
                                    <br />
                                    <br />
                                    <span>Suggestions</span>
                                    <li>
                                        <b>Upload document</b>
                                    </li>
                                    <li>Make sure all words are spelled correctly</li>
                                    <li>Try different search terms</li>
                                    <li>Try more general search terms</li>
                                    <li>Try fewer search terms</li>
                                </div>
                            );
                        }
                    })()}</>)
            } catch (error) {
                this.setState({ error: error, errorExpand: true });
            }
        }

        return <></>
    };
    handleAbstractViewDetails = () => {
        let { abstractsSelected, abstractsResponse } = this.state;
        if (abstractsSelected.length === 1) {
            let selectedDetails = abstractsResponse.find(
                (x) => x.rowIndex === abstractsSelected[0]
            );
            this.setState({
                showViewabstractDetailPop: true,
                viewAbstractsDetail: selectedDetails,
            });
        } else if (abstractsSelected.length === 0) {
            this.errorAlertMessage("Kindly select one abstract item.");
        } else if (abstractsSelected.length > 1) {
            this.errorAlertMessage("Kindly select only one abstract item.");
        }
    };
    // handleAbstractSelectAll = (isChecked) => {
    //     try {
    //         this.setState(
    //             {
    //                 abstractsSelected: isChecked ? this.state.abstractsResponse.map(r => r.rli_id) : [],
    //                 globalAbstractSelectAll: isChecked,
    //             });
    //     } catch (error) {
    //         this.setState({ error: error, errorExpand:true });
    //     }
    // };
    handleAbstractSelect = (selectedItems) => {
        try {
            this.setState({
                abstractsSelected: selectedItems,
                globalAbstractSelectAll:
                    this.state.abstractsResponse.length === selectedItems.length,
            }, () => {
                let a = this.state.abstractSelectStatus;
                let data = [];// this.state.selectedAbstractResults;
                this.state.abstractsResponse.map((item, index) => {
                    if (selectedItems.includes(item.rowIndex)) {
                        a[index] = true;
                        data.push({
                            detail: item,
                            index: index,
                        });
                    }
                })
                this.setState({
                    abstractSelectStatus: a,
                    selectedAbstractResults: data,
                });
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    createErrorHtml = () => {
        if (this.state.error.response) {
            let _JSON = this.state.error.response.data;
            let mailbody = "";
            if (_JSON) {
                mailbody = encodeURIComponent(JSON.stringify(_JSON));
            }
            return (
                <>
                    <p style={{ wordBreak: "break-all" }}>
                        <b>ERROR: </b>
                        {_JSON.ERROR}
                        <br />
                        <b>MESSAGE: </b>
                        {_JSON && _JSON.message ? <>
                            {_JSON.message}
                        </> :
                            <>
                                {(_JSON.detail && _JSON.detail.length > 0 && _JSON.detail[0].msg) ? <>{_JSON.detail[0].msg}</> : <>{_JSON.MESSAGE}</>}
                            </>}

                        <br />
                        {(_JSON && _JSON.stackTrace) && <>
                            <b>STACKTRACE: </b>
                            {_JSON.stackTrace}
                            <br />
                        </>}
                        {(_JSON.detail && _JSON.detail.length > 0 && _JSON.detail[0].type) && <>
                            <b>TYPE: </b>
                            {_JSON.detail[0].type}
                            <br />
                        </>}
                        <br />
                        <b> Please contact{" "}
                            <a
                                href={`mailto:imks.jnj.com?subject= iMS PubMed2.0 Query Error - ${_JSON["REQUEST-ID"]}&body=${mailbody}`}
                            >
                                iMedical Search Support Team
                            </a></b>

                    </p>
                </>
            );
        } else {
            return this.state.error.message;
        }
    };
    handleOnTabClickresponsive = async (event, check) => {
        let tabId = event.target.id;
        this.setState({
            selectedTabResponsive: tabId.split("-")[0],
        });
        if (tabId.split("-")[0] === "7" && check) {
            await this.handleReleventNonreleventFilter(true)
        } else if (tabId.split("-")[0] === "8" && !check) {
            await this.handleReleventNonreleventFilter(false)
        }
    }

    handleOnTabClickUploadAbstracts = async (event, check) => {
        let tabId = event.target.id;
        if (
            tabId.split("-")[0] === "9" ||
            tabId.split("-")[0] === "10"
        ) {
            this.setState({
                selectedTabResUploadAbstract: tabId.split("-")[0],
            });
        } else {
            this.setState({
                selectTabResOtherUploadAbstract: tabId.split("-")[0],
            });
        }

        if ((tabId.split("-")[0] === "9" && check) || (tabId.split("-")[0] === "11" && check)) {
            await this.handleReleventNonreleventFilterforOvidAbstract(true)
        } else if ((tabId.split("-")[0] === "10" && !check) || (tabId.split("-")[0] === "12" && !check)) {
            await this.handleReleventNonreleventFilterforOvidAbstract(false)
        }
    }


    handleOnTabSaveSearch = async (event, check) => {
        let tabId = event.target.id;
        this.setState({
            selectTabResSaveSearch: tabId.split("-")[0],
        });
        if (tabId.split("-")[0] === '13' && check) {
            await this.handleReleventNonreleventFilterForSaveSearch(true)
        } else if (tabId.split("-")[0] === '14' && !check) {
            await this.handleReleventNonreleventFilterForSaveSearch(false)
        }
    }

    handleOnTabClick = (evt) => {
        let tabId = evt.target.id;
        if (
            tabId.split("-")[0] === "3" ||
            tabId.split("-")[0] === "2" ||
            tabId.split("-")[0] === "1" ||
            tabId.split("-")[0] === "0"
        ) {
            let isOpenReviewList = tabId.split("-")[0] === "2";// && this.state.selectedTab !== tabId.split("-")[0];
            let isOpenSaveSearches = tabId.split("-")[0] === "3";// && this.state.selectedTab !== tabId.split("-")[0];
            this.resultListRef.current = []
            this.setState({
                selectedTab: tabId.split("-")[0],
                showReviewListPop: isOpenReviewList,
                showSaveSearchPop: isOpenSaveSearches,
                openManageInPubmedAlert: false,
                showPersonalAlerts: false,
                error: "",
                errorHTML: "",
            });
        } else if (tabId.split("-")[0] === "4") {
            let isOpenReviewList = tabId.split("-")[0] === "2";// && this.state.selectedTab !== tabId.split("-")[0];
            let isOpenSaveSearches = tabId.split("-")[0] === "3";// && this.state.selectedTab !== tabId.split("-")[0];
            this.resultListRef.current = []
            this.setState({
                selectedTab: tabId.split("-")[0],
                showPersonalAlerts: true,
                openManageInPubmedAlert: true,
                showReviewListPop: isOpenReviewList,
                showSaveSearchPop: isOpenSaveSearches,
                error: "",
                errorHTML: "",
                fromGlobalTab: true
            });
        }
    };
    handleChangeInAbstractsSearch = (query) => {
        this.setState(
            {
                abstractsSearchKeyword: query,
                isOvidAbstractReleventSelected: true,
            },
            async () => {
                if (this.state.error !== "") {
                    this.setState({ error: "" });
                }
                if (this.state.attachedFiles.length === 0) {
                    this.errorAlertMessage("Kindly upload document.");
                } else if (query) {
                    await this.runUploadAbstractEvaluate(query);
                }
            }
        );
    };

    fileInputChange = (event) => {
        const files = event.target.files;

        let isExcelUpload = Object.keys(files).some(
            (x) =>
                files[x].name.toLowerCase().endsWith(".xlsx") ||
                files[x].name.toLowerCase().endsWith(".xls") ||
                files[x].name.toLowerCase().endsWith(".xltx") ||
                files[x].name.toLowerCase().endsWith(".xltm") ||
                files[x].name.toLowerCase().endsWith(".xltm")
        );

        if (!isExcelUpload) {
            this.errorAlertMessage(
                "Invalid file format. Only Excel file is accepted."
            );
            this.setState({ mathRandom: Math.random() });
        } else {
            let _attachedFiles = [];
            for (var i = 0; i < Object.keys(files).length; i++) {
                let file = files[i];
                file.guid = uuidv4();
                file.newFileName = file.name;
                _attachedFiles.push(file);
            }
            var threadGuid = uuidv4();
            this.setState(
                { newAttachedFiles: _attachedFiles },
                async () => {
                    await this.runMultipleFilesUpload();
                }
            );
        }
    };

    processElasticOvidData = async (response) => {
        for (let i = 0; i < response.body.hits.hits.length; i++) {
            //response.body.hits.hits.map((hitItem, rindex) => {
            let ritem = clone(response.body.hits.hits[i]._source);
            let _authors = ritem.AU.split("\n\n");
            let ovidMappingItem = {
                ...ritem,
                title: ritem.TI,
                authors: _authors,
                mpYear: ritem.YR,
                //doi: '',
                source: {
                    location: "",
                    name: ritem.SO,
                    year: null,
                },
                PMID: ritem.PMID ? ritem.PMID : ritem.PM,
                body: ritem.AB,
                pubMed: ritem.DB,
                CN: ritem.CN,
                rli_id: uuidv4(),
                doi: ritem.DO ? ritem.DO.replace("https://dx.doi.org/", "") : "",
                publicationDate: ritem.DP ? moment(ritem.DP).format("YYYY-MM-DD") : null,
                PMCID: ritem.PMCID ? ritem.PMCID : null,
                relevant: ritem.relevant ? ritem.relevant : "False",
                summary: ritem.summary ? ritem.summary : null,
                keypoints: ritem.keypoints ? ritem.keypoints : null,
            };
            delete ovidMappingItem["TI"];
            delete ovidMappingItem["AU"];
            delete ovidMappingItem["YR"];
            delete ovidMappingItem["SO"];
            delete ovidMappingItem["PM"];
            delete ovidMappingItem["AB"];
            delete ovidMappingItem["DB"];
            delete ovidMappingItem["CN"];
            delete ovidMappingItem["DO"];
            delete ovidMappingItem["DP"];
            // delete ovidMappingItem["_pmcid"];
            // delete ovidMappingItem["_pmid"];
            delete ovidMappingItem["keypoints"];
            Object.keys(ovidMappingItem).map((y) => {
                if (typeof ovidMappingItem[y] === "number" && y !== "mpYear") {
                    ovidMappingItem[y] = `${ovidMappingItem[y]}`;
                }
            });
            response.body.hits.hits[i]._source = ovidMappingItem;
            //});
        }
        return response;
    };
    processOvidData = async (response) => {
        let ovidMappingItems = [];
        response.map((ritem, rindex) => {
            let _authors = ritem.AU.split("\n\n");
            let ovidMappingItem = {
                ...ritem,
                title: ritem.TI,
                authors: _authors,
                mpYear: ritem.YR,
                //doi: '',
                source: {
                    location: "",
                    name: ritem.SO,
                    year: null,
                },
                PMID: ritem._pmid ? ritem._pmid : ritem.PM,
                body: ritem.AB,
                pubMed: ritem.DB,
                CN: ritem.CN,
                rli_id: uuidv4(),
                doi: ritem.DO ? ritem.DO.replace("https://dx.doi.org/", "") : "",
                publicationDate: ritem.DP ? moment(ritem.DP).format("YYYY-MM-DD") : null,
                PMCID: ritem._pmcid ? ritem._pmcid : null,
                relevant: ritem.relevant ? ritem.relevant : "False",
                summary: ritem.summary ? ritem.summary : null,
            };
            delete ovidMappingItem["TI"];
            delete ovidMappingItem["AU"];
            delete ovidMappingItem["YR"];
            delete ovidMappingItem["SO"];
            delete ovidMappingItem["PM"];
            delete ovidMappingItem["AB"];
            delete ovidMappingItem["DB"];
            delete ovidMappingItem["CN"];
            delete ovidMappingItem["DO"];
            delete ovidMappingItem["DP"];
            delete ovidMappingItem["_pmcid"];
            delete ovidMappingItem["_pmid"];
            Object.keys(ovidMappingItem).map((y) => {
                if (typeof ovidMappingItem[y] === "number" && y !== "mpYear") {
                    ovidMappingItem[y] = `${ovidMappingItem[y]}`;
                }
            });
            ovidMappingItems.push(ovidMappingItem);
        });
        return ovidMappingItems;
    };

    handleRemoveAttachedFile = async () => {
        this.handleClearOvidAbstractFilters()
        this.setState(
            {
                abstractsResetInfo: null,
                isAttachedFile: false,
                abstractXSearchId: "",
                abstractsSearchKeyword: "",
                itemsPerAbstractPage: "25",
                currentAbstractPage: "1",
                documentAbstractCount: 0,
                itemsPerOvidAbstractPage: "50",
                itemsPerOvidAbstractPageHighlyResponsive: "50",
                itemsPerOvidAbstractPageResponsive: "50",
                currentOvidAbstractPage: "1",
                documentOvidAbstractCount: 0,
                attachedFiles: [],
                uploadFilePlaceHolder: "",
                uploadFilePlaceHolderTitle: "",
                updateAnyFile: false,
                newAttachedFiles: [],
                useTemplate: "OVID",
                abstractsResponse: [],
                abstractsAnswer: [],
                ovidAbstractResponse: [],
                ovidAbstractAnswer: [],
                globalAbstractCollapseAll: false,
                globalAbstractSelectAll: false,
                abstract_column_names: this.preSelectedValues["OVID"],
                abstractsSelected: [],
                showViewabstractDetailPop: false,
                viewAbstractsDetail: null,
                showReviewListPop: false,
                isRelevantAbstract: "False",
                abstractSelectStatus: [],
                abstractCollapsedSearchIDs: [],
                selectedAbstractResults: [],
                isAnyChangeAfterAbstractResult: false,
            },

            async () => {
                this.successAlertMessage("Document removed successfully.");
            }

        );
    };
    handleOnChangeUseTemplate = (event) => {
        this.setState({
            useTemplate: event.target.value,
            abstract_column_names: this.preSelectedValues[event.target.value],
        });
    };
    manageFilePlaceHolder() {
        let { attachedFiles } = this.state;
        let uploadFilePlaceHolder = "",
            uploadFilePlaceHolderTitle = "";
        if (attachedFiles.length > 0) {
            let singleFile = attachedFiles[0];
            uploadFilePlaceHolder = this.getAttachedFileName(singleFile);
            uploadFilePlaceHolderTitle = singleFile.name;
        }
        this.setState({
            uploadFilePlaceHolder: uploadFilePlaceHolder,
            uploadFilePlaceHolderTitle: uploadFilePlaceHolderTitle,
            isAttachedFile: attachedFiles.length > 0,
        });
    }
    getAttachedFileName(singleFile) {
        let filename = singleFile.name.split(".").slice(0, -1).join(".");
        let fileExtention =
            singleFile.name.substring(
                singleFile.name.lastIndexOf(".") + 1,
                singleFile.name.length
            ) || singleFile.name;
        filename = this.snippetLongStringForKeyword(filename);
        return `${filename} .${fileExtention}`;
    }
    snippetLongStringForKeyword = (snippet, strLength = 25) => {
        if (snippet.length > strLength) {
            let text = snippet.substring(0, strLength); //cuts to 70
            text = text + `...`; //adds (...) at the end to show that it's cut
            return text;
        }
        return snippet;
    };
    renderViewDetails = () => {
        let { viewAbstractsDetail } = this.state;
        return (
            <table className="table table-bordered">
                <tbody>
                    {Object.keys(viewAbstractsDetail).map(
                        (viewAbstractItemKey, viewAbstractIndex) => {
                            if (viewAbstractItemKey === 'processed_merged_abs_body' ||
                                viewAbstractItemKey === 'rowIndex' ||
                                viewAbstractItemKey === 'userID' ||
                                viewAbstractItemKey === 'searchID' ||
                                viewAbstractItemKey === 'resultID' ||
                                viewAbstractItemKey === 'rli_id'
                            ) {
                                return <></>
                            }
                            return (
                                <>
                                    {viewAbstractItemKey === 'relevant' ?
                                        (<tr key={viewAbstractIndex}>
                                            <th>{viewAbstractItemKey}</th>
                                            <td>{viewAbstractsDetail[viewAbstractItemKey] == "True" ? "Highly Responsive" : "Responsive"}</td>
                                        </tr>) :
                                        (<tr key={viewAbstractIndex}>
                                            <th>{viewAbstractItemKey}</th>
                                            <td>{viewAbstractsDetail[viewAbstractItemKey]}</td>
                                        </tr>)
                                    }
                                </>
                            );
                        }
                    )}
                </tbody>
            </table>
        );
    };

    // region reviewList
    handleRemoveReviewList = (reviewId) => {
        const { currentReviewListId } = this.state
        const currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        if (reviewId === currentReviewListId) {
            this.setState({
                titleNameReviewList: "",
                selectedReviewListResults: [],
                citationReviewListSelectStatus: [],
                reviewListCollapsedSearchIDs: [],
                reviewListFilters: {},
                allReviewListFilters: {},
                appliedReviewListFilters: [],
                selectedReviewListFilters: [],
                selectedParentReviewListFilterArr: [],
                reviewListResponse: [],
                reviewListAnswers: [],
                globalReviewListCollapseAll: false,
                globalReviewListSelectAll: false,
                currentReviewListPage: "1",
                documentReviewListCount: 0,
                itemsPerReviewListPage: "25",
                reviewListSearchKeyword: '',
                reviewListFromYear: currentYear - 5,
                reviewListToYear: currentYear,
                reviewListsortBy: "",
                reviewListsortField: "",
                reviewListSortByValue: "Relevance",
                isReviewListReleventSelected: true,
                showReviewListPop: false
            })
        }
    }

    async getAllReviewListData(reviewId, query, reviewListName) {
        const currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        this.setState({
            titleNameReviewList: reviewListName,
            selectedReviewListResults: [],
            citationReviewListSelectStatus: [],
            reviewListCollapsedSearchIDs: [],
            reviewListFilters: {},
            allReviewListFilters: {},
            appliedReviewListFilters: [],
            selectedReviewListFilters: [],
            selectedParentReviewListFilterArr: [],
            reviewListResponse: [],
            reviewListAnswers: [],
            globalReviewListCollapseAll: false,
            globalReviewListSelectAll: false,
            currentReviewListPage: "1",
            documentReviewListCount: 0,
            itemsPerReviewListPage: "25",
            reviewListSearchKeyword: '',
            selectedTab: "2",
            reviewListFromYear: currentYear - 5,
            reviewListToYear: currentYear,
            reviewListsortBy: "",
            reviewListsortField: "",
            reviewListSortByValue: "Relevance",
            isReviewListReleventSelected: true,
        }, async () => {
            const prarms = {
                filters: "",
                from_: this.state.currentReviewListPage * this.state.itemsPerReviewListPage -
                    this.state.itemsPerReviewListPage,
                size: this.state.itemsPerReviewListPage,
                sortBy: this.state.reviewListsortBy,
                sortField: this.state.reviewListsortField,
                query: "",
                // "query": "Talquetamab",
                reviewListId: reviewId,
                fromYear: this.state.reviewListFromYear,
                toYear: this.state.reviewListToYear,
                //tab: "relevant",
                get_final_answering: this.state.reviewList_get_final_answering
            }
            this.setState({
                isProcessing: true,
                //  isLoaded: false
            })
            try {

                var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist`;
                if (window.location.origin === "https://predev-ims.jnj.com") {
                    url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist`;
                }
                const _headers = {
                    "Content-Type": "application/json"
                }
                if (await Authentication.isAccessTokenAvailable()) {
                    const token = await Authentication.getAccessToken();
                    _headers.Authorization = `Bearer ${token}`;
                }
                await axios({
                    method: 'POST',
                    url: url,
                    headers: _headers,
                    data: JSON.stringify(prarms),
                    timeout: _timeoutTime,
                }).then((res) => {
                    res.data.body.hits.hits.map((hitItem, hitIndex) => {
                        hitItem._source.old_rli_id = clone(hitItem._source.rli_id);
                        hitItem._source.rli_id = uuidv4();
                    });
                    var processedFilters = processPubMedFilters(
                        res.data.body
                    );
                    const filterService = new FilterService();
                    const [filters] = filterService.expandFilterSet(
                        processedFilters,
                        this.state.appliedReviewListFilters
                    );
                    let selectedFiltered = this.state.appliedReviewListFilters.concat(filters);
                    this.setState({
                        ...this.state,
                        allReviewListFilters: processedFilters,
                        reviewListFilters: processedFilters,
                        selectedReviewListFilters: selectedFiltered,
                        reviewListResponse: res.data.body.hits.hits,
                        reviewListAnswers: this.state.reviewList_get_final_answering ? res.data.answer : this.state.reviewListAnswers,
                        isProcessing: false,
                        documentReviewListCount: res.data.body?.hits?.total?.value || 0,
                        currentReviewListId: reviewId,
                        isReviewListReleventSelected: true,
                        reviewList_get_final_answering: false,
                        isAnyChangeAfterReviewListResult: false,

                    })
                    this.handleCloseReviewList(false)
                })
                    .catch((error) => {
                        this.setState({ error: error, errorExpand: true });
                    })
                    .finally(() => {
                        this.setState({ isProcessing: false, isLoaded: true });
                    });
            } catch (err) {
                console.error({ err })
                this.setState({ error: err, isProcessing: false })
            }
        })
    }
    async runPubmedSearchTabForReviewList(querytext, filterSelected) {
        //let { isReleventSelected } = this.state;
        let filterStr = this.generateArrayString(filterSelected);
        const prarms = {
            filters: filterStr,
            from_: this.state.currentReviewListPage * this.state.itemsPerReviewListPage -
                this.state.itemsPerReviewListPage,
            size: this.state.itemsPerReviewListPage,
            sortBy: this.state.reviewListsortBy,
            sortField: this.state.reviewListsortField,
            query: querytext,
            fromYear: this.state.reviewListFromYear,
            toYear: this.state.reviewListToYear,
            // tab: this.state.isReviewListReleventSelected ? "relevant" : "non relevant",
            // "query": "Talquetamab",
            reviewListId: this.state.currentReviewListId,
            get_final_answering: this.state.reviewList_get_final_answering,
        }

        this.setState({
            isProcessing: true,
            // isLoaded: false 
        })
        try {
            var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist`;
            if (window.location.origin === "https://predev-ims.jnj.com") {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist`;
            }
            const _headers = {
                "Content-Type": "application/json"
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            await axios({
                method: 'POST',
                url: url,
                headers: _headers,
                data: JSON.stringify(prarms),
                timeout: _timeoutTime,
            }).then((res) => {

                res.data.body.hits.hits.map((hitItem, hitIndex) => {
                    hitItem._source.old_rli_id = clone(hitItem._source.rli_id);
                    hitItem._source.rli_id = uuidv4();
                });
                var processedFilters = processPubMedFilters(
                    res.data.body
                );
                const filterService = new FilterService();
                const [filters] = filterService.expandFilterSet(
                    processedFilters,
                    this.state.appliedReviewListFilters
                );
                let selectedFiltered = this.state.appliedReviewListFilters.concat(filters);
                this.setState({
                    ...this.state,
                    allReviewListFilters: processedFilters,
                    reviewListFilters: processedFilters,
                    selectedReviewListFilters: selectedFiltered,
                    reviewListResponse: res.data?.body?.hits?.hits,
                    reviewListAnswers: this.state.reviewList_get_final_answering ? res.data.answer : this.state.reviewListAnswers,
                    isProcessing: false,
                    isLoaded: true,
                    documentReviewListCount: res.data?.body?.hits?.total?.value || 0,
                    reviewList_get_final_answering: false,
                    isAnyChangeAfterReviewListResult: true,
                })
                this.handleCloseReviewList(false)
            })
                .catch((error) => {
                    this.setState({ error: error, errorExpand: true });
                })
                .finally(() => {
                    this.setState({ isProcessing: false, isLoaded: true });
                });


        } catch (err) {
            console.error({ err })
            this.setState({ error: err, isProcessing: false, isLoaded: true })
        }
    }
    runSearchFromQueryParamsForReviewList(allfilters, appliedfilters, querytext) {
        try {
            this.setState({
                isProcessing: true,
                // isLoaded: false 

            });
            const filterService = new FilterService();
            const query = querytext;
            const inFilters = appliedfilters;
            // const [filters] = filterService.expandFilterSet(allfilters, inFilters)
            const [filters] = filterService.expandFilterSet(
                this.state.reviewListFilters,
                inFilters
            );
            const filterSelected = inFilters;
            let selectedFiltered = this.state.selectedReviewListFilters.concat(filters);
            selectedFiltered = [...new Set(selectedFiltered)];
            this.setState(
                {
                    appliedReviewListFilters: inFilters,
                    selectedReviewListFilters: selectedFiltered,
                    // selectedFilters: filters
                },
                () => {
                    // this.runPubmedSearch(query);
                    this.runPubmedSearchTabForReviewList(query, filterSelected);
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });

        }
    }
    handleYearSelectionReviewList = (newYears) => {
        try {
            this.setState(
                {
                    reviewListFromYear: newYears.min,
                    reviewListToYear: newYears.max,
                },
                () =>
                    this.setState({
                        globalReviewListSelectAll: false,
                        selectedReviewListResults: [],
                        selectedReviewListResults: [],
                    })
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleReviewListPageChange = (currentPage) => {
        try {
            window.scrollTo({ behavior: "smooth", top: "0px" });
            let checkSelectStatus = this.state.citationReviewListSelectStatus.filter(
                (item) => item
            );
            if (
                this.state.globalReviewListSelectAll &&
                (checkSelectStatus.length.toString() === this.state.itemsPerReviewListPage ||
                    this.state.citationReviewListSelectStatus.length === this.state.documentReviewListCount)
            ) {
                this.setState({ citationReviewListSelectStatus: [], selectedReviewListResults: [] });
            }
            this.setState(
                {
                    currentReviewListPage: currentPage,
                    reviewListResponse: [],
                    isProcessing: true,
                    // isLoaded: false,
                    globalReviewListCollapseAll: false,
                    globalReviewListSelectAll: false,
                    reviewListCollapsedSearchIDs: [],
                },
                () => {
                    let setSelectStatus = false;
                    let startIndex =
                        this.state.currentReviewListPage * this.state.itemsPerReviewListPage -
                        this.state.itemsPerReviewListPage;
                    let endIndex = this.state.currentReviewListPage * this.state.itemsPerReviewListPage;
                    let citationStatusForCurrentPage =
                        this.state.citationReviewListSelectStatus.slice(startIndex, endIndex);
                    setSelectStatus = citationStatusForCurrentPage.some(
                        (e) => e === true
                    );
                    if (setSelectStatus) {
                        this.setState({
                            globalReviewListSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalReviewListSelectAll: false,
                        });
                    }
                    this.runSearchFromQueryParamsForReviewList(
                        this.state.allReviewListFilters,
                        this.state.appliedReviewListFilters,
                        this.state.reviewListSearchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    gotoReviewListPage = (currentPage) => {
        try {
            this.setState(
                {
                    currentReviewListPage: currentPage,
                    reviewListResponse: [],
                    isProcessing: true,
                    isLoaded: true,
                    globalReviewListCollapseAll: false,
                    reviewListCollapsedSearchIDs: [],
                },
                () => {
                    let setSelectStatus = false;
                    let startIndex =
                        this.state.currentReviewListPage * this.state.itemsPerReviewListPage -
                        this.state.itemsPerReviewListPage;
                    let endIndex = this.state.currentReviewListPage * this.state.itemsPerReviewListPage;
                    let citationStatusForCurrentPage =
                        this.state.citationReviewListSelectStatus.slice(startIndex, endIndex);
                    setSelectStatus = citationStatusForCurrentPage.some(
                        (e) => e === true
                    );
                    if (setSelectStatus) {
                        this.setState({
                            globalReviewListSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalReviewListSelectAll: false,
                        });
                    }
                    this.runSearchFromQueryParamsForReviewList(
                        this.state.allReviewListFilters,
                        this.state.appliedReviewListFilters,
                        this.state.reviewListSearchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleOnChangeInReviewListfilter = (
        filters,
        appliedfilters,
        selectedFilters,
        response,
        doc,
        query
    ) => {
        try {
            let params = queryString.parse(this.props.location.search);
            //var filters = appliedfilters;
            filters = appliedfilters;
            let selectedFacets = this.generateSelectParentArray(appliedfilters);
            const newUrl = this.buildUrl(
                params.query,
                filters,
                false
            );
            this.props.history.push({
                pathname: "/PubMedSearch",
                search: newUrl,
                state: {
                    selectedReviewListFilters: selectedFilters,
                    allReviewListFilters: this.state.allReviewListFilters,
                    appliedReviewListFilters: appliedfilters,
                },
            });
            this.setState(
                {
                    currentReviewListPage: "1",
                    selectedParentReviewListFilterArr: selectedFacets,
                    /***/
                    collapseFilter: true,
                    /***/
                    selectedReviewListFilters: selectedFilters,
                    globalReviewListSelectAll: false,
                    selectedReviewListResults: [],
                    citationReviewListSelectStatus: [],
                },
                () => {
                    this.runSearchFromQueryParamsForReviewList(
                        this.state.allReviewListFilters,
                        appliedfilters,
                        this.state.reviewListSearchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleClearReviewListFilters = () => {
        try {
            const currentDate = new Date();
            let currentYear = currentDate.getFullYear();
            this.setState(
                {
                    selectedReviewListFilters: [],
                    appliedReviewListFilters: [],
                    selectedParentReviewListFilterArr: [],
                    appliedFiltersForOnlyiMS: [],
                    reviewListFilters: [],
                    fromYear: currentYear - 2,
                    toYear: currentYear,
                    globalReviewListSelectAll: false,
                    selectedReviewListResults: [],
                    citationReviewListSelectStatus: [],
                },
                () => {
                    let params = queryString.parse(this.props.location.search);
                    const newUrl = this.buildUrl(
                        params.query,
                        this.state.appliedFilters,
                        false,
                        false
                    );
                    this.props.history.push(newUrl);
                    // this.runSearchFromQueryParamsForReviewList(
                    //     this.state.allReviewListFilters,
                    //     this.state.appliedReviewListFilters,
                    //     this.state.reviewListSearchKeyword
                    // );
                    this.getAllReviewListData(this.state.currentReviewListId, this.state.reviewListSearchKeyword)
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleRemoveAppliedReviewListFilter = (facet) => {
        try {
            let parentFacetName = facet.split("/")[0];
            let arr = this.state.selectedParentReviewListFilterArr;
            const index = arr.indexOf(parentFacetName);
            if (index > -1) {
                arr.splice(index, 1);
            }
            this.setState(
                {
                    appliedReviewListFilters: this.state.appliedReviewListFilters.filter(
                        (filter) => !filter.startsWith(facet)
                    ),
                    selectedParentReviewListFilterArr: arr,
                    selectedReviewListFilters: this.state.selectedParentReviewListFilterArr.filter(
                        (filter) => filter && !filter.startsWith(facet)
                    ),
                    globalReviewListSelectAll: false,
                    selectedReviewListResults: [],
                    citationReviewListSelectStatus: [],
                },
                () => {
                    let params = queryString.parse(this.props.location.search);
                    const newUrl = this.buildUrl(
                        params.query,
                        this.state.appliedFilters,
                        false
                    );
                    this.props.history.push(newUrl);
                    this.runSearchFromQueryParamsForReviewList(
                        this.state.allReviewListFilters,
                        this.state.appliedReviewListFilters,
                        this.state.reviewListSearchKeyword
                    );

                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleReleventNonreleventFilterForReviewList = async (isRelevent) => {
        if (this.state.isReviewListReleventSelected != isRelevent) {
            this.setState(
                {
                    isReviewListReleventSelected: isRelevent,
                    itemsPerReviewListPage: "25",
                    currentReviewListPage: "1",
                    globalReviewListCollapseAll: false,
                    reviewListCollapsedSearchIDs: [],
                    globalReviewListSelectAll: false,
                    selectedReviewListResults: [],
                    citationReviewListSelectStatus: [],
                },
                () => {
                    this.runSearchFromQueryParamsForReviewList(
                        this.state.allReviewListFilters,
                        this.state.appliedReviewListFilters,
                        this.state.reviewListSearchKeyword
                    );
                }
            );
        }
    };
    handleReviewListChangeSelectSortBy = (e) => {
        try {
            if (
                e.target.value === "Year (oldest to newest)" ||
                e.target.value === "Year Asc"
            ) {
                this.setState({ reviewListsortBy: "asc", reviewListsortField: "mpYear" });
            } else if (
                e.target.value === "Year (newest to oldest)" ||
                e.target.value === "Year Desc"
            ) {
                this.setState({ reviewListsortBy: "desc", reviewListsortField: "mpYear" });
            } else {
                this.setState({ reviewListsortBy: "", reviewListsortField: "" });
            }
            this.setState(
                {
                    reviewListSortByValue: e.target.value,
                    citationReviewListSelectStatus: [],
                    selectedReviewListResults: [],
                    globalReviewListSelectAll: false,
                    globalReviewListCollapseAll: false,
                    reviewListCollapsedSearchIDs: [],
                },
                () => {
                    this.runSearchFromQueryParamsForReviewList(
                        this.state.allReviewListFilters,
                        this.state.appliedReviewListFilters,
                        this.state.reviewListSearchKeyword
                    );
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleReviewListChangeSelectItems = (items) => {
        try {
            let checkSelectStatus = this.state.citationReviewListSelectStatus.filter(
                (item) => item
            );
            if (
                this.state.globalReviewListSelectAll &&
                (checkSelectStatus.length.toString() === this.state.itemsPerReviewListPage ||
                    this.state.citationReviewListSelectStatus.length === this.state.documentReviewListCount)
            ) {
                this.setState({ citationReviewListSelectStatus: [], selectedReviewListResults: [] });
            }
            this.setState(
                {
                    itemsPerReviewListPage: items,
                    globalReviewListCollapseAll: false,
                    globalReviewListSelectAll: false,
                    selectedReviewListResults: [],
                    reviewListCollapsedSearchIDs: [],
                    citationReviewListSelectStatus: [],
                },
                () => {
                    let totalPages = Math.ceil(
                        this.state.documentReviewListCount / this.state.itemsPerReviewListPage
                    );
                    if (totalPages < this.state.currentReviewListPage) {
                        this.setState(
                            {
                                currentReviewListPage: totalPages,
                            },
                            () => {
                                let setSelectStatus = false;
                                let startIndex =
                                    this.state.currentReviewListPage * this.state.itemsPerReviewListPage -
                                    this.state.itemsPerReviewListPage;
                                let endIndex = this.state.currentReviewListPage * this.state.itemsPerReviewListPage;
                                let citationStatusForCurrentPage =
                                    this.state.citationReviewListSelectStatus.slice(startIndex, endIndex);
                                setSelectStatus = citationStatusForCurrentPage.some(
                                    (e) => e === true
                                );
                                if (setSelectStatus) {
                                    this.setState({
                                        globalReviewListSelectAll: true,
                                    });
                                } else {
                                    this.setState({
                                        globalReviewListSelectAll: false,
                                    });
                                }
                                this.runSearchFromQueryParamsForReviewList(
                                    this.state.allReviewListFilters,
                                    this.state.appliedReviewListFilters,
                                    this.state.reviewListSearchKeyword
                                );
                            }
                        );
                    } else {
                        this.runSearchFromQueryParamsForReviewList(
                            this.state.allReviewListFilters,
                            this.state.appliedReviewListFilters,
                            this.state.reviewListSearchKeyword
                        );
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleReviewListCitationSelection = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.citationReviewListSelectStatus;
            a[index - 1] = !this.state.citationReviewListSelectStatus[index - 1];
            let data = this.state.selectedReviewListResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.citationReviewListSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                citationReviewListSelectStatus: a,
                selectedReviewListResults: data,
            });
            let checkSelectStatus = a.filter((item) => item);
            if (checkSelectStatus.length === parseInt(this.state.itemsPerReviewListPage)) {
                this.setState({ globalReviewListSelectAll: true });
            } else if (checkSelectStatus.length === this.state.reviewListResponse.length) {
                this.setState({ globalReviewListSelectAll: true });
            } else {
                this.setState({ globalReviewListSelectAll: false });
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    manageReviewListCollapseAndExpand = (iscollapsed, rli_id) => {
        try {
            let { reviewListCollapsedSearchIDs, reviewListResponse } = this.state;
            let responseSearchIDs = reviewListResponse.map((x) => x._source.rli_id);

            if (iscollapsed) {
                reviewListCollapsedSearchIDs.push(rli_id);
            } else {
                reviewListCollapsedSearchIDs = reviewListCollapsedSearchIDs.filter((x) => x !== rli_id);
            }
            let tempGlobalCollapseAll = responseSearchIDs.every((x) =>
                reviewListCollapsedSearchIDs.includes(x)
            );
            this.setState({
                reviewListCollapsedSearchIDs: reviewListCollapsedSearchIDs,
                globalReviewListCollapseAll: tempGlobalCollapseAll,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleReviewListCollapseAllGlobal = () => {
        try {
            let { reviewListResponse, reviewListCollapsedSearchIDs } = this.state;
            let collapsedSearchIDs
            if (!this.state.globalReviewListCollapseAll) {
                collapsedSearchIDs = reviewListResponse.map((x) => x._source.rli_id);
            } else {
                collapsedSearchIDs = [];
            }
            this.setState({
                globalReviewListCollapseAll: !this.state.globalReviewListCollapseAll,
                reviewListCollapsedSearchIDs: collapsedSearchIDs,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleReviewListSelectAll = () => {
        try {
            this.setState(
                {
                    globalReviewListSelectAll: !this.state.globalReviewListSelectAll,
                },
                () => {
                    let startIndex =
                        this.state.currentReviewListPage * this.state.itemsPerReviewListPage -
                        this.state.itemsPerReviewListPage +
                        1;
                    var count = startIndex;
                    let endIndex = this.state.itemsPerReviewListPage;
                    if (this.state.globalReviewListSelectAll) {
                        this.markedDocumentsUrl = [];
                        this.setState({ selectedReviewListResults: [] }, () => {
                            for (let i = 1; i <= endIndex; i++) {
                                if (this.state.reviewListResponse[i - 1] !== undefined) {
                                    this.handleReviewListCitationSelectionGlobal(
                                        count,
                                        this.state.reviewListResponse[i - 1]._source,
                                        this.state.reviewListResponse[i - 1].highlight === undefined ||
                                            this.state.reviewListResponse[i - 1].highlight?.body[0] ===
                                            "Empty File" ||
                                            this.state.reviewListResponse[i - 1].highlight?.body[0] ===
                                            "Not an empty file"
                                            ? []
                                            : this.state.reviewListResponse[i - 1].highlight.body,
                                        i
                                    );
                                    count++;
                                }
                            }
                        });
                    } else {
                        for (let i = 1; i <= endIndex; i++) {
                            if (this.state.reviewListResponse[i - 1] !== undefined) {
                                this.handleReviewListCitationUnSelection(
                                    count,
                                    this.state.reviewListResponse[i - 1]._source,
                                    this.state.reviewListResponse[i - 1].highlight === undefined ||
                                        this.state.reviewListResponse[i - 1].highlight?.body[0] ===
                                        "Empty File" ||
                                        this.state.reviewListResponse[i - 1].highlight?.body[0] ===
                                        "Not an empty file"
                                        ? []
                                        : this.state.reviewListResponse[i - 1].highlight.body
                                );
                                count++;
                            }
                        }
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleReviewListCitationSelectionGlobal = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.citationReviewListSelectStatus;
            a[index - 1] = true;
            let data = this.state.selectedReviewListResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.citationReviewListSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key - 1]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                citationReviewListSelectStatus: a,
                selectedReviewListResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleReviewListCitationUnSelection = (index, item, itemTeaser) => {
        try {
            let a = this.state.citationReviewListSelectStatus;
            a[index - 1] = false;
            let data = this.state.selectedReviewListResults;
            let urls = this.markedDocumentsUrl;
            /* if (this.state.citationReviewListSelectStatus[index - 1]) {
                                    data.push({
                                        detail: item,
                                        itemTeaser: itemTeaser,
                                        index: index,
                                    })
                                }
                                else { */
            const i = data.map((x) => x.index).indexOf(index);
            if (i > -1) {
                data.splice(i, 1); // 2nd parameter means remove one item only
                urls.splice(i, 1);
            }
            /* } */
            // let selectedResultsDetails = data;
            // sessionStorage.setItem("selectedResultsDetails", JSON.stringify(selectedResultsDetails));
            // let selectedResultsIndex = data.map(x => x.index)
            // localStorage.setItem('selectedResults', selectedResultsIndex)
            this.markedDocumentsUrl = urls;
            this.setState({
                citationReviewListSelectStatus: a,
                selectedReviewListResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    getSelectedReviewListCitationDetails = () => {
        try {
            if (this.state.selectedReviewListResults.length > 0) {
                let selectedResultsDetails = this.state.selectedReviewListResults;
                sessionStorage.setItem(
                    "selectedResultsDetails",
                    JSON.stringify(selectedResultsDetails)
                );
                let selectedResultsIndex = this.state.selectedReviewListResults.map(
                    (x) => x.index
                );
                localStorage.setItem("selectedReviewListResults", selectedResultsIndex);
                /** */
                localStorage.setItem(
                    "markedResultsUrl",
                    JSON.stringify(this.markedDocumentsUrl)
                );
                localStorage.setItem("ItemsPerPage", this.state.itemsPerReviewListPage);
                localStorage.setItem("ActivePage", this.state.currentReviewListPage);
                this.props.history.push({
                    pathname: "/viewmarked",
                    state: { selectedReviewListResults: this.state.selectedReviewListResults },
                });
            } else {
                alert("There are no documents selected");
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    resultReviewList = (results, itemsPerPage, currentPage) => {
        if (this.state.selectedTab == '2') {
            try {
                let { reviewListCollapsedSearchIDs, currentReviewListId } = this.state;
                var startIndex;
                startIndex = currentPage * itemsPerPage - itemsPerPage;
                var count = startIndex;
                let displayedResults = [];
                let displayedResultsUrl = [];
                this.resultListRef.current = Array.from({ length: results.length }, i => i)
                return (<>
                    {/* {currentReviewListId && <div className="relevant-non-relevant-filter-container">
                        <div
                            className="pubmed-search-relevant-outer-box relevant-filter-container"
                            onClick={() => this.handleReleventNonreleventFilterForReviewList(true)}
                        >
                            <div className="pubmed-search-relevant-box relevant-filter-box relevant-box-width">
                                {this.state.isReviewListReleventSelected && (
                                    <svg
                                        fill="#000000"
                                        width="14px"
                                        height="14px"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21ZM17.737,8.824a1,1,0,0,1-.061,1.413l-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,0,1,1.415-1.414l2.323,2.323,5.294-4.853A1,1,0,0,1,17.737,8.824Z"></path>
                                        </g>
                                    </svg>
                                )}
                                <span className="mx-1">Highly Responsive</span>
                            </div>
                        </div>
                        <div
                            className="pubmed-search-relevant-outer-box non-relevant-filter-container"
                            onClick={() => this.handleReleventNonreleventFilterForReviewList(false)}
                        >
                            <div className="pubmed-search-not-relevant-box non-relevant-filter-box">
                                {!this.state.isReviewListReleventSelected && (
                                    <svg
                                        fill="#000000"
                                        width="14px"
                                        height="14px"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21ZM17.737,8.824a1,1,0,0,1-.061,1.413l-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,0,1,1.415-1.414l2.323,2.323,5.294-4.853A1,1,0,0,1,17.737,8.824Z"></path>
                                        </g>
                                    </svg>
                                )}
                                <span className="mx-1">Responsive</span>
                            </div>
                        </div>
                    </div>} */}
                    <div className="relevant-non-relevant-filter-container"></div>
                    {(() => {
                        if (results.length > 0) {
                            return (
                                <>
                                    <div className="pubmed-main-right-section-result-list box-white-main">
                                        <div
                                            className="sticky top-16 z-2 overflow-hidden rounded-border-20 bg-white/95 backdrop-blur dark:bg-secondary-950/75"
                                            ref={(el) => {
                                                this.scrollingTableHeader = el;
                                            }}
                                            id="scrolling-table-header"
                                        ></div>
                                        <div
                                            className="overflow-x-auto pubmed-main-right-section-result-list-body pt-1"
                                            onScroll={(e) => this.handleScroll(e)}
                                        >
                                            {/* <div className="min-w-1200px"> */}
                                            <div>
                                                {results.map((item, index) => {
                                                    count++;
                                                    if (
                                                        item.highlight === undefined ||
                                                        item.highlight?.body[0] === "Empty File" ||
                                                        item.highlight?.body[0] === "Not an empty file"
                                                    ) {
                                                        displayedResults.push({
                                                            detail: item._source,
                                                            itemTeaser: [],
                                                            index: index + 1,
                                                        });
                                                        // item.highlight = { 'body': ['Test body until indexed value is available'] }
                                                    } else {
                                                        displayedResults.push({
                                                            detail: item._source,
                                                            itemTeaser: item.highlight.body,
                                                            index: index + 1,
                                                        });
                                                    }
                                                    let responseSearchIDs = item._source.rli_id;
                                                    let globalCollapseAll = reviewListCollapsedSearchIDs.some(
                                                        (x) => x === responseSearchIDs
                                                    );
                                                    return (
                                                        <>
                                                            <div
                                                                key={`result-id-${index}`}
                                                                id={`result-id-${index}`}
                                                                className="mx-1 mb-2 rounded-2xl border-2 border-secondary-100 pubmed-main-result-item-border"
                                                            >
                                                                <PubMedDocumentCard
                                                                    item={item._source}
                                                                    count={count}
                                                                    appliedFilters={this.state.appliedReviewListFilters}
                                                                    searchKeyword={this.state.reviewListSearchKeyword}
                                                                    pageNumber={this.state.currentReviewListPage}
                                                                    pageSize={this.state.itemsPerReviewListPage}
                                                                    itemTeaser={
                                                                        item.highlight === undefined ||
                                                                            item.highlight?.body[0] === "Empty File" ||
                                                                            item.highlight?.body[0] === "Not an empty file"
                                                                            ? []
                                                                            : item.highlight.body
                                                                    }
                                                                    handleCitationSelection={(i, item, itemTeaser) =>
                                                                        this.handleReviewListCitationSelection(
                                                                            i,
                                                                            item,
                                                                            itemTeaser,
                                                                            index
                                                                        )
                                                                    }
                                                                    isChecked={
                                                                        this.state.citationReviewListSelectStatus[count - 1]
                                                                    }
                                                                    customWidth={this.state.width}
                                                                    //globalCollapseAll={this.state.globalCollapseAll}
                                                                    globalCollapseAll={globalCollapseAll}
                                                                    csPath={this.state.csPath}
                                                                    csproduct={this.state.csproduct}
                                                                    citationUrl={(url) =>
                                                                        this.citationUrl(
                                                                            url,
                                                                            index,
                                                                            item._source,
                                                                            displayedResultsUrl
                                                                        )
                                                                    }
                                                                    manageCollapseAndExpand={
                                                                        this.manageReviewListCollapseAndExpand
                                                                    }
                                                                    selectedTab={this.state.selectedTab}
                                                                    handleRef={this.handleRef}
                                                                    index={index}
                                                                />
                                                                {/* <div className="resultsDivFooter"></div> */}
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        {localStorage.setItem(
                                            "displayedResults",
                                            JSON.stringify(displayedResults)
                                        )}
                                    </div>
                                </>
                            );
                        } else {
                            localStorage.removeItem("displayedResults");
                            return (
                                <div className="results-no-search-content pubmed-results-no-search-content">
                                    <span>Nothing here matches your search</span>
                                    <br />
                                    <br />
                                    <span>Suggestions</span>
                                    <li>
                                        <b>Adjust the 'Publication Year'</b> (if applicable)
                                    </li>
                                    <li>Make sure all words are spelled correctly</li>
                                    <li>Try different search terms</li>
                                    <li>Try more general search terms</li>
                                    <li>Try fewer search terms</li>
                                </div>
                            );
                        }
                    })()}</>)
            } catch (error) {
                this.setState({ error: error, errorExpand: true });
            }
        }
        return <></>


    };
    resultReviewListCount = (itemsPerPage, currentPage, documentCount, response) => {
        try {
            var endIndex, startIndex;
            startIndex = currentPage * itemsPerPage - itemsPerPage;
            endIndex = currentPage * itemsPerPage;
            // var count = startIndex;
            // const totalPages = Math.ceil(this.state.documentCount / itemsPerPage);
            // const previousOff = currentPage == 1;
            // const nextOff = currentPage == totalPages;
            if (this.state.width < 600) {
                return (
                    <div
                        className="results-count-wrapper pubmed-main-right-section-result-list-count box-white-main"
                        style={{
                            justifyContent:
                                this.state.response.length > 0 ? "space-between" : "flex-end",
                        }}
                    >
                        {
                            this.state.response.length > 0 && (
                                <Pagination
                                    // metadata={this.state.documentCount}
                                    // handlePageChange={this.handlePageChange}
                                    // itemsPerPage={this.state.itemsPerPage}
                                    // page={this.state.currentPage}
                                    metadata={documentCount}
                                    handlePageChange={this.handlePageChange}
                                    itemsPerPage={itemsPerPage}
                                    page={currentPage}
                                    customWidth={this.state.width}
                                    customHeight={this.state.height}
                                />
                            )
                            // <div className="resultListCount-container">
                            //     {this.state.documentCount > 0 &&
                            //         <span className="paginationContainer-mobile">
                            //             <span className="startEndIndexText-mobile" onClick={this.navigateToFirstPage}>
                            //                 {previousOff ? null : 1}
                            //             </span>
                            //             {
                            //                 previousOff ? <img src={prdtNavButton} alt="leftArrowIcon" className="paginationArrowIcon-mobile" style={{ transform: "matrix(-1, 0, 0, -1, 0, 0)" }} /> : <img src={leftArrowMobileIcon} alt="leftArrowIcon" className="paginationArrowIcon-mobile" onClick={this.handlePreviousClick} style={{ cursor: "pointer" }} />
                            //             }
                            //             <span className="currentResultText-mobile">
                            //                 {currentPage}
                            //             </span>
                            //             {
                            //                 nextOff ? <img src={prdtNavButton} alt="rightArrowIcon" className="paginationArrowIcon-mobile" /> : <img src={rightArrowMobileIcon} alt="rightArrowIcon" className="paginationArrowIcon-mobile" onClick={this.handleNextClick} style={{ cursor: "pointer" }} />
                            //             }
                            //             <span className="startEndIndexText-mobile" onClick={this.navigateToLastPage}>
                            //                 {nextOff ? null : totalPages}
                            //             </span>
                            //         </span>
                            //     }
                            // </div>
                        }
                        <div
                            className="clearSearchContainer"
                            onClick={this.handleClearSearch}
                        >
                            <img
                                src={clearSearchMobView}
                                alt="clearSearch"
                                className="clearSearchIcon" /* onClick={this.handleClearSearch} */
                            />
                            {/* <span className="clearSearchText">Clear Search</span> */}
                        </div>
                    </div>
                );
            } else {
                return (
                    <div className={this.state.selectedTab != 2 ? "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main" :
                        "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main"}>
                        {response.length > 0 && (
                            <div className="resultListCount-container">
                                {documentCount > 0 && (
                                    <span
                                        className="showingResultsCountContainer" /* style={{ display: "flex", width: "200px" }} */
                                    >
                                        {endIndex <= documentCount ? (
                                            <div className="results-number-show-wrapper">
                                                Showing {(startIndex + 1).toLocaleString("en-us")}-
                                                {endIndex.toLocaleString("en-us")} of{" "}
                                                {documentCount.toLocaleString("en-us")}{" "}
                                                Results
                                            </div>
                                        ) : (
                                            <div className="results-number-show-wrapper">
                                                Showing {(startIndex + 1).toLocaleString("en-us")}-
                                                {documentCount.toLocaleString("en-us")} of{" "}
                                                {documentCount.toLocaleString("en-us")}{" "}
                                                Results
                                            </div>
                                        )}
                                    </span>
                                )}
                                <span
                                    style={{
                                        marginRight: "0.5%",
                                        display: "flex",
                                        width: "180px",
                                    }}
                                >
                                    <PubMedPageItems
                                        handleChangeSelectItems={this.handleReviewListChangeSelectItems}
                                        itemsPerPage={this.state.itemsPerReviewListPage}
                                        customWidth={this.state.width}
                                    />
                                </span>
                                {this.state.width >= 1000 ? (
                                    <div className="sort-by-wrapper">
                                        <span className="sort-by-text">Sort By:</span>
                                        <select
                                            className="sort-by-select-wrapper"
                                            onChange={this.handleReviewListChangeSelectSortBy}
                                            defaultValue={this.state.reviewListSortByValue}
                                            value={this.state.reviewListSortByValue}
                                        >
                                            <option value="Relevance">Relevance</option>
                                            <option>Year (oldest to newest)</option>
                                            <option>Year (newest to oldest)</option>
                                        </select>
                                    </div>
                                ) : (
                                    this.state.width >= 600 && (
                                        <div className="sort-by-wrapper">
                                            <span className="sort-by-text">Sort By:</span>
                                            <select
                                                className="sort-by-select-wrapper"
                                                onChange={this.handleReviewListChangeSelectSortBy}
                                                defaultValue={this.state.reviewListSortByValue}
                                                value={this.state.reviewListSortByValue}
                                            >
                                                <option value="Relevance">Relevance</option>
                                                <option>Year Asc</option>
                                                <option>Year Desc</option>
                                            </select>
                                        </div>
                                    )
                                )}
                            </div>
                        )}
                        {this.state.width < 1000 && (
                            <div
                                className="clearSearchContainer"
                                onClick={this.handleClearSearch}
                            >
                                <img
                                    src={clearSearchMobView}
                                    alt="clearSearch"
                                    className="clearSearchIcon"
                                />
                                {this.state.width >= 805 && (
                                    <span className="clearSearchText">Clear Search</span>
                                )}
                            </div>
                        )}
                    </div>
                );
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleChangeInReviewListSearch = async (query) => {
        this.setState(
            {
                reviewListSearchKeyword: query,
                reviewList_get_final_answering: true,
            },
            async () => {
                if (this.state.error !== "") {
                    this.setState({ error: "" });
                }
                if (query) {
                    //query
                    await this.runSearchFromQueryParamsForReviewList(this.state.allReviewListFilters, this.state.appliedReviewListFilters, query)
                    // await this.getAllReviewListData(this.state.currentReviewListId, query)
                }
            }
        );
    };
    handleCloseReviewList = (status) => {
        this.setState({
            showReviewListPop: status,
        })
    }
    handleReviewNameTitle = (name, rlID) => {
        const { currentReviewListId } = this.state
        if (currentReviewListId === rlID) {
            this.setState({
                titleNameReviewList: name
            })
        }
    }
    //end of reviewList region


    //#region SaveSearch----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    handleChangeInSaveSearchesSearch = (query) => {
        this.setState(
            {
                saveSearchSearchKeyword: query,
                isSaveSearchReleventSelected: true,
                saveSearch_get_final_answering: true,
                isAnyChangeAfterSaveSearchResult: true,
            },
            async () => {
                if (this.state.error !== "") {
                    this.setState({ error: "" });
                }
                if (query) {
                    this.runRefreshSaveSearchPubmedSearch();
                    //this.runPubmedSaveSearch(this.state.saveSearchSearchKeyword)
                    //query
                }
            }
        );
    };

    handleAllSaveSearchFilters = (
        filters,
        appliedfilters,
        selectedFilters,
        response,
        docCount,
        query
    ) => {
        try {
            this.setState({
                saveSearchFilters: filters,
                appliedSaveSearchFilters: appliedfilters,
                selectedSaveSearchFilters: selectedFilters,
                saveSearchResponse: response,
                documentSaveSearchCount: docCount,
                saveSearchSearchKeyword: query,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleSaveSearchYearSelection = (newYears) => {
        try {
            this.setState(
                {
                    fromSaveSearchYear: newYears.min,
                    toSaveSearchYear: newYears.max,
                },
                () =>
                    this.setState({
                        globalSaveSearchSelectAll: false,
                        selectedSaveSearchResults: [],
                        saveSearchSelectStatus: [],
                    })
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleSaveSearchPageChange = (currentPage) => {
        try {
            window.scrollTo({ behavior: "smooth", top: "0px" });
            let checkSelectStatus = this.state.saveSearchSelectStatus.filter(
                (item) => item
            );
            if (
                this.state.globalSaveSearchSelectAll &&
                (checkSelectStatus.length.toString() === this.state.itemsPerSaveSearchPage ||
                    this.state.saveSearchSelectStatus.length === this.state.documentSaveSearchCount)
            ) {
                this.setState({ saveSearchSelectStatus: [], selectedSaveSearchResults: [] });
            }
            this.setState(
                {
                    currentSaveSearchPage: currentPage,
                    saveSearchResponse: [],
                    isProcessing: true,
                    // isLoaded: false,
                    globalSaveSearchCollapseAll: false,
                    globalSaveSearchSelectAll: false,
                    saveSearchCollapsedSearchIDs: [],
                    isAnyChangeAfterSaveSearchResult: true,
                },
                () => {
                    let setSelectStatus = false;
                    let startIndex =
                        this.state.currentSaveSearchPage * this.state.itemsPerSaveSearchPage -
                        this.state.itemsPerSaveSearchPage;
                    let endIndex = this.state.currentSaveSearchPage * this.state.itemsPerSaveSearchPage;
                    let citationStatusForCurrentPage =
                        this.state.saveSearchSelectStatus.slice(startIndex, endIndex);
                    setSelectStatus = citationStatusForCurrentPage.some(
                        (e) => e === true
                    );
                    if (setSelectStatus) {
                        this.setState({
                            globalSaveSearchSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalSaveSearchSelectAll: false,
                        });
                    }
                    this.runPubmedSaveSearch(this.state.saveSearchSearchKeyword);
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    gotoSaveSearchPage = (currentPage) => {
        try {
            this.setState(
                {
                    currentSaveSearchPage: currentPage,
                    saveSearchResponse: [],
                    isProcessing: true,
                    isLoaded: true,
                    globalSaveSearchCollapseAll: false,
                    saveSearchCollapsedSearchIDs: [],
                    isAnyChangeAfterSaveSearchResult: true,
                },
                () => {
                    let setSelectStatus = false;
                    let startIndex =
                        this.state.currentSaveSearchPage * this.state.itemsPerSaveSearchPage -
                        this.state.itemsPerSaveSearchPage;
                    let endIndex = this.state.currentSaveSearchPage * this.state.itemsPerSaveSearchPage;
                    let citationStatusForCurrentPage =
                        this.state.saveSearchSelectStatus.slice(startIndex, endIndex);
                    setSelectStatus = citationStatusForCurrentPage.some(
                        (e) => e === true
                    );
                    if (setSelectStatus) {
                        this.setState({
                            globalSaveSearchSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalSaveSearchSelectAll: false,
                        });
                    }
                    this.runPubmedSaveSearch(this.state.saveSearchSearchKeyword);

                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleChangeSaveSearchSelectItems = (items) => {
        try {
            let checkSelectStatus = this.state.saveSearchSelectStatus.filter(
                (item) => item
            );
            if (
                this.state.globalSelectAll &&
                (checkSelectStatus.length.toString() === this.state.itemsPerSaveSearchPage ||
                    this.state.saveSearchSelectStatus.length === this.state.documentSaveSearchCount)
            ) {
                this.setState({ saveSearchSelectStatus: [], selectedSaveSearchResults: [] });
            }
            let { isSaveSearchReleventSelected, itemsPerSaveSearchPageHighlyResponsive, itemsPerSaveSearchPageResponsive } = this.state;
            this.setState(
                {
                    itemsPerSaveSearchPage: items,
                    itemsPerSaveSearchPageHighlyResponsive: isSaveSearchReleventSelected ? items : itemsPerSaveSearchPageHighlyResponsive,
                    itemsPerSaveSearchPageResponsive: isSaveSearchReleventSelected ? itemsPerSaveSearchPageResponsive : items,
                    globalSaveSearchCollapseAll: false,
                    globalSaveSearchSelectAll: false,
                    saveSearchCollapsedSearchIDs: [],
                    selectedSaveSearchResults: [],
                    saveSearchSelectStatus: [],
                    isAnyChangeAfterSaveSearchResult: true,
                },
                () => {
                    let totalPages = Math.ceil(
                        this.state.documentSaveSearchCount / this.state.itemsPerSaveSearchPage
                    );
                    if (totalPages < this.state.currentSaveSearchPage) {
                        this.setState(
                            {
                                currentPage: totalPages,
                            },
                            () => {
                                let setSelectStatus = false;
                                let startIndex =
                                    this.state.currentSaveSearchPage * this.state.itemsPerSaveSearchPage -
                                    this.state.itemsPerSaveSearchPage;
                                let endIndex = this.state.currentSaveSearchPage * this.state.itemsPerSaveSearchPage;
                                let citationStatusForCurrentPage =
                                    this.state.saveSearchSelectStatus.slice(startIndex, endIndex);
                                setSelectStatus = citationStatusForCurrentPage.some(
                                    (e) => e === true
                                );
                                if (setSelectStatus) {
                                    this.setState({
                                        globalSaveSearchSelectAll: true,
                                    });
                                } else {
                                    this.setState({
                                        globalSaveSearchSelectAll: false,
                                    });
                                }
                                this.runPubmedSaveSearch(this.state.saveSearchSearchKeyword);
                            }
                        );
                    } else {
                        this.runPubmedSaveSearch(this.state.saveSearchSearchKeyword);
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleSaveSearchOnChangeInfilter = (
        filters,
        appliedfilters,
        selectedFilters,
        response,
        doc,
        query
    ) => {
        try {
            filters = appliedfilters;
            let selectedFacets = this.generateSelectParentArray(appliedfilters);
            this.setState({
                selectedSaveSearchFilters: selectedFilters,
                allSaveSearchFilters: this.state.allSaveSearchFilters,
                appliedSaveSearchFilters: appliedfilters,
            })

            this.setState(
                {
                    currentSaveSearchPage: "1",
                    selectedParentSaveSearchFilterArr: selectedFacets,
                    collapseFilter: true,
                    selectedSaveSearchFilters: selectedFilters,
                    globalSaveSearchSelectAll: false,
                    selectedSaveSearchResults: [],
                    saveSearchSelectStatus: [],
                    isAnyChangeAfterSaveSearchResult: true,
                },
                () => {
                    this.runPubmedSaveSearch(this.state.saveSearchSearchKeyword);

                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleSaveSearchCitationSelection = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.saveSearchSelectStatus;
            a[index - 1] = !this.state.saveSearchSelectStatus[index - 1];
            let data = this.state.selectedSaveSearchResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.saveSearchSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                saveSearchSelectStatus: a,
                selectedSaveSearchResults: data,
            });
            let checkSelectStatus = a.filter((item) => item);
            if (checkSelectStatus.length === parseInt(this.state.itemsPerSaveSearchPage)) {
                this.setState({ globalSaveSearchSelectAll: true });
            } else if (checkSelectStatus.length === this.state.saveSearchResponse.length) {
                this.setState({ globalSaveSearchSelectAll: true });
            } else {
                this.setState({ globalSaveSearchSelectAll: false });
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleClearSaveSearchFilters = () => {
        try {
            const currentDate = new Date();
            let currentYear = currentDate.getFullYear();
            this.setState(
                {
                    selectedSaveSearchFilters: [],
                    appliedSaveSearchFilters: [],
                    selectedParentSaveSearchFilterArr: [],
                    appliedFiltersForOnlyiMS: [],
                    saveSearchFilters: [],
                    fromSaveSearchYear: currentYear - 5,
                    toSaveSearchYear: currentYear,
                    globalSaveSearchSelectAll: false,
                    selectedSaveSearchResults: [],
                    saveSearchSelectStatus: [],
                    itemsPerSaveSearchPage: "25",
                    itemsPerSaveSearchPageHighlyResponsive: "25",
                    itemsPerSaveSearchPageResponsive: "25",
                    currentSaveSearchPage: "1",
                    isAnyChangeAfterSaveSearchResult: true,
                },
                () => {
                    this.runPubmedSaveSearch(this.state.saveSearchSearchKeyword)
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleRemoveAppliedSaveSearchFilter = (facet) => {
        try {
            let parentFacetName = facet.split("/")[0];
            let arr = this.state.selectedParentSaveSearchFilterArr;
            const index = arr.indexOf(parentFacetName);
            if (index > -1) {
                arr.splice(index, 1);
            }
            this.setState(
                {
                    appliedSaveSearchFilters: this.state.appliedSaveSearchFilters.filter(
                        (filter) => !filter.startsWith(facet)
                    ),
                    selectedParentSaveSearchFilterArr: arr,
                    selectedSaveSearchFilters: this.state.selectedSaveSearchFilters.filter(
                        (filter) => filter && !filter.startsWith(facet)
                    ),
                    globalSaveSearchSelectAll: false,
                    selectedSaveSearchResults: [],
                    saveSearchSelectStatus: [],
                    isAnyChangeAfterSaveSearchResult: true,
                },
                () => {

                    this.runPubmedSaveSearch(this.state.saveSearchSearchKeyword)
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleSaveSearchCollapseAllGlobal = () => {
        try {
            let { saveSearchResponse, saveSearchCollapsedSearchIDs } = this.state;
            if (!this.state.globalSaveSearchCollapseAll) {
                saveSearchCollapsedSearchIDs = saveSearchResponse.map((x) => x._source.rli_id);
            } else {
                saveSearchCollapsedSearchIDs = [];
            }
            this.setState({
                globalSaveSearchCollapseAll: !this.state.globalSaveSearchCollapseAll,
                saveSearchCollapsedSearchIDs: saveSearchCollapsedSearchIDs,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleSaveSearchSelectAll = () => {
        try {
            this.setState(
                {
                    globalSaveSearchSelectAll: !this.state.globalSaveSearchSelectAll,
                },
                () => {
                    let startIndex =
                        this.state.currentSaveSearchPage * this.state.itemsPerSaveSearchPage -
                        this.state.itemsPerSaveSearchPage +
                        1;
                    var count = startIndex;
                    let endIndex = this.state.itemsPerSaveSearchPage;
                    if (this.state.globalSaveSearchSelectAll) {
                        this.markedDocumentsUrl = [];
                        this.setState({ selectedSaveSearchResults: [] }, () => {
                            for (let i = 1; i <= endIndex; i++) {
                                if (this.state.saveSearchResponse[i - 1] !== undefined) {
                                    this.handleSaveSearchCitationSelectionGlobal(
                                        count,
                                        this.state.saveSearchResponse[i - 1]._source,
                                        this.state.saveSearchResponse[i - 1].highlight === undefined ||
                                            this.state.saveSearchResponse[i - 1].highlight?.body[0] ===
                                            "Empty File" ||
                                            this.state.saveSearchResponse[i - 1].highlight?.body[0] ===
                                            "Not an empty file"
                                            ? []
                                            : this.state.saveSearchResponse[i - 1].highlight.body,
                                        i
                                    );
                                    count++;
                                }
                            }
                        });
                    } else {
                        for (let i = 1; i <= endIndex; i++) {
                            if (this.state.saveSearchResponse[i - 1] !== undefined) {
                                this.handleSaveSearchCitationUnSelection(
                                    count,
                                    this.state.saveSearchResponse[i - 1]._source,
                                    this.state.saveSearchResponse[i - 1].highlight === undefined ||
                                        this.state.saveSearchResponse[i - 1].highlight?.body[0] ===
                                        "Empty File" ||
                                        this.state.saveSearchResponse[i - 1].highlight?.body[0] ===
                                        "Not an empty file"
                                        ? []
                                        : this.state.saveSearchResponse[i - 1].highlight.body
                                );
                                count++;
                            }
                        }
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleSaveSearchCitationSelectionGlobal = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.saveSearchSelectStatus;
            a[index - 1] = true;
            let data = this.state.selectedSaveSearchResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.saveSearchSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key - 1]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                saveSearchSelectStatus: a,
                selectedSaveSearchResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleSaveSearchCitationUnSelection = (index, item, itemTeaser) => {
        try {
            let a = this.state.saveSearchSelectStatus;
            a[index - 1] = false;
            let data = this.state.selectedSaveSearchResults;
            let urls = this.markedDocumentsUrl;
            /* if (this.state.citationSelectStatus[index - 1]) {
                                    data.push({
                                        detail: item,
                                        itemTeaser: itemTeaser,
                                        index: index,
                                    })
                                }
                                else { */
            const i = data.map((x) => x.index).indexOf(index);
            if (i > -1) {
                data.splice(i, 1); // 2nd parameter means remove one item only
                urls.splice(i, 1);
            }
            /* } */
            // let selectedResultsDetails = data;
            // sessionStorage.setItem("selectedResultsDetails", JSON.stringify(selectedResultsDetails));
            // let selectedResultsIndex = data.map(x => x.index)
            // localStorage.setItem('selectedResults', selectedResultsIndex)
            this.markedDocumentsUrl = urls;
            this.setState({
                saveSearchSelectStatus: a,
                selectedSaveSearchResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    getSelectedSaveSearchCitationDetails = () => {
        try {
            if (this.state.selectedSaveSearchResults.length > 0) {
                let selectedSaveSearchResultsDetails = this.state.selectedSaveSearchResults;
                sessionStorage.setItem(
                    "selectedSaveSearchResultsDetails",
                    JSON.stringify(selectedSaveSearchResultsDetails)
                );
                let selectedSaveSearchResultsIndex = this.state.selectedSaveSearchResults.map(
                    (x) => x.index
                );
                localStorage.setItem("selectedSaveSearchResults", selectedSaveSearchResultsIndex);
                localStorage.setItem(
                    "markedResultsUrl",
                    JSON.stringify(this.markedDocumentsUrl)
                );
                localStorage.setItem("ItemsSaveSearchPerPage", this.state.itemsPerSaveSearchPage);
                localStorage.setItem("ActiveSaveSearchPage", this.state.currentSaveSearchPage);
                this.props.history.push({
                    pathname: "/viewmarked",
                    state: { selectedSaveSearchResults: this.state.selectedSaveSearchResults },
                });
            } else {
                alert("There are no documents selected");
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleRemoveSaveSearch = (saveSearchId) => {
        const { selectedSavesearchId, fromYear, toYear } = this.state
        if (saveSearchId === selectedSavesearchId) {
            this.setState({
                saveSearchSearchKeyword: "",
                selectedSaveSearchPubMedXSearchId: "",
                selectedSavesearchId: saveSearchId,
                globalSaveSearchCollapseAll: false,
                globalSaveSearchSelectAll: false,
                saveSearchCollapsedSearchIDs: [],
                selectedSaveSearchResults: [],
                saveSearchSelectStatus: [],
                saveSearchResponse: [],
                saveSearchAnswer: [],
                saveSearchSelected: [],
                itemsPerSaveSearchPage: "25",
                itemsPerSaveSearchPageHighlyResponsive: "25",
                itemsPerSaveSearchPageResponsive: "25",
                currentSaveSearchPage: "1",
                documentSaveSearchCount: 0,
                sortSaveSearchByValue: "Relevance",
                sortSaveSearchBy: "",
                sortSaveSearchField: "",
                selectedSaveSearchFilters: [],
                allSaveSearchFilters: {},
                saveSearchFilters: {},
                isSaveSearchReleventSelected: true,
                fromSaveSearchYear: fromYear,
                toSaveSearchYear: toYear,
                appliedSaveSearchFilters: [],
                showSaveSearchPop: false,
                selectedParentSaveSearchFilterArr: [],
                saveSearch_get_final_answering: true,
                titleSaveSearch: "",
                selectedSaveSearchSearchKeyword: "",
                selectedFromSaveSearchYear: "",
                selectedToSaveSearchYear: "",
                selectedSaveSearchFilterString: "",
                isAnyChangeAfterSaveSearchResult: false,

            })
        }
    }
    handleViewSaveSearch = (selectedSaveSearchPubMedXSearchId, searchKeyword, filterStr, fromYear, toYear, savesearchName, selectedSavesearchId) => {
        this.setState({
            selectTabResSaveSearch: '13'
        })
        const currentDate = new Date();
        let currentYear = currentDate.getFullYear();
        if (!fromYear) {
            fromYear = currentYear - 5;
        }
        if (!toYear) {
            toYear = currentYear;
        }
        let _appliedFilters = [];
        if (filterStr) {
            let bifurcateFilters = this.bifurcateAppliedFilters(
                filterStr.split(";")
            );
            _appliedFilters = bifurcateFilters.appliedFiltersForBoth;

        } else {
            _appliedFilters = [];
        }
        let _selectedParentSaveSearchFilterArr = this.generateSelectParentArray(_appliedFilters);
        this.setState({
            saveSearchSearchKeyword: searchKeyword,
            selectedSaveSearchPubMedXSearchId: selectedSaveSearchPubMedXSearchId,
            selectedSavesearchId: selectedSavesearchId,
            globalSaveSearchCollapseAll: false,
            globalSaveSearchSelectAll: false,
            saveSearchCollapsedSearchIDs: [],
            selectedSaveSearchResults: [],
            saveSearchSelectStatus: [],
            saveSearchResponse: [],
            saveSearchAnswer: [],
            saveSearchSelected: [],
            itemsPerSaveSearchPage: "25",
            itemsPerSaveSearchPageHighlyResponsive: "25",
            itemsPerSaveSearchPageResponsive: "25",
            currentSaveSearchPage: "1",
            documentSaveSearchCount: 0,
            sortSaveSearchByValue: "Relevance",
            sortSaveSearchBy: "",
            sortSaveSearchField: "",
            selectedSaveSearchFilters: [],
            allSaveSearchFilters: {},
            saveSearchFilters: {},
            isSaveSearchReleventSelected: true,
            fromSaveSearchYear: fromYear,
            toSaveSearchYear: toYear,
            appliedSaveSearchFilters: _appliedFilters,
            selectedTab: "3",
            showSaveSearchPop: false,
            selectedParentSaveSearchFilterArr: _selectedParentSaveSearchFilterArr,
            saveSearch_get_final_answering: true,
            titleSaveSearch: savesearchName,
            selectedSaveSearchSearchKeyword: searchKeyword ? clone(searchKeyword) : "",
            selectedFromSaveSearchYear: clone(fromYear),
            selectedToSaveSearchYear: clone(toYear),
            selectedSaveSearchFilterString: clone(filterStr),
            isAnyChangeAfterSaveSearchResult: false,

        }, () => {
            this.runPubmedSaveSearch(searchKeyword);
        })
    }
    resultSaveSearchListCount = (itemsPerPage, currentPage, documentCount, response) => {
        try {
            var endIndex, startIndex;
            startIndex = currentPage * itemsPerPage - itemsPerPage;
            endIndex = currentPage * itemsPerPage;

            return (
                <div className={this.state.selectedTab != 2 ? "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main" :
                    "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main m-y"}>
                    {response.length > 0 && (
                        <div className="resultListCount-container">
                            {documentCount > 0 && (
                                <span
                                    className="showingResultsCountContainer" /* style={{ display: "flex", width: "200px" }} */
                                >
                                    {endIndex <= documentCount ? (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {endIndex.toLocaleString("en-us")} of{" "}
                                            {documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    ) : (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {documentCount.toLocaleString("en-us")} of{" "}
                                            {documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    )}
                                </span>
                            )}
                            <span
                                style={{
                                    marginRight: "0.5%",
                                    display: "flex",
                                    width: "180px",
                                }}
                            >
                                <PubMedPageItems
                                    handleChangeSelectItems={this.handleChangeSaveSearchSelectItems}
                                    itemsPerPage={this.state.itemsPerSaveSearchPage}
                                    customWidth={this.state.width}
                                />
                            </span>
                            <div className="sort-by-wrapper">
                                <span className="sort-by-text">Sort By:</span>
                                <select
                                    className="sort-by-select-wrapper"
                                    onChange={this.handleChangeSaveSearchSelectSortBy}
                                    defaultValue={this.state.sortSaveSearchByValue}
                                    value={this.state.sortSaveSearchByValue}
                                >
                                    <option value="Relevance">Relevance</option>
                                    <option>Year (oldest to newest)</option>
                                    <option>Year (newest to oldest)</option>
                                </select>
                            </div>
                        </div>
                    )}
                </div>
            );

        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    resultSaveSearchList = (results, itemsPerPage, currentPage) => {
        if (this.state.selectedTab == '3') {
            try {
                let { saveSearchCollapsedSearchIDs, selectedSaveSearchPubMedXSearchId, selectTabResSaveSearch, isSaveSearchReleventSelected } = this.state;
                var startIndex;
                startIndex = currentPage * itemsPerPage - itemsPerPage;
                var count = startIndex;
                let displayedResults = [];
                let displayedResultsUrl = [];
                this.resultListRef.current = Array.from({ length: results.length }, i => i)
                return (<>
                    {selectedSaveSearchPubMedXSearchId && <div className="relevant-non-relevant-filter-container">
                        <PubMedSearchResponsiveTabs selectedTabResponsive={selectTabResSaveSearch} isCheckButtonActive={isSaveSearchReleventSelected} selectedTab={this.state.selectedTab} isTabForId={'13'} handleOnTabClickresponsive={this.handleOnTabSaveSearch} width={this.state.width} />
                    </div>}
                    {(() => {
                        if (results.length > 0) {
                            return (
                                <>
                                    <div className="pubmed-main-right-section-result-list box-white-main">
                                        <div
                                            className="sticky top-16 z-2 overflow-hidden rounded-border-20 bg-white/95 backdrop-blur dark:bg-secondary-950/75"
                                            ref={(el) => {
                                                this.scrollingTableHeader = el;
                                            }}
                                            id="scrolling-table-header"
                                        ></div>
                                        <div
                                            className="overflow-x-auto pubmed-main-right-section-result-list-body pt-1"
                                            onScroll={(e) => this.handleScroll(e)}
                                        >
                                            {/* <div className="min-w-1200px"> */}
                                            <div>
                                                {results.map((item, index) => {
                                                    count++;
                                                    if (
                                                        item.highlight === undefined ||
                                                        item.highlight?.body[0] === "Empty File" ||
                                                        item.highlight?.body[0] === "Not an empty file"
                                                    ) {
                                                        displayedResults.push({
                                                            detail: item._source,
                                                            itemTeaser: [],
                                                            index: index + 1,
                                                        });
                                                        // item.highlight = { 'body': ['Test body until indexed value is available'] }
                                                    } else {
                                                        displayedResults.push({
                                                            detail: item._source,
                                                            itemTeaser: item.highlight.body,
                                                            index: index + 1,
                                                        });
                                                    }
                                                    let responseSearchIDs = item._source.rli_id;
                                                    let globalCollapseAll = saveSearchCollapsedSearchIDs.some(
                                                        (x) => x === responseSearchIDs
                                                    );
                                                    return (
                                                        <>
                                                            <div
                                                                key={`result-id-${index}`}
                                                                id={`result-id-${index}`}
                                                                className="mx-1 mb-2 rounded-2xl border-2 border-secondary-100 pubmed-main-result-item-border"
                                                            >
                                                                <PubMedDocumentCard
                                                                    item={item._source}
                                                                    count={count}
                                                                    appliedFilters={this.state.appliedSaveSearchFilters}
                                                                    searchKeyword={this.state.saveSearchSearchKeyword}
                                                                    pageNumber={this.state.currentSaveSearchPage}
                                                                    pageSize={this.state.itemsPerSaveSearchPage}
                                                                    itemTeaser={
                                                                        item.highlight === undefined ||
                                                                            item.highlight?.body[0] === "Empty File" ||
                                                                            item.highlight?.body[0] === "Not an empty file"
                                                                            ? []
                                                                            : item.highlight.body
                                                                    }
                                                                    handleCitationSelection={(i, item, itemTeaser) =>
                                                                        this.handleSaveSearchCitationSelection(
                                                                            i,
                                                                            item,
                                                                            itemTeaser,
                                                                            index
                                                                        )
                                                                    }
                                                                    isChecked={
                                                                        this.state.saveSearchSelectStatus[count - 1]
                                                                    }
                                                                    customWidth={this.state.width}
                                                                    //globalCollapseAll={this.state.globalCollapseAll}
                                                                    globalCollapseAll={globalCollapseAll}
                                                                    csPath={this.state.csPath}
                                                                    csproduct={this.state.csproduct}
                                                                    citationUrl={(url) =>
                                                                        this.citationUrl(
                                                                            url,
                                                                            index,
                                                                            item._source,
                                                                            displayedResultsUrl
                                                                        )
                                                                    }
                                                                    manageCollapseAndExpand={
                                                                        this.manageSaveSearchCollapseAndExpand
                                                                    }
                                                                    selectedTab={this.state.selectedTab}
                                                                    handleRef={this.handleRef}
                                                                    index={index}

                                                                />
                                                                {/* <div className="resultsDivFooter"></div> */}
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        {localStorage.setItem(
                                            "displayedResults",
                                            JSON.stringify(displayedResults)
                                        )}
                                    </div>
                                </>
                            );
                        } else {
                            localStorage.removeItem("displayedResults");
                            return (
                                <div className="results-no-search-content pubmed-results-no-search-content">
                                    <span>Nothing here matches your search</span>
                                    <br />
                                    <br />
                                    <span>Suggestions</span>
                                    <li>
                                        <b>Adjust the 'Publication Year'</b> (if applicable)
                                    </li>
                                    <li>Make sure all words are spelled correctly</li>
                                    <li>Try different search terms</li>
                                    <li>Try more general search terms</li>
                                    <li>Try fewer search terms</li>
                                </div>
                            );
                        }
                    })()}
                </>)
            } catch (error) {
                this.setState({ error: error, errorExpand: true });
            }
        } else {
            return <></>
        }

        // this.setState({displayedResults:displayedResults})
    };
    handleChangeSaveSearchSelectSortBy = (e) => {
        try {
            if (
                e.target.value === "Year (oldest to newest)" ||
                e.target.value === "Year Asc"
            ) {
                this.setState({ sortSaveSearchBy: "asc", sortSaveSearchField: "mpYear" });
            } else if (
                e.target.value === "Year (newest to oldest)" ||
                e.target.value === "Year Desc"
            ) {
                this.setState({ sortSaveSearchBy: "desc", sortSaveSearchField: "mpYear" });
            } else {
                this.setState({ sortSaveSearchBy: "", sortSaveSearchField: "" });
            }
            this.setState(
                {
                    sortSaveSearchByValue: e.target.value,
                    saveSearchSelectStatus: [],
                    selectedSaveSearchResults: [],
                    globalSaveSearchSelectAll: false,
                    globalSaveSearchCollapseAll: false,
                    saveSearchCollapsedSearchIDs: [],
                    isAnyChangeAfterSaveSearchResult: true,
                },
                () => {
                    this.runPubmedSaveSearch(this.state.saveSearchSearchKeyword);
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleCloseSaveSearch = (status) => {
        this.setState({
            showSaveSearchPop: status,
        })
    }
    handleReleventNonreleventFilterForSaveSearch = async (isRelevent) => {
        if (this.state.isSaveSearchReleventSelected != isRelevent) {
            let { itemsPerSaveSearchPageHighlyResponsive, itemsPerSaveSearchPageResponsive } = this.state;
            this.setState(
                {
                    isSaveSearchReleventSelected: isRelevent,
                    itemsPerSaveSearchPage: isRelevent ? itemsPerSaveSearchPageHighlyResponsive : itemsPerSaveSearchPageResponsive,
                    currentSaveSearchPage: "1",
                    globalSaveSearchCollapseAll: false,
                    saveSearchCollapsedSearchIDs: [],
                    globalSaveSearchSelectAll: false,
                    selectedSaveSearchResults: [],
                    saveSearchSelectStatus: [],
                    isAnyChangeAfterSaveSearchResult: true,
                    saveSearchResponse: []
                },
                () => {
                    this.runPubmedSaveSearch(
                        this.state.saveSearchSearchKeyword
                    );
                }
            );
        }
    };
    manageSaveSearchCollapseAndExpand = (iscollapsed, rli_id) => {
        try {
            let { saveSearchCollapsedSearchIDs, saveSearchResponse } = this.state;
            let responseSearchIDs = saveSearchResponse.map((x) => x._source.rli_id);

            if (iscollapsed) {
                saveSearchCollapsedSearchIDs.push(rli_id);
            } else {
                saveSearchCollapsedSearchIDs = saveSearchCollapsedSearchIDs.filter((x) => x !== rli_id);
            }
            let tempGlobalCollapseAll = responseSearchIDs.every((x) =>
                saveSearchCollapsedSearchIDs.includes(x)
            );
            this.setState({
                saveSearchCollapsedSearchIDs: saveSearchCollapsedSearchIDs,
                globalSaveSearchCollapseAll: tempGlobalCollapseAll,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    //#endregion----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------


    //#region OvidAbstract----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    handleReleventNonreleventFilterforOvidAbstract = async (isRelevent) => {
        if (this.state.isOvidAbstractReleventSelected != isRelevent) {
            let { itemsPerOvidAbstractPageHighlyResponsive, itemsPerOvidAbstractPageResponsive } = this.state;

            this.setState(
                {
                    isOvidAbstractReleventSelected: isRelevent,
                    itemsPerOvidAbstractPage: isRelevent ? itemsPerOvidAbstractPageHighlyResponsive : itemsPerOvidAbstractPageResponsive,
                    currentOvidAbstractPage: "1",
                    globalOvidAbstractCollapseAll: false,
                    ovidAbstractCollapsedSearchIDs: [],
                    globalOvidAbstractSelectAll: false,
                    selectedOvidAbstractResults: [],
                    ovidAbstractSelectStatus: [],
                    ovidAbstractResponse: []
                },
                () => {
                    this.runUploadAbstractRead(this.state.abstractsSearchKeyword);
                }
            );
        }
    };

    handleAllOvidAbstractFilters = (
        filters,
        appliedfilters,
        selectedFilters,
        response,
        docCount,
        query
    ) => {
        try {
            this.setState({
                ovidAbstractFilters: filters,
                appliedOvidAbstractFilters: appliedfilters,
                selectedOvidAbstractFilters: selectedFilters,
                ovidAbstractResponse: response,
                documentOvidAbstractCount: docCount,
                abstractsSearchKeyword: query,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleOvidAbstractYearSelection = (newYears) => {
        try {
            this.setState(
                {
                    fromOvidAbstractYear: newYears.min,
                    toOvidAbstractYear: newYears.max,
                },
                () =>
                    this.setState({
                        globalOvidAbstractSelectAll: false,
                        selectedOvidAbstractResults: [],
                        ovidAbstractSelectStatus: [],
                    })
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleOvidAbstractPageChange = (currentPage) => {
        try {
            window.scrollTo({ behavior: "smooth", top: "0px" });
            let checkSelectStatus = this.state.ovidAbstractSelectStatus.filter(
                (item) => item
            );
            if (
                this.state.globalOvidAbstractSelectAll &&
                (checkSelectStatus.length.toString() === this.state.itemsPerOvidAbstractPage ||
                    this.state.ovidAbstractSelectStatus.length === this.state.documentOvidAbstractCount)
            ) {
                this.setState({ ovidAbstractSelectStatus: [], selectedOvidAbstractResults: [] });
            }
            this.setState(
                {
                    currentOvidAbstractPage: currentPage,
                    ovidAbstractResponse: [],
                    isProcessing: true,
                    // isLoaded: false,
                    globalOvidAbstractCollapseAll: false,
                    globalOvidAbstractSelectAll: false,
                    ovidAbstractCollapsedSearchIDs: [],
                },
                () => {
                    let setSelectStatus = false;
                    let startIndex =
                        this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage -
                        this.state.itemsPerOvidAbstractPage;
                    let endIndex = this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage;
                    let citationStatusForCurrentPage =
                        this.state.ovidAbstractSelectStatus.slice(startIndex, endIndex);
                    setSelectStatus = citationStatusForCurrentPage.some(
                        (e) => e === true
                    );
                    if (setSelectStatus) {
                        this.setState({
                            globalOvidAbstractSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalOvidAbstractSelectAll: false,
                        });
                    }
                    this.runUploadAbstractRead(this.state.abstractsSearchKeyword);
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    gotoOvidAbstractPage = (currentPage) => {
        try {
            this.setState(
                {
                    currentOvidAbstractPage: currentPage,
                    ovidAbstractResponse: [],
                    isProcessing: true,
                    isLoaded: true,
                    globalOvidAbstractCollapseAll: false,
                    ovidAbstractCollapsedSearchIDs: [],
                },
                () => {
                    let setSelectStatus = false;
                    let startIndex =
                        this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage -
                        this.state.itemsPerOvidAbstractPage;
                    let endIndex = this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage;
                    let citationStatusForCurrentPage =
                        this.state.ovidAbstractSelectStatus.slice(startIndex, endIndex);
                    setSelectStatus = citationStatusForCurrentPage.some(
                        (e) => e === true
                    );
                    if (setSelectStatus) {
                        this.setState({
                            globalOvidAbstractSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalOvidAbstractSelectAll: false,
                        });
                    }
                    this.runUploadAbstractRead(this.state.abstractsSearchKeyword);

                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleChangeOvidAbstractSelectItems = (items) => {
        try {
            let checkSelectStatus = this.state.ovidAbstractSelectStatus.filter(
                (item) => item
            );
            if (
                this.state.globalSelectAll &&
                (checkSelectStatus.length.toString() === this.state.itemsPerOvidAbstractPage ||
                    this.state.ovidAbstractSelectStatus.length === this.state.documentOvidAbstractCount)
            ) {
                this.setState({ ovidAbstractSelectStatus: [], selectedOvidAbstractResults: [] });
            }
            let { isOvidAbstractReleventSelected, itemsPerOvidAbstractPageHighlyResponsive, itemsPerOvidAbstractPageResponsive } = this.state;
            this.setState(
                {
                    itemsPerOvidAbstractPage: items,
                    itemsPerOvidAbstractPageHighlyResponsive: isOvidAbstractReleventSelected ? items : itemsPerOvidAbstractPageHighlyResponsive,
                    itemsPerOvidAbstractPageResponsive: isOvidAbstractReleventSelected ? itemsPerOvidAbstractPageResponsive : items,
                    globalOvidAbstractCollapseAll: false,
                    globalOvidAbstractSelectAll: false,
                    ovidAbstractCollapsedSearchIDs: [],
                    selectedOvidAbstractResults: [],
                    ovidAbstractSelectStatus: [],
                },
                () => {
                    let totalPages = Math.ceil(
                        this.state.documentOvidAbstractCount / this.state.itemsPerOvidAbstractPage
                    );
                    if (totalPages < this.state.currentOvidAbstractPage) {
                        this.setState(
                            {
                                currentPage: totalPages,
                            },
                            () => {
                                let setSelectStatus = false;
                                let startIndex =
                                    this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage -
                                    this.state.itemsPerOvidAbstractPage;
                                let endIndex = this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage;
                                let citationStatusForCurrentPage =
                                    this.state.ovidAbstractSelectStatus.slice(startIndex, endIndex);
                                setSelectStatus = citationStatusForCurrentPage.some(
                                    (e) => e === true
                                );
                                if (setSelectStatus) {
                                    this.setState({
                                        globalOvidAbstractSelectAll: true,
                                    });
                                } else {
                                    this.setState({
                                        globalOvidAbstractSelectAll: false,
                                    });
                                }
                                this.runUploadAbstractRead(this.state.abstractsSearchKeyword);
                            }
                        );
                    } else {
                        this.runUploadAbstractRead(this.state.abstractsSearchKeyword);
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleOvidAbstractOnChangeInfilter = (
        filters,
        appliedfilters,
        selectedFilters,
        response,
        doc,
        query
    ) => {
        try {
            filters = appliedfilters;
            let selectedFacets = this.generateSelectParentArray(appliedfilters);
            this.setState({
                selectedOvidAbstractFilters: selectedFilters,
                allOvidAbstractFilters: this.state.allOvidAbstractFilters,
                appliedOvidAbstractFilters: appliedfilters,
            })

            this.setState(
                {
                    currentOvidAbstractPage: "1",
                    selectedParentOvidAbstractFilterArr: selectedFacets,
                    collapseFilter: true,
                    selectedOvidAbstractFilters: selectedFilters,
                    globalOvidAbstractSelectAll: false,
                    selectedOvidAbstractResults: [],
                    ovidAbstractSelectStatus: [],
                },
                () => {
                    this.runUploadAbstractRead(this.state.abstractsSearchKeyword);

                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleOvidAbstractCitationSelection = (index, item, itemTeaser, key) => {
        //console.log({item})
        try {
            let a = this.state.ovidAbstractSelectStatus;
            a[index - 1] = !this.state.ovidAbstractSelectStatus[index - 1];
            let data = this.state.selectedOvidAbstractResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.ovidAbstractSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                ovidAbstractSelectStatus: a,
                selectedOvidAbstractResults: data,
            });
            let checkSelectStatus = a.filter((item) => item);
            if (checkSelectStatus.length === parseInt(this.state.itemsPerOvidAbstractPage)) {
                this.setState({ globalOvidAbstractSelectAll: true });
            } else if (checkSelectStatus.length === this.state.ovidAbstractResponse.length) {
                this.setState({ globalOvidAbstractSelectAll: true });
            } else {
                this.setState({ globalOvidAbstractSelectAll: false });
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleClearOvidAbstractFilters = () => {
        try {
            const currentDate = new Date();
            let currentYear = currentDate.getFullYear();
            this.setState(
                {
                    selectedOvidAbstractFilters: [],
                    appliedOvidAbstractFilters: [],
                    selectedParentOvidAbstractFilterArr: [],
                    appliedFiltersForOnlyiMS: [],
                    ovidAbstractFilters: [],
                    fromOvidAbstractYear: currentYear - 5,
                    toOvidAbstractYear: currentYear,
                    globalOvidAbstractSelectAll: false,
                    selectedOvidAbstractResults: [],
                    ovidAbstractSelectStatus: [],
                    itemsPerOvidAbstractPage: "50",
                    itemsPerOvidAbstractPageHighlyResponsive: "50",
                    itemsPerOvidAbstractPageResponsive: "50",
                    currentOvidAbstractPage: "1",
                },
                () => {
                    this.runUploadAbstractRead(this.state.abstractsSearchKeyword)
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleRemoveAppliedOvidAbstractFilter = (facet) => {
        try {
            let parentFacetName = facet.split("/")[0];
            let arr = this.state.selectedParentOvidAbstractFilterArr;
            const index = arr.indexOf(parentFacetName);
            if (index > -1) {
                arr.splice(index, 1);
            }
            this.setState(
                {
                    appliedOvidAbstractFilters: this.state.appliedOvidAbstractFilters.filter(
                        (filter) => !filter.startsWith(facet)
                    ),
                    selectedParentOvidAbstractFilterArr: arr,
                    selectedOvidAbstractFilters: this.state.selectedOvidAbstractFilters.filter(
                        (filter) => filter && !filter.startsWith(facet)
                    ),
                    globalOvidAbstractSelectAll: false,
                    selectedOvidAbstractResults: [],
                    ovidAbstractSelectStatus: [],
                },
                () => {

                    this.runUploadAbstractRead(this.state.abstractsSearchKeyword)
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    handleOvidAbstractCollapseAllGlobal = () => {
        try {
            let { ovidAbstractResponse, ovidAbstractCollapsedSearchIDs } = this.state;
            if (!this.state.globalOvidAbstractCollapseAll) {
                ovidAbstractCollapsedSearchIDs = ovidAbstractResponse.map((x) => x._source.rli_id);
            } else {
                ovidAbstractCollapsedSearchIDs = [];
            }
            this.setState({
                globalOvidAbstractCollapseAll: !this.state.globalOvidAbstractCollapseAll,
                ovidAbstractCollapsedSearchIDs: ovidAbstractCollapsedSearchIDs,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleOvidAbstractSelectAll = () => {
        try {
            this.setState(
                {
                    globalOvidAbstractSelectAll: !this.state.globalOvidAbstractSelectAll,
                },
                () => {
                    let startIndex =
                        this.state.currentOvidAbstractPage * this.state.itemsPerOvidAbstractPage -
                        this.state.itemsPerOvidAbstractPage +
                        1;
                    var count = startIndex;
                    let endIndex = this.state.itemsPerOvidAbstractPage;
                    if (this.state.globalOvidAbstractSelectAll) {
                        this.markedDocumentsUrl = [];
                        this.setState({ selectedOvidAbstractResults: [] }, () => {
                            for (let i = 1; i <= endIndex; i++) {
                                if (this.state.ovidAbstractResponse[i - 1] !== undefined) {
                                    this.handleOvidAbstractCitationSelectionGlobal(
                                        count,
                                        this.state.ovidAbstractResponse[i - 1]._source,
                                        this.state.ovidAbstractResponse[i - 1].highlight === undefined ||
                                            this.state.ovidAbstractResponse[i - 1].highlight?.body[0] ===
                                            "Empty File" ||
                                            this.state.ovidAbstractResponse[i - 1].highlight?.body[0] ===
                                            "Not an empty file"
                                            ? []
                                            : this.state.ovidAbstractResponse[i - 1].highlight.body,
                                        i
                                    );
                                    count++;
                                }
                            }
                        });
                    } else {
                        for (let i = 1; i <= endIndex; i++) {
                            if (this.state.ovidAbstractResponse[i - 1] !== undefined) {
                                this.handleOvidAbstractCitationUnSelection(
                                    count,
                                    this.state.ovidAbstractResponse[i - 1]._source,
                                    this.state.ovidAbstractResponse[i - 1].highlight === undefined ||
                                        this.state.ovidAbstractResponse[i - 1].highlight?.body[0] ===
                                        "Empty File" ||
                                        this.state.ovidAbstractResponse[i - 1].highlight?.body[0] ===
                                        "Not an empty file"
                                        ? []
                                        : this.state.ovidAbstractResponse[i - 1].highlight.body
                                );
                                count++;
                            }
                        }
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleOvidAbstractCitationSelectionGlobal = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.ovidAbstractSelectStatus;
            a[index - 1] = true;
            let data = this.state.selectedOvidAbstractResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.ovidAbstractSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key - 1]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                ovidAbstractSelectStatus: a,
                selectedOvidAbstractResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    manageOvidAbstractCollapseAndExpand = (iscollapsed, rli_id) => {
        try {
            let { ovidAbstractCollapsedSearchIDs, ovidAbstractResponse } = this.state;
            let responseSearchIDs = ovidAbstractResponse.map((x) => x._source.rli_id);

            if (iscollapsed) {
                ovidAbstractCollapsedSearchIDs.push(rli_id);
            } else {
                ovidAbstractCollapsedSearchIDs = ovidAbstractCollapsedSearchIDs.filter((x) => x !== rli_id);
            }
            let tempGlobalCollapseAll = responseSearchIDs.every((x) =>
                ovidAbstractCollapsedSearchIDs.includes(x)
            );
            this.setState({
                ovidAbstractCollapsedSearchIDs: ovidAbstractCollapsedSearchIDs,
                globalOvidAbstractCollapseAll: tempGlobalCollapseAll,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleOvidAbstractCitationUnSelection = (index, item, itemTeaser) => {
        try {
            let a = this.state.ovidAbstractSelectStatus;
            a[index - 1] = false;
            let data = this.state.selectedOvidAbstractResults;
            let urls = this.markedDocumentsUrl;
            /* if (this.state.citationSelectStatus[index - 1]) {
                                    data.push({
                                        detail: item,
                                        itemTeaser: itemTeaser,
                                        index: index,
                                    })
                                }
                                else { */
            const i = data.map((x) => x.index).indexOf(index);
            if (i > -1) {
                data.splice(i, 1); // 2nd parameter means remove one item only
                urls.splice(i, 1);
            }
            /* } */
            // let selectedResultsDetails = data;
            // sessionStorage.setItem("selectedResultsDetails", JSON.stringify(selectedResultsDetails));
            // let selectedResultsIndex = data.map(x => x.index)
            // localStorage.setItem('selectedResults', selectedResultsIndex)
            this.markedDocumentsUrl = urls;
            this.setState({
                ovidAbstractSelectStatus: a,
                selectedOvidAbstractResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    getSelectedOvidAbstractCitationDetails = () => {
        try {
            if (this.state.selectedOvidAbstractResults.length > 0) {
                let selectedOvidAbstractResultsDetails = this.state.selectedOvidAbstractResults;
                sessionStorage.setItem(
                    "selectedOvidAbstractResultsDetails",
                    JSON.stringify(selectedOvidAbstractResultsDetails)
                );
                let selectedOvidAbstractResultsIndex = this.state.selectedOvidAbstractResults.map(
                    (x) => x.index
                );
                localStorage.setItem("selectedOvidAbstractResults", selectedOvidAbstractResultsIndex);
                localStorage.setItem(
                    "markedResultsUrl",
                    JSON.stringify(this.markedDocumentsUrl)
                );
                localStorage.setItem("ItemsOvidAbstractPerPage", this.state.itemsPerOvidAbstractPage);
                localStorage.setItem("ActiveOvidAbstractPage", this.state.currentOvidAbstractPage);
                this.props.history.push({
                    pathname: "/viewmarked",
                    state: { selectedOvidAbstractResults: this.state.selectedOvidAbstractResults },
                });
            } else {
                alert("There are no documents selected");
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };

    resultOvidAbstractListCount = (itemsPerPage, currentPage, documentCount, response) => {
        try {
            var endIndex, startIndex;
            startIndex = currentPage * itemsPerPage - itemsPerPage;
            endIndex = currentPage * itemsPerPage;
            let { useTemplate } = this.state;
            return (
                <div className={useTemplate === "OVID" ? "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main" : "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main"}>
                    {response.length > 0 && (
                        <div className="resultListCount-container">
                            {documentCount > 0 && (
                                <span
                                    className="showingResultsCountContainer" /* style={{ display: "flex", width: "200px" }} */
                                >
                                    {endIndex <= documentCount ? (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {endIndex.toLocaleString("en-us")} of{" "}
                                            {documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    ) : (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {documentCount.toLocaleString("en-us")} of{" "}
                                            {documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    )}
                                </span>
                            )}
                            <span
                                style={{
                                    marginRight: "0.5%",
                                    display: "flex",
                                    width: "180px",
                                }}
                            >
                                <PubMedPageItems
                                    handleChangeSelectItems={this.handleChangeOvidAbstractSelectItems}
                                    itemsPerPage={this.state.itemsPerOvidAbstractPage}
                                    customWidth={this.state.width}
                                />
                            </span>
                            {useTemplate === "OVID" && <div className="sort-by-wrapper">
                                <span className="sort-by-text">Sort By:</span>
                                <select
                                    className="sort-by-select-wrapper"
                                    onChange={this.handleChangeOvidAbstractSelectSortBy}
                                    defaultValue={this.state.sortOvidAbstractByValue}
                                    value={this.state.sortOvidAbstractByValue}
                                >
                                    <option value="Relevance">Relevance</option>
                                    <option>Year (oldest to newest)</option>
                                    <option>Year (newest to oldest)</option>
                                </select>
                            </div>}
                        </div>
                    )}
                </div>
            );

        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    resultOvidAbstractList = (results, itemsPerPage, currentPage) => {
        if (this.state.selectedTab == '1') {
            try {
                let { ovidAbstractCollapsedSearchIDs, attachedFiles, selectedTabResUploadAbstract, isOvidAbstractReleventSelected } = this.state;
                var startIndex;
                startIndex = currentPage * itemsPerPage - itemsPerPage;
                var count = startIndex;
                let displayedResults = [];
                let displayedResultsUrl = [];
                this.resultListRef.current = Array.from({ length: results.length }, i => i)

                return (<>
                    {(attachedFiles && attachedFiles.length > 0) &&
                        <div className="relevant-non-relevant-filter-container">
                            <PubMedSearchResponsiveTabs selectedTabResponsive={selectedTabResUploadAbstract} isCheckButtonActive={isOvidAbstractReleventSelected} selectedTab={this.state.selectedTab} isTabForId={'9'} handleOnTabClickresponsive={this.handleOnTabClickUploadAbstracts} width={this.state.width} />
                        </div>
                    }
                    {(() => {
                        if (results.length > 0) {
                            return (
                                <>
                                    <div className="pubmed-main-right-section-result-list box-white-main">
                                        <div
                                            className="sticky top-16 z-2 overflow-hidden rounded-border-20 bg-white/95 backdrop-blur dark:bg-secondary-950/75"
                                            ref={(el) => {
                                                this.scrollingTableHeader = el;
                                            }}
                                            id="scrolling-table-header"
                                        ></div>
                                        <div
                                            className="overflow-x-auto pubmed-main-right-section-result-list-body pt-1"
                                            onScroll={(e) => this.handleScroll(e)}
                                        >
                                            {/* <div className="min-w-1200px"> */}
                                            <div>
                                                {results.map((item, index) => {
                                                    count++;
                                                    if (
                                                        item.highlight === undefined ||
                                                        item.highlight?.body[0] === "Empty File" ||
                                                        item.highlight?.body[0] === "Not an empty file"
                                                    ) {
                                                        displayedResults.push({
                                                            detail: item._source,
                                                            itemTeaser: [],
                                                            index: index + 1,
                                                        });
                                                        // item.highlight = { 'body': ['Test body until indexed value is available'] }
                                                    } else {
                                                        displayedResults.push({
                                                            detail: item._source,
                                                            itemTeaser: item.highlight.body,
                                                            index: index + 1,
                                                        });
                                                    }
                                                    let responseSearchIDs = item._source.rli_id;
                                                    let globalCollapseAll = ovidAbstractCollapsedSearchIDs.some(
                                                        (x) => x === responseSearchIDs
                                                    );
                                                    return (
                                                        <>
                                                            <div
                                                                key={`result-id-${index}`}
                                                                id={`result-id-${index}`}
                                                                className="mx-1 mb-2 rounded-2xl border-2 border-secondary-100 pubmed-main-result-item-border"
                                                            >
                                                                <PubMedDocumentCard
                                                                    item={item._source}
                                                                    count={count}
                                                                    appliedFilters={this.state.appliedOvidAbstractFilters}
                                                                    searchKeyword={this.state.abstractsSearchKeyword}
                                                                    pageNumber={this.state.currentOvidAbstractPage}
                                                                    pageSize={this.state.itemsPerOvidAbstractPage}
                                                                    itemTeaser={
                                                                        item.highlight === undefined ||
                                                                            item.highlight?.body[0] === "Empty File" ||
                                                                            item.highlight?.body[0] === "Not an empty file"
                                                                            ? []
                                                                            : item.highlight.body
                                                                    }
                                                                    handleCitationSelection={(i, item, itemTeaser) =>
                                                                        this.handleOvidAbstractCitationSelection(
                                                                            i,
                                                                            item,
                                                                            itemTeaser,
                                                                            index
                                                                        )
                                                                    }
                                                                    isChecked={
                                                                        this.state.ovidAbstractSelectStatus[count - 1]
                                                                    }
                                                                    customWidth={this.state.width}
                                                                    //globalCollapseAll={this.state.globalCollapseAll}
                                                                    globalCollapseAll={globalCollapseAll}
                                                                    csPath={this.state.csPath}
                                                                    csproduct={this.state.csproduct}
                                                                    citationUrl={(url) =>
                                                                        this.citationUrl(
                                                                            url,
                                                                            index,
                                                                            item._source,
                                                                            displayedResultsUrl
                                                                        )
                                                                    }
                                                                    manageCollapseAndExpand={
                                                                        this.manageOvidAbstractCollapseAndExpand
                                                                    }
                                                                    selectedTab={this.state.selectedTab}
                                                                    handleRef={this.handleRef}
                                                                    index={index}
                                                                />
                                                                {/* <div className="resultsDivFooter"></div> */}
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        {localStorage.setItem(
                                            "displayedResults",
                                            JSON.stringify(displayedResults)
                                        )}
                                    </div>
                                </>
                            );
                        } else {
                            localStorage.removeItem("displayedResults");
                            return (
                                <div className="results-no-search-content pubmed-results-no-search-content">
                                    <span>Nothing here matches your search</span>
                                    <br />
                                    <br />
                                    <span>Suggestions</span>
                                    <li>
                                        <b>Upload document</b>
                                    </li>
                                    <li>
                                        <b>Adjust the 'Publication Year'</b> (if applicable)
                                    </li>
                                    <li>Make sure all words are spelled correctly</li>
                                    <li>Try different search terms</li>
                                    <li>Try more general search terms</li>
                                    <li>Try fewer search terms</li>
                                </div>
                            );
                        }
                    })()}</>)
            } catch (error) {
                this.setState({ error: error, errorExpand: true });
            }
        } else {
            return <></>
        }
    };
    handleChangeOvidAbstractSelectSortBy = (e) => {
        try {
            if (
                e.target.value === "Year (oldest to newest)" ||
                e.target.value === "Year Asc"
            ) {
                this.setState({ sortOvidAbstractBy: "asc", sortOvidAbstractField: "YR" });
            } else if (
                e.target.value === "Year (newest to oldest)" ||
                e.target.value === "Year Desc"
            ) {
                this.setState({ sortOvidAbstractBy: "desc", sortOvidAbstractField: "YR" });
            } else {
                this.setState({ sortOvidAbstractBy: "", sortOvidAbstractField: "" });
            }
            this.setState(
                {
                    sortOvidAbstractByValue: e.target.value,
                    ovidAbstractSelectStatus: [],
                    selectedOvidAbstractResults: [],
                    globalOvidAbstractSelectAll: false,
                    globalOvidAbstractCollapseAll: false,
                    ovidAbstractCollapsedSearchIDs: [],
                },
                () => {
                    this.runUploadAbstractRead(this.state.abstractsSearchKeyword);
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleCloseOvidAbstract = (status) => {
        this.setState({
            showOvidAbstractPop: status,
        })
    }

    //#endregion OvidAbstract----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------


    // region alert
    openAlert = () => {
        this.setState({ ...this.state, showPersonalAlerts: true, fromGlobalTab: false })
    }

    //#region 

    handleOnClickResetIcon = () => {
        let { selectedTab } = this.state
        if (selectedTab === "1") {
            this.setState({ isProcessing: true }, () => {
                this.resetAbstractsResult();
            })
        }
        else if (selectedTab === "2") {
            let { currentReviewListId } = this.state;
            this.getAllReviewListData(currentReviewListId, '');
        }
        else if (selectedTab === "3") {
            let { selectedSaveSearchPubMedXSearchId,
                selectedSaveSearchSearchKeyword,
                selectedSaveSearchFilterString,
                selectedFromSaveSearchYear,
                selectedToSaveSearchYear,
                titleSaveSearch } = this.state;
            this.handleViewSaveSearch(selectedSaveSearchPubMedXSearchId,
                selectedSaveSearchSearchKeyword,
                selectedSaveSearchFilterString,
                selectedFromSaveSearchYear,
                selectedToSaveSearchYear,
                titleSaveSearch);
        }

    }

    resetAbstractsResult = async () => {
        try {
            this.setState({
                itemsPerAbstractPage: "50",
                currentAbstractPage: "1",
                documentAbstractCount: 0,
                itemsPerOvidAbstractPage: "50",
                itemsPerOvidAbstractPageHighlyResponsive: "50",
                itemsPerOvidAbstractPageResponsive: "50",
                currentOvidAbstractPage: "1",
                documentOvidAbstractCount: 0,
                globalAbstractCollapseAll: false,
                globalAbstractSelectAll: false,
                abstractSelectStatus: [],
                abstractCollapsedSearchIDs: [],
                selectedAbstractResults: [],
                globalOvidAbstractCollapseAll: false,
                globalOvidAbstractSelectAll: false,
                ovidAbstractCollapsedSearchIDs: [],
                selectedOvidAbstractResults: [],
                ovidAbstractSelectStatus: [],
                sortOvidAbstractByValue: "Relevance",
                sortOvidAbstractBy: "",
                sortOvidAbstractField: "",
                fromOvidAbstractYear: "",
                toOvidAbstractYear: "",
                appliedOvidAbstractFilters: [], //Filters that are applied for while search is happening
                selectedOvidAbstractFilters: [],
                allOvidAbstractFilters: {},
                ovidAbstractFilters: {},
                selectedParentOvidAbstractFilterArr: [],
                isOvidAbstractReleventSelected: false,
                abstractsSearchKeyword: "",
                abstractsSelected: [],
            }, async () => {
                let { useTemplate, abstractsResetInfo } = this.state;
                if (abstractsResetInfo) {
                    let _responseData = JSON.parse(JSON.stringify(this.state.abstractsResetInfo)) //{ ...abstractsResetInfo }; //Object.assign({}, this.state.abstractsResetInfo); //JSON.parse(JSON.stringify(this.state.abstractsResetInfo));
                    if (useTemplate === "OVID") {
                        var processed = processPubMedFilters(_responseData.body);
                        _responseData = await this.processElasticOvidData(_responseData)
                        const filterService = new FilterService();
                        const [filters] = filterService.expandFilterSet(
                            processed,
                            this.state.appliedOvidAbstractFilters
                        );
                        let selectedFiltered = this.state.selectedOvidAbstractFilters.concat(filters);
                        selectedFiltered = this.state.appliedOvidAbstractFilters.concat(filters);
                        this.setState(
                            {
                                documentOvidAbstractCount: _responseData.body.hits.total.value,
                                ovidAbstractResponse: _responseData.body.hits.hits,
                                ovidAbstractFilters: processed,
                                isProcessing: false,
                                isLoaded: true,
                                collapseFilter: false,
                                ovidAbstractAnswer: [],
                                fromOvidAbstractYear: _responseData.body.aggregations.min_year,
                                toOvidAbstractYear: _responseData.body.aggregations.max_year,
                            },
                            async () => {
                                if (
                                    this.state.globalOvidAbstractSelectAll &&
                                    (this.state.ovidAbstractSelectStatus.length.toString() ===
                                        this.state.itemsPerOvidAbstractPage ||
                                        this.state.ovidAbstractSelectStatus.length ===
                                        this.state.documentOvidAbstractCount)
                                ) {
                                    this.setState({ globalOvidAbstractSelectAll: true });
                                } else {
                                    this.setState({ globalOvidAbstractSelectAll: false });
                                }
                                this.handleAllOvidAbstractFilters(
                                    this.state.ovidAbstractFilters,
                                    this.state.appliedOvidAbstractFilters,
                                    this.state.selectedOvidAbstractFilters,
                                    this.state.ovidAbstractResponse,
                                    this.state.documentOvidAbstractCount,
                                    this.state.abstractsSearchKeyword
                                );
                            }
                        );
                    } else if (_responseData && _responseData.body && _responseData.body.hits && _responseData.body.hits.hits && _responseData.body.hits.hits.length > 0) {
                        _responseData.body.hits.hits.map((hitItem, hitIndex) => {
                            hitItem._source.rli_id = uuidv4();
                            hitItem._source.relevant = hitItem._source.relevant
                                ? hitItem._source.relevant
                                : "False";
                            hitItem._source.summary = hitItem._source.summary
                                ? hitItem._source.summary
                                : "";
                            hitItem._source.keypoints = hitItem._source.keypoints ? hitItem._source.keypoints : null;

                            Object.keys(hitItem._source).map((y) => {
                                if (typeof hitItem._source[y] === "number" && y !== "mpYear") {
                                    hitItem._source[y] = `${hitItem._source[y]}`;
                                }
                            });
                        });

                        let _response = _responseData.body.hits.hits.map(x => x._source);
                        var processed = processPubMedFilters(_responseData.body);
                        const filterService = new FilterService();
                        const [filters] = filterService.expandFilterSet(
                            processed,
                            this.state.appliedOvidAbstractFilters
                        );
                        let selectedFiltered = this.state.selectedOvidAbstractFilters.concat(filters);
                        selectedFiltered = this.state.appliedOvidAbstractFilters.concat(filters);
                        this.setState(
                            {
                                documentOvidAbstractCount: _responseData.body.hits.total.value,
                                abstractsResponse: _response,
                                ovidAbstractFilters: processed,
                                isProcessing: false,
                                isLoaded: true,
                                collapseFilter: false,
                                ovidAbstractAnswer: [],
                                fromOvidAbstractYear: '',
                                toOvidAbstractYear: '',
                            });
                    }
                } else {
                    this.errorAlertMessage("Sorry, something went wrong");
                }
            })
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
            this.errorAlertMessage("Sorry, something went wrong");
        }
    }
    //#endregion

    //export excel region
    openExportPopup = () => {
        this.setState({ showExportPopup: true })
    }

    handleExportDataLength = () => {
        if (this.state.selectedTab == '0') {
            return this.state.response.length
        } else if (this.state.selectedTab == '3') {
            return this.state.saveSearchResponse.length
        } else if (this.state.selectedTab == '2') {
            return this.state.reviewListResponse.length
        } else if (this.state.selectedTab == '1') {
            if (this.state.useTemplate == 'Other') {
                return this.state.abstractsResponse.length
            } else {
                return this.state.ovidAbstractResponse.length
            }

        } else {
            return 0
        }
    }
    handleExportData = () => {
        if (this.state.selectedTab == '0') {
            return this.state.response
        } else if (this.state.selectedTab == '3') {
            return this.state.saveSearchResponse
        } else if (this.state.selectedTab == '2') {
            return this.state.reviewListResponse
        } else if (this.state.selectedTab == '1') {
            if (this.state.useTemplate == 'Other') {
                return this.state.abstractsResponse
            } else {
                return this.state.ovidAbstractResponse
            }
        } else {
            return []
        }
    }
    handleSelectedExportData = () => {
        if (this.state.selectedTab == '0') {
            return this.state.selectedResults
        } else if (this.state.selectedTab == '3') {
            return this.state.selectedSaveSearchResults
        } else if (this.state.selectedTab == '2') {
            return this.state.selectedReviewListResults
        } else if (this.state.selectedTab == '1') {
            if (this.state.useTemplate == 'Other') {
                return this.state.selectedAbstractResults
            } else {
                return this.state.selectedOvidAbstractResults
            }
        } else {
            return []
        }
    }
    //endof export excel region
    resultAlertListCount = (itemsPerPage, currentPage, documentCount, response) => {
        try {
            var endIndex, startIndex;
            startIndex = currentPage * itemsPerPage - itemsPerPage;
            endIndex = currentPage * itemsPerPage;

            return (
                <div className={this.state.selectedTab != 2 ? "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main" :
                    "results-count-wrapper pubmed-main-right-section-result-list-count box-white-main m-y"}>
                    {response.length > 0 && (
                        <div className="resultListCount-container">
                            {documentCount > 0 && (
                                <span
                                    className="showingResultsCountContainer" /* style={{ display: "flex", width: "200px" }} */
                                >
                                    {endIndex <= documentCount ? (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {endIndex.toLocaleString("en-us")} of{" "}
                                            {documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    ) : (
                                        <div className="results-number-show-wrapper">
                                            Showing {(startIndex + 1).toLocaleString("en-us")}-
                                            {documentCount.toLocaleString("en-us")} of{" "}
                                            {documentCount.toLocaleString("en-us")}{" "}
                                            Results
                                        </div>
                                    )}
                                </span>
                            )}
                            <span
                                style={{
                                    marginRight: "0.5%",
                                    display: "flex",
                                    width: "180px",
                                }}
                            >
                                <PubMedPageItems
                                    handleChangeSelectItems={this.handleAlertFrequencySizeChange}
                                    itemsPerPage={this.state.itemsPerAlertPage}
                                    customWidth={this.state.width}
                                />
                            </span>
                            {/* <div className="sort-by-wrapper">
                                <span className="sort-by-text">Sort By:</span>
                                <select
                                    className="sort-by-select-wrapper"
                                    onChange={this.handleChangeSaveSearchSelectSortBy}
                                    defaultValue={this.state.sortSaveSearchByValue}
                                    value={this.state.sortSaveSearchByValue}
                                >
                                    <option value="Relevance">Relevance</option>
                                    <option>Year (oldest to newest)</option>
                                    <option>Year (newest to oldest)</option>
                                </select>
                            </div> */}
                        </div>
                    )}
                </div>
            );

        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    OpenWindow = (url) => {
        let width = window.innerWidth
        let height = window.innerHeight
        let left = 0.10 * window.innerWidth
        let top = 0.10 * window.innerHeight
        window.open(url, '', `width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`)
        return null;
    }
    handleViewMoreAlert = (alertDate) => {
        let url = `/PubMedSearchViewMore?AlertDate=${alertDate}&AlertID=${this.state.selectedAlert.item_id}`;
        this.OpenWindow(url)
    }
    formatDate = (_date) => {
        const date = new Date(_date);
        const day = date.getUTCDate();
        const year = date.getUTCFullYear();
        const month = date.toLocaleString('en-US', {
            month: 'long',
            timeZone: 'UTC'
        })
        let day_str = ''
        if (day > 3 && day < 21) {
            day_str = day + 'th'
        } else {
            switch (day % 10) {
                case 1: day_str = day + 'st';
                case 2: day_str = day + 'nd';
                case 3: day_str = day + 'rd';
                case 4: day_str = day + 'th';
            }
        }
        return (day_str + ' ' + month + ' ' + year)
    }
    resultAlertList = (results, itemsPerPage, currentPage) => {
        if (this.state.selectedTab == '4') {
            try {
                let { alertCollapsedSearchIDs, selectedAlert } = this.state;
                var startIndex;
                startIndex = currentPage * itemsPerPage - itemsPerPage;
                var count = startIndex;
                let displayedResults = [];
                let displayedResultsUrl = [];
                this.resultListRef.current = Array.from({ length: results.length }, i => i)
                return (<>
                    {/* {(results.length > 0 && results[0]._source.alerts.length > 0) && <div className="relevant-non-relevant-filter-container">

                        <div
                            className="pubmed-search-relevant-outer-box relevant-filter-container"
                            onClick={() => this.handleReleventNonreleventFilterForAlert(true)}
                        >
                            <div className="pubmed-search-relevant-box relevant-filter-box relevant-box-width">
                                {this.state.isAlertReleventSelected && (
                                    <svg
                                        fill="#000000"
                                        width="14px"
                                        height="14px"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21ZM17.737,8.824a1,1,0,0,1-.061,1.413l-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,0,1,1.415-1.414l2.323,2.323,5.294-4.853A1,1,0,0,1,17.737,8.824Z"></path>
                                        </g>
                                    </svg>
                                )}
                                <span className="mx-1">Highly Responsive</span>
                            </div>
                        </div>
                        <div
                            className="pubmed-search-relevant-outer-box non-relevant-filter-container"
                            onClick={() => this.handleReleventNonreleventFilterForAlert(false)}
                        >
                            <div className="pubmed-search-not-relevant-box non-relevant-filter-box">
                                {!this.state.isAlertReleventSelected && (
                                    <svg
                                        fill="#000000"
                                        width="14px"
                                        height="14px"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                        <g
                                            id="SVGRepo_tracerCarrier"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        ></g>
                                        <g id="SVGRepo_iconCarrier">
                                            <path d="M12,1A11,11,0,1,0,23,12,11.013,11.013,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9.011,9.011,0,0,1,12,21ZM17.737,8.824a1,1,0,0,1-.061,1.413l-6,5.5a1,1,0,0,1-1.383-.03l-3-3a1,1,0,0,1,1.415-1.414l2.323,2.323,5.294-4.853A1,1,0,0,1,17.737,8.824Z"></path>
                                        </g>
                                    </svg>
                                )}
                                <span className="mx-1">Responsive</span>
                            </div>
                        </div>
                    </div>} */}

                    {(() => {
                        if (results.length > 0 && results[0]._source.alerts.length > 0) {
                            return (
                                <>
                                    <div className="pubmed-main-right-section-result-list box-white-main">
                                        <div
                                            className="sticky top-16 z-2 overflow-hidden rounded-border-20 bg-white/95 backdrop-blur dark:bg-secondary-950/75"
                                            ref={(el) => {
                                                this.scrollingTableHeader = el;
                                            }}
                                            id="scrolling-table-header"
                                        ></div>
                                        <div
                                            className="overflow-x-auto pubmed-main-right-section-result-list-body pt-1"
                                            onScroll={(e) => this.handleScroll(e)}
                                        >
                                            {/* <div className="min-w-1200px"> */}
                                            <div>
                                                {results.map((x) => {
                                                    return (<>
                                                        <div className="alert-date-conc">{this.formatDate(x._source.alertDate)}</div>
                                                        {x._source.alerts.map((y) => {
                                                            return (<>
                                                                {y.pmidList.map((item, index) => {
                                                                    count++;
                                                                    if (
                                                                        item.highlight === undefined ||
                                                                        item.highlight?.body[0] === "Empty File" ||
                                                                        item.highlight?.body[0] === "Not an empty file"
                                                                    ) {
                                                                        displayedResults.push({
                                                                            detail: item,
                                                                            itemTeaser: [],
                                                                            index: index + 1,
                                                                        });
                                                                        // item.highlight = { 'body': ['Test body until indexed value is available'] }
                                                                    } else {
                                                                        displayedResults.push({
                                                                            detail: item,
                                                                            itemTeaser: item.highlight.body,
                                                                            index: index + 1,
                                                                        });
                                                                    }
                                                                    let responseSearchIDs = item._source;
                                                                    let globalCollapseAll = alertCollapsedSearchIDs.some(
                                                                        (x) => x === responseSearchIDs
                                                                    );
                                                                    return (
                                                                        <>
                                                                            <div
                                                                                key={`result-id-${index}`}
                                                                                id={`result-id-${index}`}
                                                                                className="mx-1 mb-2 rounded-2xl border-2 border-secondary-100 pubmed-main-result-item-border"
                                                                            >
                                                                                <PubMedDocumentCard
                                                                                    item={item}
                                                                                    count={count}
                                                                                    appliedFilters={[]}
                                                                                    searchKeyword={''}
                                                                                    pageNumber={this.state.currentAlertPage}
                                                                                    pageSize={this.state.itemsPerAlertPage}
                                                                                    itemTeaser={
                                                                                        item.highlight === undefined ||
                                                                                            item.highlight?.body[0] === "Empty File" ||
                                                                                            item.highlight?.body[0] === "Not an empty file"
                                                                                            ? []
                                                                                            : item.highlight.body
                                                                                    }
                                                                                    handleCitationSelection={(i, item, itemTeaser) =>
                                                                                        this.handleAlertCitationSelection(
                                                                                            i,
                                                                                            item,
                                                                                            itemTeaser,
                                                                                            index
                                                                                        )
                                                                                    }
                                                                                    isChecked={
                                                                                        this.state.alertSelectStatus[count - 1]
                                                                                    }
                                                                                    customWidth={this.state.width}
                                                                                    //globalCollapseAll={this.state.globalCollapseAll}
                                                                                    globalCollapseAll={globalCollapseAll}
                                                                                    csPath={this.state.csPath}
                                                                                    csproduct={this.state.csproduct}
                                                                                    citationUrl={(url) =>
                                                                                        this.citationUrl(
                                                                                            url,
                                                                                            index,
                                                                                            item._source,
                                                                                            displayedResultsUrl
                                                                                        )
                                                                                    }
                                                                                    manageCollapseAndExpand={
                                                                                        this.manageAlertCollapseAndExpand
                                                                                    }
                                                                                    selectedTab={this.state.selectedTab}
                                                                                    handleRef={this.handleRef}
                                                                                    index={index}

                                                                                />
                                                                                {/* <div className="resultsDivFooter"></div> */}
                                                                            </div>
                                                                        </>
                                                                    );
                                                                })
                                                                }
                                                                {(y.pmidsCounts > 10) && <div className="alert-view-conc" onClick={() => this.handleViewMoreAlert(x._source.alertDate)}>{`View All (${y.pmidsCounts})`}</div>}
                                                            </>)
                                                        })}
                                                    </>)
                                                })}
                                            </div>
                                        </div>
                                        {localStorage.setItem(
                                            "displayedResults",
                                            JSON.stringify(displayedResults)
                                        )}
                                    </div>
                                </>
                            );
                        } else {
                            localStorage.removeItem("displayedResults");
                            return (
                                <div className="results-no-search-content pubmed-results-no-search-content">
                                    <span>{`It seems like there are no alerts sent over last ${this.state.alertsFrequencySelected} days for this saved alert.`}</span>
                                    <br />
                                    <br />
                                    <span>Suggestions</span>
                                    <li>
                                        <b>Adjust the View</b> (if applicable)
                                    </li>
                                </div>
                            );
                        }
                    })()}
                </>)
            } catch (error) {
                this.setState({ error: error, errorExpand: true });
            }
        } else {
            return <></>
        }

        // this.setState({displayedResults:displayedResults})
    };
    handleReleventNonreleventFilterForAlert = async (isRelevent) => {
        if (this.state.isAlertReleventSelected != isRelevent) {
            let { itemsPerAlertPageHighlyResponsive, itemsPerAlertPageResponsive } = this.state;
            this.setState(
                {
                    isAlertReleventSelected: isRelevent,
                    itemsPerAlertPage: isRelevent ? itemsPerAlertPageHighlyResponsive : itemsPerAlertPageResponsive,
                    currentAlertPage: "1",
                    globalAlertCollapseAll: false,
                    alertCollapsedSearchIDs: [],
                    globalAlertSelectAll: false,
                    selectedAlertResults: [],
                    alertSelectStatus: [],
                    isAnyChangeAfterAlertResult: true,
                    alertResponses: []
                },
                () => {
                    this.handleMyAlert(
                        this.state.selectedAlert, isRelevent
                    );
                }
            );
        }
    };
    handleAlertCollapseAllGlobal = () => {
        try {
            let { alertResponses, alertCollapsedSearchIDs, globalAlertCollapseAll } = this.state;
            if (!this.state.globalAlertCollapseAll) {
                alertCollapsedSearchIDs = alertResponses.map((x) => x._source.rli_id);
            } else {
                alertCollapsedSearchIDs = [];
            }
            this.setState({
                globalAlertCollapseAll: !this.state.globalAlertCollapseAll,
                alertCollapsedSearchIDs: alertCollapsedSearchIDs,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleAlertSelectAll = () => {
        try {
            this.setState(
                {
                    globalAlertSelectAll: !this.state.globalAlertSelectAll,
                },
                () => {
                    let startIndex =
                        this.state.currentAlertPage * this.state.itemsPerAlertPage -
                        this.state.itemsPerAlertPage +
                        1;
                    var count = startIndex;
                    let endIndex = this.state.itemsPerAlertPage;
                    if (this.state.globalAlertSelectAll) {
                        this.markedDocumentsUrl = [];
                        this.setState({ selectedAlertResults: [] }, () => {
                            for (let i = 1; i <= endIndex; i++) {
                                if (this.state.alertResponses[i - 1] !== undefined) {
                                    this.handleAlertCitationSelectionGlobal(
                                        count,
                                        this.state.alertResponses[i - 1]._source,
                                        this.state.alertResponses[i - 1].highlight === undefined ||
                                            this.state.alertResponses[i - 1].highlight?.body[0] ===
                                            "Empty File" ||
                                            this.state.alertResponses[i - 1].highlight?.body[0] ===
                                            "Not an empty file"
                                            ? []
                                            : this.state.alertResponses[i - 1].highlight.body,
                                        i
                                    );
                                    count++;
                                }
                            }
                        });
                    } else {
                        for (let i = 1; i <= endIndex; i++) {
                            if (this.state.alertResponses[i - 1] !== undefined) {
                                this.handleAlertCitationUnSelection(
                                    count,
                                    this.state.alertResponses[i - 1]._source,
                                    this.state.alertResponses[i - 1].highlight === undefined ||
                                        this.state.alertResponses[i - 1].highlight?.body[0] ===
                                        "Empty File" ||
                                        this.state.alertResponses[i - 1].highlight?.body[0] ===
                                        "Not an empty file"
                                        ? []
                                        : this.state.alertResponses[i - 1].highlight.body
                                );
                                count++;
                            }
                        }
                    }
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    }
    handleAlertCitationSelectionGlobal = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.alertSelectStatus;
            a[index - 1] = true;
            let data = this.state.selectedAlertResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.alertSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key - 1]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                alertSelectStatus: a,
                selectedAlertResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleAlertCitationUnSelection = (index, item, itemTeaser) => {
        try {
            let a = this.state.alertSelectStatus;
            a[index - 1] = false;
            let data = this.state.selectedAlertResults;
            let urls = this.markedDocumentsUrl;
            /* if (this.state.citationSelectStatus[index - 1]) {
                                    data.push({
                                        detail: item,
                                        itemTeaser: itemTeaser,
                                        index: index,
                                    })
                                }
                                else { */
            const i = data.map((x) => x.index).indexOf(index);
            if (i > -1) {
                data.splice(i, 1); // 2nd parameter means remove one item only
                urls.splice(i, 1);
            }
            /* } */
            // let selectedResultsDetails = data;
            // sessionStorage.setItem("selectedResultsDetails", JSON.stringify(selectedResultsDetails));
            // let selectedResultsIndex = data.map(x => x.index)
            // localStorage.setItem('selectedResults', selectedResultsIndex)
            this.markedDocumentsUrl = urls;
            this.setState({
                alertSelectStatus: a,
                selectedAlertResults: data,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleAlertCitationSelection = (index, item, itemTeaser, key) => {
        try {
            let a = this.state.alertSelectStatus;
            a[index - 1] = !this.state.alertSelectStatus[index - 1];
            let data = this.state.selectedAlertResults;
            let urls = this.markedDocumentsUrl;
            if (this.state.alertSelectStatus[index - 1]) {
                data.push({
                    detail: item,
                    itemTeaser: itemTeaser,
                    index: index,
                });
                urls.push(this.documentsUrl[key]);
            } else {
                const i = data.map((x) => x.index).indexOf(index);
                if (i > -1) {
                    data.splice(i, 1); // 2nd parameter means remove one item only
                    urls.splice(i, 1);
                }
            }
            this.markedDocumentsUrl = urls;
            this.setState({
                alertSelectStatus: a,
                selectedAlertResults: data,
            });
            let checkSelectStatus = a.filter((item) => item);
            if (checkSelectStatus.length === parseInt(this.state.itemsPerAlertPage)) {
                this.setState({ globalAlertSelectAll: true });
            } else if (checkSelectStatus.length === this.state.alertResponses.length) {
                this.setState({ globalAlertSelectAll: true });
            } else {
                this.setState({ globalAlertSelectAll: false });
            }
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleAlertPageChange = (currentPage) => {
        try {
            window.scrollTo({ behavior: "smooth", top: "0px" });
            let checkSelectStatus = this.state.alertSelectStatus.filter(
                (item) => item
            );
            if (
                this.state.globalAlertSelectAll &&
                (checkSelectStatus.length.toString() === this.state.itemsPerAlertPage ||
                    this.state.alertSelectStatus.length === this.state.documentAlertCount)
            ) {
                this.setState({ alertSelectStatus: [], selectedAlertResults: [] });
            }
            this.setState(
                {
                    currentAlertPage: currentPage,
                    alertResponses: [],
                    isProcessing: true,
                    // isLoaded: false,
                    globalAlertCollapseAll: false,
                    globalAlertSelectAll: false,
                    alertCollapsedSearchIDs: [],
                    isAnyChangeAfterAlertResult: true,
                },
                () => {
                    let setSelectStatus = false;
                    let startIndex =
                        this.state.currentAlertPage * this.state.itemsPerAlertPage -
                        this.state.itemsPerAlertPage;
                    let endIndex = this.state.currentAlertPage * this.state.itemsPerAlertPage;
                    let citationStatusForCurrentPage =
                        this.state.alertSelectStatus.slice(startIndex, endIndex);
                    setSelectStatus = citationStatusForCurrentPage.some(
                        (e) => e === true
                    );
                    if (setSelectStatus) {
                        this.setState({
                            globalAlertSelectAll: true,
                        });
                    } else {
                        this.setState({
                            globalAlertSelectAll: false,
                        });
                    }
                    this.handleMyAlert(this.state.selectedAlert, this.state.isAlertReleventSelected);
                }
            );
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    manageAlertCollapseAndExpand = (iscollapsed, rli_id) => {
        try {
            let { alertCollapsedSearchIDs, alertResponses } = this.state;
            let responseSearchIDs = alertResponses.map((x) => x._source.rli_id);

            if (iscollapsed) {
                alertCollapsedSearchIDs.push(rli_id);
            } else {
                alertCollapsedSearchIDs = alertCollapsedSearchIDs.filter((x) => x !== rli_id);
            }
            let tempGlobalCollapseAll = responseSearchIDs.every((x) =>
                alertCollapsedSearchIDs.includes(x)
            );
            this.setState({
                alertCollapsedSearchIDs: alertCollapsedSearchIDs,
                globalAlertCollapseAll: tempGlobalCollapseAll,
            });
        } catch (error) {
            this.setState({ error: error, errorExpand: true });
        }
    };
    handleMyAlert = async (item, isRelevant) => {
        let resp = "";
        let userId = UserData.sub
        var url = `${_locationOrigin}/api/pubmed/alerts/search`;
        if (window.location.origin === "https://predev-ims.jnj.com") {
            url = `${window.location.origin}/api/pubmed/alerts/search`;
        }
        this.setState({
            selectedAlert: item,
            alertSearchKeyword: item.search_keyword,
            showMyAlert: true,
            showPersonalAlerts: false,
            fromGlobalTab: false,
            isProcessing: true,
        })
        const _data = {
            user_id: userId,
            alert_id: item.item_id,
            size: 10,
            from_: 0,
            alert_date: {
                // "eq" : "2026-04-22T00:00:00Z"
                last_n_days: 7
            }
        }
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.post(
            url, _data,
            {
                headers: _headers,
            }
        )
        /*await axios.post(url,{
            headers:_headers,
            data:{
                alert_id: `${item.item_id}`,
                last_n_days: 7
            }
        }*/.then((response) => {
            let _pubMedXSearchId = response.headers["x-search-id"];
            var processed = processPubMedFilters(response.data.body);
            const filterService = new FilterService();
            const [filters] = filterService.expandFilterSet(
                processed,
                this.state.appliedFilters
            );
            let selectedFiltered = this.state.appliedFilters.concat(filters);
            response.data.hits.hits.map((hitItem, hitIndex) => {
                hitItem._source.rli_id = uuidv4();
                hitItem._source.relevant = hitItem._source.relevant
                    ? hitItem._source.relevant
                    : "False";
                hitItem._source.summary = hitItem._source.summary
                    ? hitItem._source.summary
                    : "";
                hitItem._source.resultID = hitItem._id;
            });
            this.setState({
                alertResponses: response.data.hits.hits,
                documentAlertCount: response.data.hits.total.value
            })
        }).catch((eror) => {
            console.log(eror)
        }).finally(() => {
            this.setState({ isProcessing: false })
        })
    }
    handleAlertFrequency = async (frequency) => {
        this.setState({ alertsFrequencySelected: frequency })
        let resp = "";
        let userId = UserData.sub;
        var url = `${_locationOrigin}/api/pubmed/alerts/search`;
        if (window.location.origin === "https://predev-ims.jnj.com") {
            url = `${window.location.origin}/api/pubmed/alerts/search`;
        }
        this.setState({
            isProcessing: true,
        })
        const _data = {
            user_id: userId,
            alert_id: this.state.selectedAlert.item_id,
            size: 10,
            from_: 0,
            alert_date: {
                // "eq" : "2026-04-22T00:00:00Z"
                last_n_days: parseInt(frequency)
            }

        }
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.post(
            url, _data,
            {
                headers: _headers,
            }
        ).then((response) => {
            let _pubMedXSearchId = response.headers["x-search-id"];
            var processed = processPubMedFilters(response.data.body);
            const filterService = new FilterService();
            const [filters] = filterService.expandFilterSet(
                processed,
                this.state.appliedFilters
            );
            let selectedFiltered = this.state.appliedFilters.concat(filters);
            response.data.hits.hits.map((hitItem, hitIndex) => {
                hitItem._source.rli_id = uuidv4();
                hitItem._source.relevant = hitItem._source.relevant
                    ? hitItem._source.relevant
                    : "False";
                hitItem._source.summary = hitItem._source.summary
                    ? hitItem._source.summary
                    : "";
                hitItem._source.resultID = hitItem._id;
            });
            this.setState({
                alertResponses: response.data.hits.hits,
                documentAlertCount: response.data.hits.total.value
            })
        }).catch((eror) => {
            console.log(eror)
        }).finally(() => {
            this.setState({ isProcessing: false })
        })
    }
    handleAlertFrequencySizeChange = async (alert_size) => {
        let { alertsFrequencySelected } = this.state
        this.setState({ itemsPerAlertPage: alert_size })
        let resp = "";
        let userId = UserData.sub;
        var url = `${_locationOrigin}/api/pubmed/alerts/search`;
        if (window.location.origin === "https://predev-ims.jnj.com") {
            url = `${window.location.origin}/api/pubmed/alerts/search`;
        }
        this.setState({
            isProcessing: true,
        })

        const _data = {
            user_id: userId,
            last_n_days: parseInt(alertsFrequencySelected),
            //tab: (isRelevant ? "relevant" : "non relevant"),
            size: alert_size,
            from_: 0,

        }
        const _headers = {
            'Content-Type': 'application/json'
        };
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.post(
            url, _data,
            {
                headers: _headers,
            }
        ).then((response) => {
            let _pubMedXSearchId = response.headers["x-search-id"];
            var processed = processPubMedFilters(response.data.body);
            const filterService = new FilterService();
            const [filters] = filterService.expandFilterSet(
                processed,
                this.state.appliedFilters
            );
            let selectedFiltered = this.state.appliedFilters.concat(filters);
            response.data.hits.hits.map((hitItem, hitIndex) => {
                hitItem._source.rli_id = uuidv4();
                hitItem._source.relevant = hitItem._source.relevant
                    ? hitItem._source.relevant
                    : "False";
                hitItem._source.summary = hitItem._source.summary
                    ? hitItem._source.summary
                    : "";
                hitItem._source.resultID = hitItem._id;
            });
            this.setState({
                alertResponses: response.data.hits.hits,
                documentAlertCount: response.data.hits.total.value
            })
        }).catch((eror) => {
            console.log(eror)
        }).finally(() => {
            this.setState({ isProcessing: false })
        })
    }
    render() {
        let {
            searchKeyword,
            isRenderLandingPage,
            selectedTab,
            abstractsSearchKeyword,
            reviewListSearchKeyword,
            saveSearchSearchKeyword,
            alertSearchKeyword
        } = this.state;
        console.log(this.state.isAlertReleventSelected)
        const {
            alertMessageModelColor,
            alertMessageContent,
            alertMessageShowModal,
            useTemplate,
        } = this.state;
        if (this.state.width >= 600 && this.state.width <= 1000) {
            return (
                <PubMedSearchAskQuestionIndex
                    customWidth={this.state.width}
                    customHeight={this.state.height}
                />
            );
        } else if (this.state.width > 1000) {
            return (
                <div>
                    <ErrorBoundary>
                        {this.state.userExists ? (
                            <>
                                <div className="pubmed-main-innerWrapper">
                                    <PubMedNavigationMenu
                                        pathName={window.location.pathname}
                                        customWidth={this.state.width}
                                        customHeight={this.state.height}
                                    />
                                    <div className="pubmed-main-section-container">
                                        {this.state.isLoaded ? (
                                            <>
                                                {isRenderLandingPage ? (
                                                    <PubMedSearchAskQuestionIndex
                                                        customWidth={this.state.width}
                                                        customHeight={this.state.height}
                                                        searchKeyword={searchKeyword}
                                                        handleChangeInSearch={this.handleChangeInSearch}
                                                    />
                                                ) : (
                                                    <>
                                                        <div className="pubmed-main-ask-question-headerWithBanner">
                                                            <div className="pubmed-main-ask-question-headerWithBanner-left">
                                                                <Link to="/">
                                                                    <img
                                                                        className="bm-agent-image"
                                                                        src={JJ_IMedical_icon}
                                                                        alt="iMS profile image"
                                                                        style={{ padding: '2.5px', margin: '0.75%', height: "50px" }}
                                                                    />
                                                                </Link>
                                                            </div>
                                                            <div className="pubmed-main-ask-question-headerWithBanner-right">
                                                                <div className="pubmed-main-ask-question-headerWithBanner-pubmedicon-wrapper">
                                                                    <img
                                                                        src={pubMedIcon}
                                                                        alt=""
                                                                        className="global-feature-pubmedicon"
                                                                    />
                                                                </div>
                                                                <div className="pubmed-main-ask-question-headerWithBanner-pubmednih-wrapper">
                                                                    <img src={pubMedNIH} alt="" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", zIndex: "1" }}>
                                                            <div style={{ padding: "5px", backgroundColor: "#ffe597" }}>Attention users: iMS PubMed is currently under maintenance. Please check back at 3 am EDT</div>
                                                        </div> */}
                                                        <div className="pubmed-main-section">
                                                            <div className="pubmed-main-left-section">
                                                                {selectedTab === "0" && (
                                                                    <>
                                                                        <PubMedLeftSearchBoxIndex
                                                                            customWidth={this.state.width}
                                                                            customHeight={this.state.height}
                                                                            searchKeyword={searchKeyword}
                                                                            appliedFilters={this.state.appliedFilters}
                                                                            handleChangeInSearch={
                                                                                this.handleChangeInSearch
                                                                            }
                                                                            selectedTab={selectedTab}
                                                                            useTemplate={this.state.useTemplate}
                                                                            handleOnClickResetIcon={this.handleOnClickResetIcon}
                                                                            isAnyChangeAfterResult={false}
                                                                        />
                                                                        <div className="pubmed-main-left-section-filter-contents-wrapper">
                                                                            <div
                                                                                className={
                                                                                    this.state.showFilters
                                                                                        ? "filterMenuWrapper pubmed-main-filterMenuWrapperExpanded"
                                                                                        : "filterMenuWrapper pubmed-main-filterMenuWrapperCollapse"
                                                                                }
                                                                                style={{ float: "left" }}
                                                                            >
                                                                                {this.state.showFilters ? (
                                                                                    <>
                                                                                        <div className="filterMenuHeader filterMenuHeader-pubmed">
                                                                                            <span className="filter-menu-icon-wrapper">
                                                                                                <img
                                                                                                    src={filterIconWhite}
                                                                                                    alt=""
                                                                                                />
                                                                                            </span>
                                                                                            <span>Filters</span>
                                                                                            <span
                                                                                                style={{ float: "right" }}
                                                                                                onClick={(e) =>
                                                                                                    this.setState({
                                                                                                        showFilters:
                                                                                                            !this.state.showFilters,
                                                                                                    })
                                                                                                }
                                                                                            >
                                                                                                <img
                                                                                                    src={collapseFilterWhite}
                                                                                                    alt=""
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="pubmed-main-left-section-filter-menu-content">
                                                                                            {(this.state.isLoaded && !this.state.isProcessing) ? (
                                                                                                this.state.error === "" ? (
                                                                                                    <SearchFilter
                                                                                                        allFilters={
                                                                                                            this.state.allFilters
                                                                                                        }
                                                                                                        filters={this.state.filters}
                                                                                                        appliedFilters={
                                                                                                            this.state.appliedFilters
                                                                                                        }
                                                                                                        handleOnChangeInfilter={
                                                                                                            this
                                                                                                                .handleOnChangeInfilter
                                                                                                        }
                                                                                                        selectedParentFilterArr={
                                                                                                            this.state
                                                                                                                .selectedParentFilterArr
                                                                                                        }
                                                                                                        handleChangeInSearch={
                                                                                                            this.handleChangeInSearch
                                                                                                        }
                                                                                                        selectedFilters={
                                                                                                            this.state.selectedFilters
                                                                                                        }
                                                                                                        querytext={
                                                                                                            this.state.searchKeyword
                                                                                                        }
                                                                                                        documentCount={
                                                                                                            this.state.documentCount
                                                                                                        }
                                                                                                        response={
                                                                                                            this.state.response
                                                                                                        }
                                                                                                        isProcessing={
                                                                                                            this.state.isProcessing
                                                                                                        }
                                                                                                        csPath={this.state.csPath}
                                                                                                        csproduct={
                                                                                                            this.state.csproduct
                                                                                                        }
                                                                                                        customWidth={
                                                                                                            this.state.width
                                                                                                        }
                                                                                                        appliedFiltersForOnlyiMS={
                                                                                                            this.state
                                                                                                                .appliedFiltersForOnlyiMS
                                                                                                        }
                                                                                                        key={`filter-menu-content-${this.state.filters.length}`}
                                                                                                        filterYears={
                                                                                                            this.state.filterYears
                                                                                                        }
                                                                                                        fromYear={
                                                                                                            this.state.fromYear
                                                                                                        }
                                                                                                        toYear={this.state.toYear}
                                                                                                        handleYearSelection={
                                                                                                            this.handleYearSelection
                                                                                                        }
                                                                                                        handlePageChange={
                                                                                                            this.gotoPage
                                                                                                        }
                                                                                                        handleToYear={
                                                                                                            this.handleToYear
                                                                                                        }
                                                                                                        handleFromYear={
                                                                                                            this.handleFromYear
                                                                                                        }
                                                                                                        selectedTab={selectedTab}
                                                                                                        useTemplate={this.state.useTemplate}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <SearchFilter
                                                                                                        allFilters={[]}
                                                                                                        filters={[]}
                                                                                                        appliedFilters={[]}
                                                                                                        handleOnChangeInfilter={
                                                                                                            this
                                                                                                                .handleOnChangeInfilter
                                                                                                        }
                                                                                                        selectedParentFilterArr={[]}
                                                                                                        handleChangeInSearch={
                                                                                                            this.handleChangeInSearch
                                                                                                        }
                                                                                                        selectedFilters={[]}
                                                                                                        querytext={
                                                                                                            this.state.searchKeyword
                                                                                                        }
                                                                                                        documentCount={0}
                                                                                                        response={[]}
                                                                                                        isProcessing={
                                                                                                            this.state.isProcessing
                                                                                                        }
                                                                                                        csPath={this.state.csPath}
                                                                                                        csproduct={
                                                                                                            this.state.csproduct
                                                                                                        }
                                                                                                        customWidth={
                                                                                                            this.state.width
                                                                                                        }
                                                                                                        appliedFiltersForOnlyiMS={[]}
                                                                                                        key={`filter-menu-content-${this.state.filters.length}`}
                                                                                                        filterYears={[]}
                                                                                                        fromYear={this.state.fromYear}
                                                                                                        toYear={this.state.toYear}
                                                                                                        handleYearSelection={
                                                                                                            this.handleYearSelection
                                                                                                        }
                                                                                                        handlePageChange={
                                                                                                            this.gotoPage
                                                                                                        }
                                                                                                        selectedTab={selectedTab}
                                                                                                        useTemplate={this.state.useTemplate}
                                                                                                        isError={true}
                                                                                                    />
                                                                                                )
                                                                                            ) : (
                                                                                                <div
                                                                                                    style={{
                                                                                                        textAlign: "center",
                                                                                                        padding: "10%",
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={imsLoader}
                                                                                                        alt="Loading Filters"
                                                                                                        style={{ width: "20%" }}
                                                                                                    />
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div
                                                                                            className="result-filter-expand-wrapper"
                                                                                            onClick={(e) =>
                                                                                                this.setState({
                                                                                                    showFilters:
                                                                                                        !this.state.showFilters,
                                                                                                })
                                                                                            }
                                                                                        >
                                                                                            <img
                                                                                                src={expandFilterWhite}
                                                                                                alt=""
                                                                                            />
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {selectedTab === "1" && (
                                                                    <>
                                                                        <PubMedLeftSearchBoxIndex
                                                                            appliedFilters={this.state.appliedOvidAbstractFilters}
                                                                            customWidth={this.state.width}
                                                                            customHeight={this.state.height}
                                                                            searchKeyword={abstractsSearchKeyword}
                                                                            selectedTab={selectedTab}
                                                                            useTemplate={this.state.useTemplate}
                                                                            handleChangeInSearch={
                                                                                this.handleChangeInAbstractsSearch
                                                                            }
                                                                            handleOnClickResetIcon={this.handleOnClickResetIcon}
                                                                            isAnyChangeAfterResult={this.state.isAnyChangeAfterAbstractResult}
                                                                        />

                                                                        <PubMedLeftUploadAbstracts
                                                                            customWidth={this.state.width}
                                                                            useTemplate={this.state.useTemplate}
                                                                            customHeight={this.state.height}
                                                                            mathRandom={this.state.mathRandom}
                                                                            fileInputChange={this.fileInputChange}
                                                                            handleRemoveAttachedFile={
                                                                                this.handleRemoveAttachedFile
                                                                            }
                                                                            handleOnChangeUseTemplate={
                                                                                this.handleOnChangeUseTemplate
                                                                            }
                                                                            uploadFilePlaceHolder={
                                                                                this.state.uploadFilePlaceHolder
                                                                            }
                                                                            uploadFilePlaceHolderTitle={
                                                                                this.state.uploadFilePlaceHolderTitle
                                                                            }
                                                                        />

                                                                        <div className="pubmed-main-left-section-filter-contents-wrapper">
                                                                            <div
                                                                                className={
                                                                                    this.state.showFilters
                                                                                        ? "filterMenuWrapper pubmed-main-filterMenuWrapperExpanded"
                                                                                        : "filterMenuWrapper pubmed-main-filterMenuWrapperCollapse"
                                                                                }
                                                                                style={{ float: "left" }}
                                                                            >
                                                                                {this.state.showFilters ? (
                                                                                    <>
                                                                                        <div className="filterMenuHeader filterMenuHeader-pubmed">
                                                                                            <span className="filter-menu-icon-wrapper">
                                                                                                <img
                                                                                                    src={filterIconWhite}
                                                                                                    alt=""
                                                                                                />
                                                                                            </span>
                                                                                            <span>Filters</span>
                                                                                            <span
                                                                                                style={{ float: "right" }}
                                                                                                onClick={(e) =>
                                                                                                    this.setState({
                                                                                                        showFilters:
                                                                                                            !this.state.showFilters,
                                                                                                    })
                                                                                                }
                                                                                            >
                                                                                                <img
                                                                                                    src={collapseFilterWhite}
                                                                                                    alt=""
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="pubmed-main-left-section-filter-menu-content">
                                                                                            {(this.state.isLoaded && !this.state.isProcessing) ? (
                                                                                                this.state.error === "" ? (
                                                                                                    <SearchFilter
                                                                                                        allFilters={
                                                                                                            this.state.allOvidAbstractFilters
                                                                                                        }
                                                                                                        filters={this.state.ovidAbstractFilters}
                                                                                                        appliedFilters={
                                                                                                            this.state.appliedOvidAbstractFilters
                                                                                                        }
                                                                                                        handleOnChangeInfilter={
                                                                                                            this.handleOvidAbstractOnChangeInfilter
                                                                                                        }
                                                                                                        selectedParentFilterArr={
                                                                                                            this.state.selectedParentOvidAbstractFilterArr
                                                                                                        }
                                                                                                        handleChangeInSearch={
                                                                                                            this.handleChangeInAbstractsSearch
                                                                                                        }
                                                                                                        selectedFilters={
                                                                                                            this.state.selectedOvidAbstractFilters
                                                                                                        }
                                                                                                        querytext={
                                                                                                            this.state.abstractsSearchKeyword
                                                                                                        }
                                                                                                        documentCount={
                                                                                                            this.state.documentOvidAbstractCount
                                                                                                        }
                                                                                                        response={
                                                                                                            this.state.ovidAbstractResponse
                                                                                                        }
                                                                                                        isProcessing={
                                                                                                            this.state.isProcessing
                                                                                                        }
                                                                                                        csPath={this.state.csPath}
                                                                                                        csproduct={
                                                                                                            this.state.csproduct
                                                                                                        }
                                                                                                        customWidth={
                                                                                                            this.state.width
                                                                                                        }
                                                                                                        appliedFiltersForOnlyiMS={
                                                                                                            this.state.appliedFiltersForOnlyiMS
                                                                                                        }
                                                                                                        key={`filter-menu-content-${this.state.ovidAbstractFilters.length}`}
                                                                                                        filterYears={
                                                                                                            this.state.filterYears
                                                                                                        }
                                                                                                        fromYear={
                                                                                                            this.state.fromOvidAbstractYear
                                                                                                        }
                                                                                                        toYear={this.state.toOvidAbstractYear}
                                                                                                        handleYearSelection={
                                                                                                            this.handleOvidAbstractYearSelection
                                                                                                        }
                                                                                                        handlePageChange={
                                                                                                            this.gotoOvidAbstractPage
                                                                                                        }
                                                                                                        handleToYear={
                                                                                                            this.handleToYear
                                                                                                        }
                                                                                                        handleFromYear={
                                                                                                            this.handleFromYear
                                                                                                        }
                                                                                                        selectedTab={selectedTab}
                                                                                                        useTemplate={this.state.useTemplate}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <SearchFilter
                                                                                                        allFilters={[]}
                                                                                                        filters={[]}
                                                                                                        appliedFilters={[]}
                                                                                                        handleOnChangeInfilter={
                                                                                                            this
                                                                                                                .handleOvidAbstractOnChangeInfilter
                                                                                                        }
                                                                                                        selectedParentFilterArr={[]}
                                                                                                        handleChangeInSearch={
                                                                                                            this.handleChangeInAbstractsSearch
                                                                                                        }
                                                                                                        selectedFilters={[]}
                                                                                                        querytext={
                                                                                                            this.state.abstractsSearchKeyword
                                                                                                        }
                                                                                                        documentCount={0}
                                                                                                        response={[]}
                                                                                                        isProcessing={
                                                                                                            this.state.isProcessing
                                                                                                        }
                                                                                                        csPath={this.state.csPath}
                                                                                                        csproduct={
                                                                                                            this.state.csproduct
                                                                                                        }
                                                                                                        customWidth={
                                                                                                            this.state.width
                                                                                                        }
                                                                                                        appliedFiltersForOnlyiMS={[]}
                                                                                                        key={`filter-menu-content-${this.state.ovidAbstractFilters.length}`}
                                                                                                        filterYears={[]}
                                                                                                        fromYear={this.state.fromOvidAbstractYear}
                                                                                                        toYear={this.state.toOvidAbstractYear}
                                                                                                        handleYearSelection={
                                                                                                            this.handleOvidAbstractYearSelection
                                                                                                        }
                                                                                                        handlePageChange={
                                                                                                            this.gotoOvidAbstractPage
                                                                                                        }
                                                                                                        isError={true}
                                                                                                    />
                                                                                                )
                                                                                            ) : (
                                                                                                <div
                                                                                                    style={{
                                                                                                        textAlign: "center",
                                                                                                        padding: "10%",
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={imsLoader}
                                                                                                        alt="Loading Filters"
                                                                                                        style={{ width: "20%" }}
                                                                                                    />
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div
                                                                                            className="result-filter-expand-wrapper"
                                                                                            onClick={(e) =>
                                                                                                this.setState({
                                                                                                    showFilters:
                                                                                                        !this.state.showFilters,
                                                                                                })
                                                                                            }
                                                                                        >
                                                                                            <img
                                                                                                src={expandFilterWhite}
                                                                                                alt=""
                                                                                            />
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {selectedTab === "2" && (
                                                                    <>
                                                                        <PubMedLeftSearchBoxIndex
                                                                            appliedFilters={this.state.appliedReviewListFilters}
                                                                            customWidth={this.state.width}
                                                                            customHeight={this.state.height}
                                                                            searchKeyword={reviewListSearchKeyword}
                                                                            selectedTab={selectedTab}
                                                                            useTemplate={this.state.useTemplate}
                                                                            handleChangeInSearch={
                                                                                this.handleChangeInReviewListSearch
                                                                            }
                                                                            handleOnClickResetIcon={this.handleOnClickResetIcon}
                                                                            isAnyChangeAfterResult={this.state.isAnyChangeAfterReviewListResult}
                                                                        />

                                                                        <div className="pubmed-main-left-section-filter-contents-wrapper">
                                                                            <div
                                                                                className={
                                                                                    this.state.showReviewListFilters
                                                                                        ? "filterMenuWrapper pubmed-main-filterMenuWrapperExpanded"
                                                                                        : "filterMenuWrapper pubmed-main-filterMenuWrapperCollapse"
                                                                                }
                                                                                style={{ float: "left" }}
                                                                            >
                                                                                {this.state.showReviewListFilters ? (
                                                                                    <>
                                                                                        <div className="filterMenuHeader filterMenuHeader-pubmed">
                                                                                            <span className="filter-menu-icon-wrapper">
                                                                                                <img
                                                                                                    src={filterIconWhite}
                                                                                                    alt=""
                                                                                                />
                                                                                            </span>
                                                                                            <span>Filters</span>
                                                                                            <span
                                                                                                style={{ float: "right" }}
                                                                                                onClick={(e) =>
                                                                                                    this.setState({
                                                                                                        showReviewListFilters:
                                                                                                            !this.state.showReviewListFilters,
                                                                                                    })
                                                                                                }
                                                                                            >
                                                                                                <img
                                                                                                    src={collapseFilterWhite}
                                                                                                    alt=""
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="pubmed-main-left-section-filter-menu-content">
                                                                                            {(this.state.isLoaded && !this.state.isProcessing) ? (
                                                                                                this.state.error === "" ? (
                                                                                                    <SearchFilter
                                                                                                        allFilters={
                                                                                                            this.state.allReviewListFilters
                                                                                                        }
                                                                                                        filters={this.state.reviewListFilters}
                                                                                                        appliedFilters={
                                                                                                            this.state.appliedReviewListFilters
                                                                                                        }
                                                                                                        handleOnChangeInfilter={
                                                                                                            this
                                                                                                                .handleOnChangeInReviewListfilter
                                                                                                        }
                                                                                                        selectedParentFilterArr={
                                                                                                            this.state
                                                                                                                .selectedParentReviewListFilterArr
                                                                                                        }
                                                                                                        handleChangeInSearch={
                                                                                                            this.handleChangeInSearch
                                                                                                        }
                                                                                                        selectedFilters={
                                                                                                            this.state.selectedReviewListFilters
                                                                                                        }
                                                                                                        querytext={
                                                                                                            this.state.reviewListSearchKeyword
                                                                                                        }
                                                                                                        documentCount={
                                                                                                            this.state.documentReviewListCount
                                                                                                        }
                                                                                                        response={
                                                                                                            this.state.reviewListResponse
                                                                                                        }
                                                                                                        isProcessing={
                                                                                                            this.state.isProcessing
                                                                                                        }
                                                                                                        csPath={this.state.csPath}
                                                                                                        csproduct={
                                                                                                            this.state.csproduct
                                                                                                        }
                                                                                                        customWidth={
                                                                                                            this.state.width
                                                                                                        }
                                                                                                        appliedFiltersForOnlyiMS={
                                                                                                            this.state
                                                                                                                .appliedFiltersForOnlyiMS
                                                                                                        }
                                                                                                        key={`filter-menu-content-${this.state.reviewListFilters.length}`}
                                                                                                        filterYears={
                                                                                                            this.state.filterYears
                                                                                                        }
                                                                                                        fromYear={
                                                                                                            this.state.reviewListFromYear
                                                                                                        }
                                                                                                        toYear={this.state.reviewListToYear}
                                                                                                        handleYearSelection={
                                                                                                            this.handleYearSelectionReviewList
                                                                                                        }
                                                                                                        handlePageChange={
                                                                                                            this.gotoReviewListPage
                                                                                                        }
                                                                                                        handleToYear={
                                                                                                            this.handleToYear
                                                                                                        }
                                                                                                        handleFromYear={
                                                                                                            this.handleFromYear
                                                                                                        }
                                                                                                        selectedTab={selectedTab}
                                                                                                        useTemplate={this.state.useTemplate}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <SearchFilter
                                                                                                        allFilters={[]}
                                                                                                        filters={[]}
                                                                                                        appliedFilters={[]}
                                                                                                        handleOnChangeInfilter={
                                                                                                            this
                                                                                                                .handleOnChangeInReviewListfilter
                                                                                                        }
                                                                                                        selectedParentFilterArr={[]}
                                                                                                        handleChangeInSearch={
                                                                                                            this.handleChangeInSearch
                                                                                                        }
                                                                                                        selectedFilters={[]}
                                                                                                        querytext={
                                                                                                            this.state.reviewListSearchKeyword
                                                                                                        }
                                                                                                        documentCount={0}
                                                                                                        response={[]}
                                                                                                        isProcessing={
                                                                                                            this.state.isProcessing
                                                                                                        }
                                                                                                        csPath={this.state.csPath}
                                                                                                        csproduct={
                                                                                                            this.state.csproduct
                                                                                                        }
                                                                                                        customWidth={
                                                                                                            this.state.width
                                                                                                        }
                                                                                                        appliedFiltersForOnlyiMS={[]}
                                                                                                        key={`filter-menu-content-${this.state.reviewListFilters.length}`}
                                                                                                        filterYears={[]}
                                                                                                        fromYear={this.state.reviewListFromYear}
                                                                                                        toYear={this.state.reviewListToYear}
                                                                                                        handleYearSelection={
                                                                                                            this.handleYearSelectionReviewList
                                                                                                        }
                                                                                                        handlePageChange={
                                                                                                            this.gotoReviewListPage
                                                                                                        }
                                                                                                        selectedTab={selectedTab}
                                                                                                        useTemplate={this.state.useTemplate}
                                                                                                        isError={true}
                                                                                                    />
                                                                                                )
                                                                                            ) : (
                                                                                                <div
                                                                                                    style={{
                                                                                                        textAlign: "center",
                                                                                                        padding: "10%",
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={imsLoader}
                                                                                                        alt="Loading Filters"
                                                                                                        style={{ width: "20%" }}
                                                                                                    />

                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div
                                                                                            className="result-filter-expand-wrapper"
                                                                                            onClick={(e) =>
                                                                                                this.setState({
                                                                                                    showReviewListFilters:
                                                                                                        !this.state.showReviewListFilters,
                                                                                                })
                                                                                            }
                                                                                        >
                                                                                            <img
                                                                                                src={expandFilterWhite}
                                                                                                alt=""
                                                                                            />
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                                {selectedTab === "3" && (
                                                                    <>
                                                                        <PubMedLeftSearchBoxIndex
                                                                            appliedFilters={this.state.appliedSaveSearchFilters}
                                                                            customWidth={this.state.width}
                                                                            customHeight={this.state.height}
                                                                            searchKeyword={saveSearchSearchKeyword}
                                                                            selectedTab={selectedTab}
                                                                            useTemplate={this.state.useTemplate}
                                                                            handleChangeInSearch={
                                                                                this.handleChangeInSaveSearchesSearch
                                                                            }
                                                                            handleOnClickResetIcon={this.handleOnClickResetIcon}
                                                                            isAnyChangeAfterResult={this.state.isAnyChangeAfterSaveSearchResult}
                                                                        />
                                                                        <div className="pubmed-main-left-section-filter-contents-wrapper">
                                                                            <div
                                                                                className={
                                                                                    this.state.showFilters
                                                                                        ? "filterMenuWrapper pubmed-main-filterMenuWrapperExpanded"
                                                                                        : "filterMenuWrapper pubmed-main-filterMenuWrapperCollapse"
                                                                                }
                                                                                style={{ float: "left" }}
                                                                            >
                                                                                {this.state.showFilters ? (
                                                                                    <>
                                                                                        <div className="filterMenuHeader filterMenuHeader-pubmed">
                                                                                            <span className="filter-menu-icon-wrapper">
                                                                                                <img
                                                                                                    src={filterIconWhite}
                                                                                                    alt=""
                                                                                                />
                                                                                            </span>
                                                                                            <span>Filters</span>
                                                                                            <span
                                                                                                style={{ float: "right" }}
                                                                                                onClick={(e) =>
                                                                                                    this.setState({
                                                                                                        showFilters:
                                                                                                            !this.state.showFilters,
                                                                                                    })
                                                                                                }
                                                                                            >
                                                                                                <img
                                                                                                    src={collapseFilterWhite}
                                                                                                    alt=""
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="pubmed-main-left-section-filter-menu-content">
                                                                                            {(this.state.isLoaded && !this.state.isProcessing) ? (
                                                                                                this.state.error === "" ? (
                                                                                                    <SearchFilter
                                                                                                        allFilters={
                                                                                                            this.state.allSaveSearchFilters
                                                                                                        }
                                                                                                        filters={this.state.saveSearchFilters}
                                                                                                        appliedFilters={
                                                                                                            this.state.appliedSaveSearchFilters
                                                                                                        }
                                                                                                        handleOnChangeInfilter={
                                                                                                            this.handleSaveSearchOnChangeInfilter
                                                                                                        }
                                                                                                        selectedParentFilterArr={
                                                                                                            this.state.selectedParentSaveSearchFilterArr
                                                                                                        }
                                                                                                        handleChangeInSearch={
                                                                                                            this.handleChangeInSaveSearchesSearch
                                                                                                        }
                                                                                                        selectedFilters={
                                                                                                            this.state.selectedSaveSearchFilters
                                                                                                        }
                                                                                                        querytext={
                                                                                                            this.state.saveSearchSearchKeyword
                                                                                                        }
                                                                                                        documentCount={
                                                                                                            this.state.documentSaveSearchCount
                                                                                                        }
                                                                                                        response={
                                                                                                            this.state.saveSearchResponse
                                                                                                        }
                                                                                                        isProcessing={
                                                                                                            this.state.isProcessing
                                                                                                        }
                                                                                                        csPath={this.state.csPath}
                                                                                                        csproduct={
                                                                                                            this.state.csproduct
                                                                                                        }
                                                                                                        customWidth={
                                                                                                            this.state.width
                                                                                                        }
                                                                                                        appliedFiltersForOnlyiMS={
                                                                                                            this.state.appliedFiltersForOnlyiMS
                                                                                                        }
                                                                                                        key={`filter-menu-content-${this.state.saveSearchFilters.length}`}
                                                                                                        filterYears={
                                                                                                            this.state.filterYears
                                                                                                        }
                                                                                                        fromYear={
                                                                                                            this.state.fromSaveSearchYear
                                                                                                        }
                                                                                                        toYear={this.state.toSaveSearchYear}
                                                                                                        handleYearSelection={
                                                                                                            this.handleSaveSearchYearSelection
                                                                                                        }
                                                                                                        handlePageChange={
                                                                                                            this.gotoSaveSearchPage
                                                                                                        }
                                                                                                        handleToYear={
                                                                                                            this.handleToYear
                                                                                                        }
                                                                                                        handleFromYear={
                                                                                                            this.handleFromYear
                                                                                                        }
                                                                                                        selectedTab={selectedTab}
                                                                                                        useTemplate={this.state.useTemplate}

                                                                                                    />
                                                                                                ) : (
                                                                                                    <SearchFilter
                                                                                                        allFilters={[]}
                                                                                                        filters={[]}
                                                                                                        appliedFilters={[]}
                                                                                                        handleOnChangeInfilter={
                                                                                                            this
                                                                                                                .handleSaveSearchOnChangeInfilter
                                                                                                        }
                                                                                                        selectedParentFilterArr={[]}
                                                                                                        handleChangeInSearch={
                                                                                                            this.handleChangeInSaveSearchesSearch
                                                                                                        }
                                                                                                        selectedFilters={[]}
                                                                                                        querytext={
                                                                                                            this.state.saveSearchSearchKeyword
                                                                                                        }
                                                                                                        documentCount={0}
                                                                                                        response={[]}
                                                                                                        isProcessing={
                                                                                                            this.state.isProcessing
                                                                                                        }
                                                                                                        csPath={this.state.csPath}
                                                                                                        csproduct={
                                                                                                            this.state.csproduct
                                                                                                        }
                                                                                                        customWidth={
                                                                                                            this.state.width
                                                                                                        }
                                                                                                        appliedFiltersForOnlyiMS={[]}
                                                                                                        key={`filter-menu-content-${this.state.saveSearchFilters.length}`}
                                                                                                        filterYears={[]}
                                                                                                        fromYear={this.state.fromSaveSearchYear}
                                                                                                        toYear={this.state.toSaveSearchYear}
                                                                                                        handleYearSelection={
                                                                                                            this.handleSaveSearchYearSelection
                                                                                                        }
                                                                                                        handlePageChange={
                                                                                                            this.gotoSaveSearchPage
                                                                                                        }
                                                                                                        selectedTab={selectedTab}
                                                                                                        useTemplate={this.state.useTemplate}
                                                                                                        isError={true}
                                                                                                    />
                                                                                                )
                                                                                            ) : (
                                                                                                <div
                                                                                                    style={{
                                                                                                        textAlign: "center",
                                                                                                        padding: "10%",
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        src={imsLoader}
                                                                                                        alt="Loading Filters"
                                                                                                        style={{ width: "20%" }}
                                                                                                    />
                                                                                                </div>
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <div
                                                                                            className="result-filter-expand-wrapper"
                                                                                            onClick={(e) =>
                                                                                                this.setState({
                                                                                                    showFilters:
                                                                                                        !this.state.showFilters,
                                                                                                })
                                                                                            }
                                                                                        >
                                                                                            <img
                                                                                                src={expandFilterWhite}
                                                                                                alt=""
                                                                                            />
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>


                                                                    </>
                                                                )}
                                                                {selectedTab === "4" && (
                                                                    <>
                                                                        <PubMedLeftSearchBoxIndex
                                                                            appliedFilters={this.state.appliedSaveSearchFilters}
                                                                            customWidth={this.state.width}
                                                                            customHeight={this.state.height}
                                                                            searchKeyword={alertSearchKeyword}
                                                                            selectedTab={selectedTab}
                                                                            useTemplate={this.state.useTemplate}
                                                                            handleChangeInSearch={
                                                                                this.handleChangeInSaveSearchesSearch
                                                                            }
                                                                            handleOnClickResetIcon={this.handleOnClickResetIcon}
                                                                            isAnyChangeAfterResult={this.state.isAnyChangeAfterAlertResult}
                                                                        />
                                                                    </>)}
                                                                <div className="pubmed-main-left-section-message-content">
                                                                    <span>
                                                                        The answer and the extracted information was
                                                                        obtained with a large language model and
                                                                        might contain errors and inaccuracies. All
                                                                        information presented needs to
                                                                        be carefully checked.
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="pubmed-main-right-section">

                                                                <Tabs
                                                                    defaultTab={selectedTab.toString()}
                                                                    selectedindex={selectedTab}
                                                                    onClick={this.handleOnTabClick}
                                                                >
                                                                    <TabList className="tablist-pubmed">
                                                                        <Tab
                                                                            tabFor="0"
                                                                            className={
                                                                                selectedTab === "0"
                                                                                    ? `${this.state.width < 1200 ? 'tab-list-item-pubmed-1 tab-list-item-pubmed-active' : 'tab-list-item-pubmed tab-list-item-pubmed-active'}`
                                                                                    : `${this.state.width < 1200 ? 'tab-list-item-pubmed-1' : 'tab-list-item-pubmed'}`
                                                                            }

                                                                        >
                                                                            PubMed
                                                                        </Tab>
                                                                        <Tab
                                                                            tabFor="1"
                                                                            className={
                                                                                selectedTab === "1"
                                                                                    ? "tab-list-item-pubmed tab-list-item-pubmed-active"
                                                                                    : "tab-list-item-pubmed"
                                                                            }
                                                                        >
                                                                            Upload Abstracts
                                                                        </Tab>
                                                                        <Tab
                                                                            tabFor="2"
                                                                            className={
                                                                                selectedTab === "2"
                                                                                    ? "tab-list-item-pubmed tab-list-item-pubmed-active"
                                                                                    : "tab-list-item-pubmed"
                                                                            }
                                                                        >
                                                                            Review List
                                                                        </Tab>
                                                                        <Tab
                                                                            tabFor="3"
                                                                            className={
                                                                                selectedTab === "3"
                                                                                    ? "tab-list-item-pubmed tab-list-item-pubmed-active"
                                                                                    : "tab-list-item-pubmed"
                                                                            }
                                                                        >
                                                                            Saved Searches
                                                                        </Tab>
                                                                        <Tab
                                                                            tabFor="4"
                                                                            className={
                                                                                selectedTab === "4"
                                                                                    ? `${this.state.width < 1200 ? 'tab-list-item-pubmed-alert tab-list-item-pubmed-active' : 'tab-list-item-pubmed tab-list-item-pubmed-active'}`
                                                                                    : `${this.state.width < 1200 ? 'tab-list-item-pubmed-alert' : 'tab-list-item-pubmed'}`
                                                                            }
                                                                        >
                                                                            Alerts
                                                                        </Tab>
                                                                    </TabList>
                                                                    <TabPanel
                                                                        tabId="0"
                                                                        className="tabpanel-list-item-pubmed"
                                                                    >
                                                                        {this.state.error === "" &&
                                                                            this.state.response &&
                                                                            this.state.response.length > 0 && (
                                                                                <PubMedRightGenAIAnswer
                                                                                    customWidth={this.state.width}
                                                                                    customHeight={this.state.height}
                                                                                    data={this.state.answers}
                                                                                    selectedTab={this.state.selectedTab}
                                                                                    resultListRef={this.resultListRef}
                                                                                    selectedFinalAnsweringDocSize={this.state.selectedFinalAnsweringDocSize}
                                                                                    handleChangeSelectItems={this.handleAnswerChangeDocsize}
                                                                                />
                                                                            )}

                                                                        {this.state.error === "" &&
                                                                            this.state.response &&
                                                                            this.state.response.length > 0 && (
                                                                                <PubMedGlobalFeatures

                                                                                    getAllReviewListData={this.getAllReviewListData}
                                                                                    customWidth={this.state.width}
                                                                                    customHeight={this.state.height}
                                                                                    handelSelectedCitation={
                                                                                        this.getSelectedCitationDetails
                                                                                    }
                                                                                    pubmedResponse={this.state.response.map(
                                                                                        (x) => x._source
                                                                                    )}
                                                                                    pubMedXSearchId={
                                                                                        this.state.pubMedXSearchId
                                                                                    }
                                                                                    handleCollapseAllGlobal={
                                                                                        this.handleCollapseAllGlobal
                                                                                    }
                                                                                    selectedTab={selectedTab}
                                                                                    useTemplate={useTemplate}
                                                                                    selectedResults={
                                                                                        this.state.selectedResults
                                                                                    }
                                                                                    globalCollapseAll={
                                                                                        this.state.globalCollapseAll
                                                                                    }
                                                                                    globalSelectAll={
                                                                                        this.state.globalSelectAll
                                                                                    }
                                                                                    handleSelectAll={this.handleSelectAll}
                                                                                    searchKeyword={this.state.searchKeyword}
                                                                                    fromYear={this.state.fromYear}
                                                                                    toYear={this.state.toYear}
                                                                                    appliedFilters={this.state.appliedFilters}
                                                                                    handleViewSaveSearch={this.handleViewSaveSearch}
                                                                                    handleRemoveSaveSearch={this.handleRemoveSaveSearch}
                                                                                    openAlertPopup={this.openAlert}
                                                                                    openExportPopup={this.openExportPopup}
                                                                                    handleReviewNameTitle={this.handleReviewNameTitle}
                                                                                    handleRemoveReviewList={this.handleRemoveReviewList}
                                                                                />
                                                                            )}
                                                                        {this.state.appliedFilters.length > 0 ? (
                                                                            <FilterDisplay
                                                                                allFilters={this.state.allFilters}
                                                                                appliedFilters={
                                                                                    this.state.appliedFilters
                                                                                }
                                                                                handleClearFilters={
                                                                                    this.handleClearFilters
                                                                                }
                                                                                handleRemoveAppliedFilter={
                                                                                    this.handleRemoveAppliedFilter
                                                                                }
                                                                                customWidth={this.state.width}
                                                                            />
                                                                        ) : null}

                                                                        {this.state.response.length > 0 && (
                                                                            <>
                                                                                {this.state.error === ""
                                                                                    ? this.resultListCount(
                                                                                        this.state.itemsPerPage,
                                                                                        this.state.currentPage,
                                                                                        this.state.documentCount,
                                                                                        this.state.response
                                                                                    )
                                                                                    : ""}
                                                                            </>
                                                                        )}
                                                                        {this.state.error === "" ? (
                                                                            this.resultList(
                                                                                this.state.response,
                                                                                this.state.itemsPerPage,
                                                                                this.state.currentPage
                                                                            )
                                                                        ) : (
                                                                            <>
                                                                                {(() => {
                                                                                    let service = new Services();
                                                                                    service.logService(
                                                                                        this.state.error.stack,
                                                                                        "error"
                                                                                    );
                                                                                })()}

                                                                                <div style={{ margin: "2rem 2rem" }}>
                                                                                    <h2>Sorry, something went wrong</h2>

                                                                                    {this.state.errorExpand ? (
                                                                                        <p
                                                                                            style={{
                                                                                                backgroundColor: "#f8d4d4",
                                                                                                borderColor: "#f5a6a7",
                                                                                            }}
                                                                                        >
                                                                                            {this.createErrorHtml()}
                                                                                            {/* {JSON.stringify(
                                                                                                        this.state.error.response
                                                                                                          ? this.state.error.response.data
                                                                                                          : this.state.error.message
                                                                                                      )
                                                                                                        .replaceAll("{", "")
                                                                                                        .replaceAll("}", "")} */}
                                                                                        </p>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: "0.9rem",
                                                                                            marginTop: "30px",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            this.setState({
                                                                                                errorExpand:
                                                                                                    !this.state.errorExpand,
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {this.state.errorExpand
                                                                                            ? `SHOW LESS`
                                                                                            : `SHOW DETAILS`}
                                                                                    </p>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                        {this.state.error === "" ? (
                                                                            <Pagination
                                                                                metadata={this.state.documentCount}
                                                                                handlePageChange={this.handlePageChange}
                                                                                itemsPerPage={parseInt(
                                                                                    this.state.itemsPerPage
                                                                                )}
                                                                                page={parseInt(this.state.currentPage)}
                                                                                customWidth={this.state.width}
                                                                                customHeight={this.state.height}
                                                                            />
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </TabPanel>
                                                                    <TabPanel
                                                                        tabId="1"
                                                                        className="tabpanel-list-item-pubmed"
                                                                    >
                                                                        {this.state.error === "" &&
                                                                            this.state.abstractsResponse &&
                                                                            this.state.abstractsResponse.length >
                                                                            0 && (
                                                                                <PubMedRightGenAIAnswer
                                                                                    customWidth={this.state.width}
                                                                                    customHeight={this.state.height}
                                                                                    data={this.state.ovidAbstractAnswer}
                                                                                    selectedTab={this.state.selectedTab}
                                                                                    resultListRef={this.resultListRef}
                                                                                />

                                                                                // <PubMedRightGenAIAbstractsAnswer
                                                                                //     customWidth={this.state.width}
                                                                                //     customHeight={this.state.height}
                                                                                //     abstractsAnswer={
                                                                                //         this.state.abstractsAnswer
                                                                                //     }
                                                                                //     handleAbstract={this.handleAbstract}
                                                                                //     useTemplate={this.state.useTemplate}
                                                                                //     preSelectedValues={
                                                                                //         this.preSelectedValues
                                                                                //     }
                                                                                // />
                                                                            )}

                                                                        {this.state.error === "" &&
                                                                            this.state.abstractsResponse &&
                                                                            this.state.abstractsResponse.length >
                                                                            0 && (
                                                                                <PubMedGlobalFeatures
                                                                                    getAllReviewListData={this.getAllReviewListData}
                                                                                    customWidth={this.state.width}
                                                                                    customHeight={this.state.height}
                                                                                    selectedTab={selectedTab}
                                                                                    useTemplate={useTemplate}
                                                                                    pubMedXSearchId={
                                                                                        this.state.pubMedXSearchId
                                                                                    }
                                                                                    pubmedResponse={this.state.response.map(
                                                                                        (x) => x._source
                                                                                    )}
                                                                                    handelSelectedAbstract={
                                                                                        this.handelSelectedAbstract
                                                                                    }
                                                                                    handleCollapseAllGlobal={
                                                                                        this.handleAbstractCollapseAllGlobal
                                                                                    }
                                                                                    selectedResults={
                                                                                        this.state.selectedAbstractResults
                                                                                    }
                                                                                    globalCollapseAll={
                                                                                        this.state.globalAbstractCollapseAll
                                                                                    }
                                                                                    globalSelectAll={
                                                                                        this.state.globalAbstractSelectAll
                                                                                    }
                                                                                    handleSelectAll={
                                                                                        this.handleAbstractSelectAll
                                                                                    }
                                                                                    handleAbstractViewDetails={
                                                                                        this.handleAbstractViewDetails
                                                                                    }
                                                                                    openExportPopup={this.openExportPopup}
                                                                                    handleViewSaveSearch={this.handleViewSaveSearch}
                                                                                    handleRemoveSaveSearch={this.handleRemoveSaveSearch}
                                                                                    handleReviewNameTitle={this.handleReviewNameTitle}
                                                                                    handleRemoveReviewList={this.handleRemoveReviewList}
                                                                                />
                                                                            )}
                                                                        {useTemplate === "OVID" ? (
                                                                            <>
                                                                                {this.state.error === "" &&
                                                                                    this.state.ovidAbstractResponse &&
                                                                                    this.state.ovidAbstractResponse.length > 0 && (
                                                                                        <PubMedRightGenAIAnswer
                                                                                            customWidth={this.state.width}
                                                                                            customHeight={this.state.height}
                                                                                            data={this.state.ovidAbstractAnswer}
                                                                                            selectedTab={this.state.selectedTab}
                                                                                            resultListRef={this.resultListRef}
                                                                                        />
                                                                                    )}

                                                                                {this.state.error === "" &&
                                                                                    this.state.ovidAbstractResponse &&
                                                                                    this.state.ovidAbstractResponse.length > 0 && (
                                                                                        <PubMedGlobalFeatures
                                                                                            openExportPopup={this.openExportPopup}
                                                                                            getAllReviewListData={this.getAllReviewListData}
                                                                                            customWidth={this.state.width}
                                                                                            customHeight={this.state.height}
                                                                                            handelSelectedCitation={
                                                                                                this.getSelectedOvidAbstractCitationDetails
                                                                                            }
                                                                                            pubmedResponse={this.state.ovidAbstractResponse.map(
                                                                                                (x) => x._source
                                                                                            )}
                                                                                            pubMedXSearchId={
                                                                                                this.state.pubMedXSearchId
                                                                                            }
                                                                                            handleCollapseAllGlobal={
                                                                                                this.handleOvidAbstractCollapseAllGlobal
                                                                                            }
                                                                                            selectedTab={selectedTab}
                                                                                            useTemplate={useTemplate}
                                                                                            selectedResults={
                                                                                                this.state.selectedOvidAbstractResults
                                                                                            }
                                                                                            globalCollapseAll={
                                                                                                this.state.globalOvidAbstractCollapseAll
                                                                                            }
                                                                                            globalSelectAll={
                                                                                                this.state.globalOvidAbstractSelectAll
                                                                                            }
                                                                                            handleSelectAll={this.handleOvidAbstractSelectAll}
                                                                                            handleViewSaveSearch={this.handleViewSaveSearch}
                                                                                            handleRemoveSaveSearch={this.handleRemoveSaveSearch}
                                                                                            handleReviewNameTitle={this.handleReviewNameTitle}
                                                                                            handleRemoveReviewList={this.handleRemoveReviewList}
                                                                                        />
                                                                                    )}
                                                                                {this.state.appliedOvidAbstractFilters.length > 0 ? (
                                                                                    <FilterDisplay
                                                                                        allFilters={this.state.allOvidAbstractFilters}
                                                                                        appliedFilters={
                                                                                            this.state.appliedOvidAbstractFilters
                                                                                        }
                                                                                        handleClearFilters={
                                                                                            this.handleClearOvidAbstractFilters
                                                                                        }
                                                                                        handleRemoveAppliedFilter={
                                                                                            this.handleRemoveAppliedOvidAbstractFilter
                                                                                        }
                                                                                        customWidth={this.state.width}
                                                                                    />
                                                                                ) : null}

                                                                                {this.state.ovidAbstractResponse.length > 0 && (
                                                                                    <>
                                                                                        {this.state.error === ""
                                                                                            ? this.resultOvidAbstractListCount(
                                                                                                this.state.itemsPerOvidAbstractPage,
                                                                                                this.state.currentOvidAbstractPage,
                                                                                                this.state.documentOvidAbstractCount,
                                                                                                this.state.ovidAbstractResponse
                                                                                            )
                                                                                            : ""}
                                                                                    </>

                                                                                )}
                                                                                {this.state.error === "" ? (
                                                                                    this.resultOvidAbstractList(
                                                                                        this.state.ovidAbstractResponse,
                                                                                        this.state.itemsPerOvidAbstractPage,
                                                                                        this.state.currentOvidAbstractPage
                                                                                    )
                                                                                ) : (
                                                                                    <>
                                                                                        {(() => {
                                                                                            let service = new Services();
                                                                                            service.logService(
                                                                                                this.state.error.stack,
                                                                                                "error"
                                                                                            );
                                                                                        })()}

                                                                                        <div style={{ margin: "2rem 2rem" }}>
                                                                                            <h2>Sorry, something went wrong</h2>
                                                                                            <p
                                                                                                style={{
                                                                                                    fontSize: "0.9rem",
                                                                                                    marginTop: "30px",
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                                onClick={() => {
                                                                                                    this.setState({
                                                                                                        errorExpand:
                                                                                                            !this.state.errorExpand,
                                                                                                    });
                                                                                                }}
                                                                                            >
                                                                                                {this.state.errorExpand
                                                                                                    ? `SHOW LESS`
                                                                                                    : `SHOW DETAILS`}
                                                                                            </p>
                                                                                            {this.state.errorExpand ? (
                                                                                                <p
                                                                                                    style={{
                                                                                                        backgroundColor: "#f8d4d4",
                                                                                                        borderColor: "#f5a6a7",
                                                                                                    }}
                                                                                                >
                                                                                                    {this.createErrorHtml()}
                                                                                                    {/* {JSON.stringify(
                                                                                                                this.state.error.response
                                                                                                                  ? this.state.error.response.data
                                                                                                                  : this.state.error.message
                                                                                                              )
                                                                                                                .replaceAll("{", "")
                                                                                                                .replaceAll("}", "")} */}
                                                                                                </p>
                                                                                            ) : (
                                                                                                ""
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                                {this.state.error === "" ? (
                                                                                    <Pagination
                                                                                        metadata={this.state.documentOvidAbstractCount}
                                                                                        handlePageChange={this.handleOvidAbstractPageChange}
                                                                                        itemsPerPage={parseInt(
                                                                                            this.state.itemsPerOvidAbstractPage
                                                                                        )}
                                                                                        page={parseInt(this.state.currentOvidAbstractPage)}
                                                                                        customWidth={this.state.width}
                                                                                        customHeight={this.state.height}
                                                                                    />
                                                                                ) : (
                                                                                    ""
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {this.state.abstractsResponse &&
                                                                                    this.state.abstractsResponse.length >
                                                                                    0 ? <>

                                                                                    {this.resultOvidAbstractListCount(
                                                                                        this.state.itemsPerOvidAbstractPage,
                                                                                        this.state.currentOvidAbstractPage,
                                                                                        this.state.documentOvidAbstractCount,
                                                                                        this.state.abstractsResponse
                                                                                    )}
                                                                                    <div className="relevant-non-relevant-filter-container">
                                                                                        <PubMedSearchResponsiveTabs selectedTabResponsive={this.state.selectTabResOtherUploadAbstract} isCheckButtonActive={this.state.isOvidAbstractReleventSelected} selectedTab={this.state.selectedTab} isTabForId={'11'} handleOnTabClickresponsive={this.handleOnTabClickUploadAbstracts} width={this.state.width} />
                                                                                    </div>
                                                                                    <PubMedRightAbstractsDataCard
                                                                                        customWidth={this.state.width}
                                                                                        customHeight={this.state.height}
                                                                                        abstractsResponse={
                                                                                            this.state.abstractsResponse
                                                                                        }
                                                                                        abstractsSelected={
                                                                                            this.state.abstractsSelected
                                                                                        }
                                                                                        handleSelectAll={
                                                                                            this.handleAbstractSelectAll
                                                                                        }
                                                                                        handleAbstractSelect={
                                                                                            this.handleAbstractSelect
                                                                                        }
                                                                                        handleAbstract={
                                                                                            this.handleAbstract
                                                                                        }
                                                                                        preSelectedValues={
                                                                                            this.preSelectedValues
                                                                                        }
                                                                                        useTemplate={useTemplate}
                                                                                    />

                                                                                    <Pagination
                                                                                        metadata={this.state.documentOvidAbstractCount}
                                                                                        handlePageChange={this.handleOvidAbstractPageChange}
                                                                                        itemsPerPage={parseInt(
                                                                                            this.state.itemsPerOvidAbstractPage
                                                                                        )}
                                                                                        page={parseInt(this.state.currentOvidAbstractPage)}
                                                                                        customWidth={this.state.width}
                                                                                        customHeight={this.state.height}
                                                                                    />
                                                                                </> : (
                                                                                    <div className="results-no-search-content pubmed-results-no-search-content">
                                                                                        <span>
                                                                                            Nothing here matches your search
                                                                                        </span>
                                                                                        <br />
                                                                                        <br />
                                                                                        <span>Suggestions</span>
                                                                                        <li>
                                                                                            <b>Upload document</b>
                                                                                        </li>
                                                                                        <li>
                                                                                            Make sure all words are spelled
                                                                                            correctly
                                                                                        </li>
                                                                                        <li>Try different search terms</li>
                                                                                        <li>
                                                                                            Try more general search terms
                                                                                        </li>
                                                                                        <li>Try fewer search terms</li>
                                                                                    </div>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </TabPanel>
                                                                    <TabPanel
                                                                        tabId="2"
                                                                        className="tabpanel-list-item-pubmed"
                                                                    >
                                                                        {(this.state.titleNameReviewList) && <div className="pub-med-review-title">Review List: {this.state.titleNameReviewList}</div>}
                                                                        {this.state.error === "" &&
                                                                            this.state.reviewListResponse &&
                                                                            this.state.reviewListResponse.length > 0 && (
                                                                                <PubMedRightGenAIAnswer
                                                                                    customWidth={this.state.width}
                                                                                    customHeight={this.state.height}
                                                                                    data={this.state.reviewListAnswers}
                                                                                    selectedTab={this.state.selectedTab}
                                                                                    resultListRef={this.resultListRef}
                                                                                />
                                                                            )}

                                                                        {this.state.error === "" &&
                                                                            this.state.reviewListResponse &&
                                                                            this.state.reviewListResponse.length > 0 && (
                                                                                <PubMedGlobalFeatures
                                                                                    openExportPopup={this.openExportPopup}
                                                                                    customWidth={this.state.width}
                                                                                    customHeight={this.state.height}
                                                                                    handelSelectedCitation={
                                                                                        this.getSelectedReviewListCitationDetails
                                                                                    }
                                                                                    getAllReviewListData={this.getAllReviewListData}
                                                                                    pubmedResponse={this.state.reviewListResponse.map(
                                                                                        (x) => x._source
                                                                                    )}
                                                                                    // pubMedXSearchId={
                                                                                    //     this.state.pubMedXSearchId
                                                                                    // }
                                                                                    handleCollapseAllGlobal={
                                                                                        this.handleReviewListCollapseAllGlobal
                                                                                    }
                                                                                    selectedTab={selectedTab}
                                                                                    useTemplate={useTemplate}
                                                                                    selectedResults={
                                                                                        this.state.selectedReviewListResults
                                                                                    }
                                                                                    globalCollapseAll={
                                                                                        this.state.globalReviewListCollapseAll
                                                                                    }
                                                                                    globalSelectAll={
                                                                                        this.state.globalReviewListSelectAll
                                                                                    }
                                                                                    handleSelectAll={this.handleReviewListSelectAll}
                                                                                    handleViewSaveSearch={this.handleViewSaveSearch}
                                                                                    handleRemoveSaveSearch={this.handleRemoveSaveSearch}
                                                                                    handleReviewNameTitle={this.handleReviewNameTitle}
                                                                                    handleRemoveReviewList={this.handleRemoveReviewList}
                                                                                />

                                                                            )}
                                                                        {this.state.appliedReviewListFilters.length > 0 ? (
                                                                            <FilterDisplay
                                                                                allFilters={this.state.allReviewListFilters}
                                                                                appliedFilters={
                                                                                    this.state.appliedReviewListFilters
                                                                                }
                                                                                handleClearFilters={
                                                                                    this.handleClearReviewListFilters
                                                                                }
                                                                                handleRemoveAppliedFilter={
                                                                                    this.handleRemoveAppliedReviewListFilter
                                                                                }
                                                                                customWidth={this.state.width}
                                                                            />
                                                                        ) : null}

                                                                        {this.state.reviewListResponse.length > 0 && (
                                                                            <>
                                                                                {this.state.error === ""
                                                                                    ? this.resultReviewListCount(
                                                                                        this.state.itemsPerReviewListPage,
                                                                                        this.state.currentReviewListPage,
                                                                                        this.state.documentReviewListCount,
                                                                                        this.state.reviewListResponse
                                                                                    )
                                                                                    : ""}
                                                                            </>

                                                                        )}
                                                                        {this.state.error === "" ? (
                                                                            this.resultReviewList(
                                                                                this.state.reviewListResponse,
                                                                                this.state.itemsPerReviewListPage,
                                                                                this.state.currentReviewListPage
                                                                            )
                                                                        ) : (
                                                                            <>
                                                                                {(() => {
                                                                                    let service = new Services();
                                                                                    service.logService(
                                                                                        this.state.error.stack,
                                                                                        "error"
                                                                                    );
                                                                                })()}

                                                                                <div style={{ margin: "2rem 2rem" }}>
                                                                                    <h2>Sorry, something went wrong</h2>
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: "0.9rem",
                                                                                            marginTop: "30px",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            this.setState({
                                                                                                errorExpand:
                                                                                                    !this.state.errorExpand,
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {this.state.errorExpand
                                                                                            ? `SHOW LESS`
                                                                                            : `SHOW DETAILS`}
                                                                                    </p>
                                                                                    {this.state.errorExpand ? (
                                                                                        <p
                                                                                            style={{
                                                                                                backgroundColor: "#f8d4d4",
                                                                                                borderColor: "#f5a6a7",
                                                                                            }}
                                                                                        >
                                                                                            {this.createErrorHtml()}
                                                                                            {/* {JSON.stringify(
                                                                                                        this.state.error.response
                                                                                                          ? this.state.error.response.data
                                                                                                          : this.state.error.message
                                                                                                      )
                                                                                                        .replaceAll("{", "")
                                                                                                        .replaceAll("}", "")} */}
                                                                                        </p>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                        {this.state.error === "" ? (
                                                                            <Pagination
                                                                                metadata={this.state.documentReviewListCount}
                                                                                handlePageChange={this.handleReviewListPageChange}
                                                                                itemsPerPage={parseInt(
                                                                                    this.state.itemsPerReviewListPage
                                                                                )}
                                                                                page={parseInt(this.state.currentReviewListPage)}
                                                                                customWidth={this.state.width}
                                                                                customHeight={this.state.height}
                                                                            />
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </TabPanel>
                                                                    <TabPanel
                                                                        tabId="3"
                                                                        className="tabpanel-list-item-pubmed">
                                                                        {(this.state.titleSaveSearch) && <div className="pub-med-review-title">Save Search List: {this.state.titleSaveSearch}</div>}
                                                                        {this.state.error === "" &&
                                                                            this.state.saveSearchResponse &&
                                                                            this.state.saveSearchResponse.length > 0 && (
                                                                                <PubMedRightGenAIAnswer
                                                                                    customWidth={this.state.width}
                                                                                    customHeight={this.state.height}
                                                                                    data={this.state.saveSearchAnswer}
                                                                                    selectedTab={this.state.selectedTab}
                                                                                    resultListRef={this.resultListRef}
                                                                                />
                                                                            )}

                                                                        {this.state.error === "" &&
                                                                            this.state.saveSearchResponse &&
                                                                            this.state.saveSearchResponse.length > 0 && (
                                                                                <PubMedGlobalFeatures
                                                                                    openExportPopup={this.openExportPopup}
                                                                                    getAllReviewListData={this.getAllReviewListData}
                                                                                    customWidth={this.state.width}
                                                                                    customHeight={this.state.height}
                                                                                    handelSelectedCitation={
                                                                                        this.getSelectedSaveSearchCitationDetails
                                                                                    }
                                                                                    pubmedResponse={this.state.saveSearchResponse.map(
                                                                                        (x) => x._source
                                                                                    )}
                                                                                    pubMedXSearchId={
                                                                                        this.state.pubMedXSearchId
                                                                                    }
                                                                                    handleCollapseAllGlobal={
                                                                                        this.handleSaveSearchCollapseAllGlobal
                                                                                    }
                                                                                    selectedTab={selectedTab}
                                                                                    useTemplate={useTemplate}
                                                                                    selectedResults={
                                                                                        this.state.selectedSaveSearchResults
                                                                                    }
                                                                                    globalCollapseAll={
                                                                                        this.state.globalSaveSearchCollapseAll
                                                                                    }
                                                                                    globalSelectAll={
                                                                                        this.state.globalSaveSearchSelectAll
                                                                                    }
                                                                                    handleSelectAll={this.handleSaveSearchSelectAll}
                                                                                    handleViewSaveSearch={this.handleViewSaveSearch}
                                                                                    handleRemoveSaveSearch={this.handleRemoveSaveSearch}
                                                                                    handleReviewNameTitle={this.handleReviewNameTitle}
                                                                                    handleRemoveReviewList={this.handleRemoveReviewList}
                                                                                />
                                                                            )}
                                                                        {this.state.appliedSaveSearchFilters.length > 0 ? (
                                                                            <FilterDisplay
                                                                                allFilters={this.state.allSaveSearchFilters}
                                                                                appliedFilters={
                                                                                    this.state.appliedSaveSearchFilters
                                                                                }
                                                                                handleClearFilters={
                                                                                    this.handleClearSaveSearchFilters
                                                                                }
                                                                                handleRemoveAppliedFilter={
                                                                                    this.handleRemoveAppliedSaveSearchFilter
                                                                                }
                                                                                customWidth={this.state.width}
                                                                            />
                                                                        ) : null}

                                                                        {this.state.saveSearchResponse.length > 0 && (
                                                                            <>
                                                                                {this.state.error === ""
                                                                                    ? this.resultSaveSearchListCount(
                                                                                        this.state.itemsPerSaveSearchPage,
                                                                                        this.state.currentSaveSearchPage,
                                                                                        this.state.documentSaveSearchCount,
                                                                                        this.state.saveSearchResponse
                                                                                    )
                                                                                    : ""}
                                                                            </>

                                                                        )}
                                                                        {this.state.error === "" ? (
                                                                            this.resultSaveSearchList(
                                                                                this.state.saveSearchResponse,
                                                                                this.state.itemsPerSaveSearchPage,
                                                                                this.state.currentSaveSearchPage
                                                                            )
                                                                        ) : (
                                                                            <>
                                                                                {(() => {
                                                                                    let service = new Services();
                                                                                    service.logService(
                                                                                        this.state.error.stack,
                                                                                        "error"
                                                                                    );
                                                                                })()}

                                                                                <div style={{ margin: "2rem 2rem" }}>
                                                                                    <h2>Sorry, something went wrong</h2>
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: "0.9rem",
                                                                                            marginTop: "30px",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            this.setState({
                                                                                                errorExpand:
                                                                                                    !this.state.errorExpand,
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {this.state.errorExpand
                                                                                            ? `SHOW LESS`
                                                                                            : `SHOW DETAILS`}
                                                                                    </p>
                                                                                    {this.state.errorExpand ? (
                                                                                        <p
                                                                                            style={{
                                                                                                backgroundColor: "#f8d4d4",
                                                                                                borderColor: "#f5a6a7",
                                                                                            }}
                                                                                        >
                                                                                            {this.createErrorHtml()}
                                                                                            {/* {JSON.stringify(
                                                                                                        this.state.error.response
                                                                                                          ? this.state.error.response.data
                                                                                                          : this.state.error.message
                                                                                                      )
                                                                                                        .replaceAll("{", "")
                                                                                                        .replaceAll("}", "")} */}
                                                                                        </p>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                        {this.state.error === "" ? (
                                                                            <Pagination
                                                                                metadata={this.state.documentSaveSearchCount}
                                                                                handlePageChange={this.handleSaveSearchPageChange}
                                                                                itemsPerPage={parseInt(
                                                                                    this.state.itemsPerSaveSearchPage
                                                                                )}
                                                                                page={parseInt(this.state.currentSaveSearchPage)}
                                                                                customWidth={this.state.width}
                                                                                customHeight={this.state.height}
                                                                            />
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </TabPanel>
                                                                    <TabPanel
                                                                        tabId="4"
                                                                        className="tabpanel-list-item-pubmed">
                                                                        {(this.state.selectedAlert.search_name) && <div className="">
                                                                            {/* <div className="alert-myalert" style={{ textAlign: 'left', padding: "5px" }}>My Alerts</div>
                                                                            <div className="alert-title">{this.state.selectedAlert.search_name}</div> */}
                                                                            <PubMedAlertTableQuery
                                                                                selectedAlert={this.state.selectedAlert} />
                                                                            {<div className="sort-by-wrapper" style={{ border: "none", justifyContent: 'end' }}><div className="sort-by-wrapper br-black">
                                                                                <span className="sort-by-text" style={{ color: 'black', fontSize: '12px' }}>View:</span>
                                                                                <select
                                                                                    className="sort-by-select-wrapper br-black"
                                                                                    onChange={(e) => {
                                                                                        //this.setState({selectedAlert: e.target.value});
                                                                                        this.handleAlertFrequency(e.target.value)
                                                                                    }}>
                                                                                    <option value='7'>Last Week</option>
                                                                                    <option value='30'>Last 30 Days</option>
                                                                                    <option value='60'>Last 60 Days</option>
                                                                                    {/* <option value='All'>All</option> */}
                                                                                </select>
                                                                            </div></div>}
                                                                            {/*<div className="my-alert-dropdown-container">
                                                                                <select className="my-alert-drop-down-value" value={this.state.alertsFrequencySelected} onChange={this.handleAlertFrequencyFilter}>
                                                                                    <option value='Last Week'>Last Week</option>
                                                                                    <option value='Last 30 Days'>Last 30 Days</option>
                                                                                    <option value='Last 30 Days'>Last 60 Days</option>
                                                                                    <option value='All'>All</option>
                                                                                </select>
                                                                            </div>*/}
                                                                        </div>}
                                                                        {/* {this.state.error === "" &&
                                                                            this.state.alertResponses.length > 0 && (
                                                                                <PubMedGlobalFeatures
                                                                                    openExportPopup={this.openExportPopup}
                                                                                    getAllReviewListData={this.getAllReviewListData}
                                                                                    customWidth={this.state.width}
                                                                                    customHeight={this.state.height}
                                                                                    handelSelectedCitation={
                                                                                        this.getSelectedSaveSearchCitationDetails
                                                                                    }
                                                                                    pubmedResponse={this.state.alertResponses.map(
                                                                                        (x) => x._source
                                                                                    )}
                                                                                    pubMedXSearchId={
                                                                                        this.state.pubMedXSearchId
                                                                                    }
                                                                                    handleCollapseAllGlobal={this.handleAlertCollapseAllGlobal}
                                                                                    selectedTab={selectedTab}
                                                                                    useTemplate={useTemplate}
                                                                                    selectedResults={
                                                                                        this.state.selectedAlertResults
                                                                                    }
                                                                                    globalCollapseAll={
                                                                                        this.state.globalAlertCollapseAll
                                                                                    }
                                                                                    globalSelectAll={
                                                                                        this.state.globalAlertSelectAll
                                                                                    }
                                                                                    handleSelectAll={this.handleAlertSelectAll}
                                                                                    handleViewSaveSearch={this.handleViewSaveSearch}
                                                                                    handleRemoveSaveSearch={this.handleRemoveSaveSearch}
                                                                                    handleReviewNameTitle={this.handleReviewNameTitle}
                                                                                    handleRemoveReviewList={this.handleRemoveReviewList}
                                                                                    handleAlertFrequency={this.handleAlertFrequency}
                                                                                />
                                                                            )} */}
                                                                        {/* {this.state.appliedSaveSearchFilters.length > 0 ? (
                                                                            <FilterDisplay
                                                                                allFilters={''}
                                                                                appliedFilters={''}
                                                                                handleClearFilters={
                                                                                    () => { }
                                                                                }
                                                                                handleRemoveAppliedFilter={
                                                                                    () => { }
                                                                                }
                                                                                customWidth={this.state.width}
                                                                            />
                                                                        ) : null} */}

                                                                        {/* {this.state.alertResponses.length > 0 && (
                                                                            <>
                                                                                {this.state.error === ""
                                                                                    ? this.resultAlertListCount(
                                                                                        this.state.itemsPerAlertPage,
                                                                                        this.state.currentAlertPage,
                                                                                        this.state.documentAlertCount,
                                                                                        this.state.alertResponses
                                                                                    )
                                                                                    : ""}
                                                                            </>

                                                                        )} */}
                                                                        {this.state.error === "" ? (
                                                                            this.resultAlertList(
                                                                                this.state.alertResponses,
                                                                                this.state.itemsPerAlertPage,
                                                                                this.state.currentAlertPage
                                                                            )
                                                                        ) : (
                                                                            <>
                                                                                {(() => {
                                                                                    let service = new Services();
                                                                                    service.logService(
                                                                                        this.state.error.stack,
                                                                                        "error"
                                                                                    );
                                                                                })()}

                                                                                <div style={{ margin: "2rem 2rem" }}>
                                                                                    <h2>Sorry, something went wrong</h2>
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: "0.9rem",
                                                                                            marginTop: "30px",
                                                                                            cursor: "pointer",
                                                                                        }}
                                                                                        onClick={() => {
                                                                                            this.setState({
                                                                                                errorExpand:
                                                                                                    !this.state.errorExpand,
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        {this.state.errorExpand
                                                                                            ? `SHOW LESS`
                                                                                            : `SHOW DETAILS`}
                                                                                    </p>
                                                                                    {this.state.errorExpand ? (
                                                                                        <p
                                                                                            style={{
                                                                                                backgroundColor: "#f8d4d4",
                                                                                                borderColor: "#f5a6a7",
                                                                                            }}
                                                                                        >
                                                                                            {this.createErrorHtml()}
                                                                                            {/* {JSON.stringify(
                                                                                                        this.state.error.response
                                                                                                          ? this.state.error.response.data
                                                                                                          : this.state.error.message
                                                                                                      )
                                                                                                        .replaceAll("{", "")
                                                                                                        .replaceAll("}", "")} */}
                                                                                        </p>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                </div>
                                                                            </>
                                                                        )}


                                                                        {/* {this.state.error === "" ? (
                                                                            <Pagination
                                                                                metadata={this.state.documentAlertCount}
                                                                                handlePageChange={this.handleAlertPageChange}
                                                                                itemsPerPage={parseInt(
                                                                                    this.state.itemsPerAlertPage
                                                                                )}
                                                                                page={parseInt(this.state.currentAlertPage)}
                                                                                customWidth={this.state.width}
                                                                                customHeight={this.state.height}
                                                                            />
                                                                        ) : (
                                                                            ""
                                                                        )} */}
                                                                    </TabPanel>
                                                                </Tabs>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                {this.state.isProcessing && (
                                                    <Modal
                                                        show={this.state.isProcessing}
                                                        size="lg md sm xs"
                                                        centered
                                                        aria-labelledby="contained-modal-title-vcenter"
                                                        dialogClassName="savePopUp"
                                                        className="document-processing-newthread"
                                                        backdropClassName="document-processing-newthread-backdrop"
                                                        scrollable={true}
                                                    >
                                                        <div style={{ padding: "0 5%" }}>
                                                            <div
                                                                style={{
                                                                    fontSize: "14px",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                <Modal.Body>
                                                                    <img
                                                                        src={imsLoader}
                                                                        alt=""
                                                                        width={100}
                                                                        height={100}
                                                                    />
                                                                    <div
                                                                        className="saveModal-heading"
                                                                        style={{ color: "#EB1700" }}
                                                                    >
                                                                        {this.state.spinnerMessage ? this.state.spinnerMessage : `Please wait while generating results.`}
                                                                    </div>
                                                                </Modal.Body>
                                                            </div>
                                                        </div>
                                                    </Modal>
                                                )}
                                            </>
                                        ) : (
                                            <div style={{ textAlign: "center", padding: "10%" }}>
                                                <img
                                                    src={imsLoader}
                                                    alt="Loading Data"
                                                    style={{ width: "10%" }}
                                                />
                                                <div style={{ color: "#EB1700" }} className="saveModal-heading">
                                                    <b>Please wait while generating results.</b>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>{" "}
                                <div style={{ margin: "0% 1%" }}>
                                    <Footer
                                        customWidth={this.state.width}
                                        customHeight={this.state.height}
                                    />
                                </div>{" "}
                            </>
                        ) : (
                            <div style={{ textAlign: "center", padding: "10%" }}>
                                <img
                                    src={imsLoader}
                                    alt="Loading Data"
                                    style={{ width: "20%" }}
                                />
                            </div>
                        )}
                        {
                            this.state.showReviewListPop &&
                            <PubMedReviewListPopup
                                getAllReviewListData={this.getAllReviewListData}
                                selectedTab={this.state.selectedTab}
                                useTemplate={this.state.useTemplate}
                                showModal={this.state.showReviewListPop}
                                handleClose={this.handleCloseReviewList}
                                width={this.state.customWidth}
                                selectedResults={[]}
                                handleReviewNameTitle={this.handleReviewNameTitle}
                                handleRemoveReviewList={this.handleRemoveReviewList}
                            />
                        }
                        {
                            this.state.showSaveSearchPop &&
                            <PubMedSaveSearchPopup
                                selectedTab={this.state.selectedTab}
                                useTemplate={this.state.useTemplate}
                                handleViewSaveSearch={this.handleViewSaveSearch}
                                showModal={this.state.showSaveSearchPop}
                                handleClose={this.handleCloseSaveSearch}
                                width={this.props.customWidth}
                                selectedResults={[]}
                                pubMedXSearchId={''}
                                handleRemoveSaveSearch={this.handleRemoveSaveSearch} />
                        }

                        {alertMessageShowModal && (
                            <AlertMessagePopUpModal
                                color={alertMessageModelColor}
                                content={alertMessageContent}
                                showModal={alertMessageShowModal}
                                handleClose={() => this.closeAlertMessage()}
                            />
                        )}

                        {this.state.showPersonalAlerts &&
                            <PubMedNotifyMePopUp
                                fromGlobalTab={this.state.fromGlobalTab}
                                showPersonalAlerts={this.state.showPersonalAlerts}
                                handleMyAlert={this.handleMyAlert}
                                handleClose={() => this.setState({ showPersonalAlerts: false, fromGlobalTab: false })}
                                customWidth={this.props.customWidth}
                                openManageInPubmedAlert={this.state.openManageInPubmedAlert}
                            />
                        }
                        {this.state.showExportPopup &&
                            <PubmedExportPopUp
                                showModal={this.state.showExportPopup}
                                handleClose={() => this.setState({ showExportPopup: false })}
                                allResults={this.handleExportData()}
                                selectedResults={this.handleSelectedExportData()}
                                itemsPerPage={this.handleExportDataLength()}
                                selectedTab={this.state.selectedTab}
                                useTemplate={this.state.useTemplate}
                            />
                        }
                        {this.state.showViewabstractDetailPop && (
                            <Modal
                                show={this.state.showViewabstractDetailPop}
                                size="lg md"
                                //size="md"
                                centered
                                aria-labelledby="contained-modal-title-vcenter"
                                dialogClassName="popup-transition"
                                scrollable={true}
                            >
                                <div
                                    style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}
                                >
                                    <div className="popup-cancel-btn-wrapper">
                                        <img
                                            src={popCancelBttn}
                                            alt=""
                                            onClick={(e) => {
                                                this.setState({ showViewabstractDetailPop: false });
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <Modal.Header
                                            className="gsfModalHeader"
                                            style={{ justifyContent: "left" }}
                                        >
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    width: "70%",
                                                    paddingTop: "1%",
                                                }}
                                            >
                                                <Modal.Title>
                                                    <div className="upload-abstracts-actionItem-headerPart">
                                                        <div className={"alert-active-features-button"}>
                                                            <span>View Details</span>
                                                        </div>
                                                    </div>
                                                </Modal.Title>
                                            </div>
                                        </Modal.Header>
                                        <Modal.Body
                                            scrollable={true}
                                            style={{ maxHeight: "50vh", padding: " 1rem 3rem" }}
                                        >
                                            <div className="upload-abstracts-main">
                                                {this.renderViewDetails()}
                                            </div>
                                        </Modal.Body>
                                        <div className="pubmed-upload-abstracts-close-button-wrapper">
                                            <Button
                                                text="Close"
                                                customColor="#0074B0"
                                                action={() => {
                                                    this.setState({ showViewabstractDetailPop: false });
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        )}
                    </ErrorBoundary>
                </div>
            );
        } else {
            return <></>;
        }
    }
}
export default withRouter(PubMedSearch);
